(function(){
  const SHOPIFY_VARIANT_MAP = {
    // Aufkleber Oval
    oval_normal_1:    56838100124035,
    oval_normal_5:    56838100156803,
    oval_normal_10:   56838100189571,
    oval_normal_30:   56838100222339,
    oval_normal_50:   56838100255107,
    oval_normal_100:  56838114312579,
    oval_normal_250:  56838114443651,
    oval_normal_500:  56838114574723,
    oval_normal_1000: 56838114705795,
    oval_normal_1500: 56838114836867,
    oval_normal_2500: 56838114967939,
    oval_normal_5000: 56838115099011,
	oval_normal_6000: 57971803652483,
    // Aufkleber Oval Mini
    oval_mini_1:    56838113821059,
    oval_mini_5:    56838113919363,
    oval_mini_10:   56838114017667,
    oval_mini_30:   56838114115971,
    oval_mini_50:   56838114214275,
    oval_mini_100:  56838114345347,
    oval_mini_250:  56838114476419,
    oval_mini_500:  56838114607491,
    oval_mini_1000: 56838114738563,
    oval_mini_1500: 56838114869635,
    oval_mini_2500: 56838115000707,
    oval_mini_5000: 56838115131779,
	oval_mini_6000: 57971803685251,
    // Aufkleber Rechteckig
    rect_normal_1:    56838113853827,
    rect_normal_5:    56838113952131,
    rect_normal_10:   56838114050435,
    rect_normal_30:   56838114148739,
    rect_normal_50:   56838114247043,
    rect_normal_100:  56838114378115,
    rect_normal_250:  56838114509187,
    rect_normal_500:  56838114640259,
    rect_normal_1000: 56838114771331,
    rect_normal_1500: 56838114902403,
    rect_normal_2500: 56838115033475,
    rect_normal_5000: 56838115164547,
	rect_normal_6000: 57971803718019,
    // Aufkleber Rechteckig Mini
    rect_mini_1:    56838113886595,
    rect_mini_5:    56838113984899,
    rect_mini_10:   56838114083203,
    rect_mini_30:   56838114181507,
    rect_mini_50:   56838114279811,
    rect_mini_100:  56838114410883,
    rect_mini_250:  56838114541955,
    rect_mini_500:  56838114673027,
    rect_mini_1000: 56838114804099,
    rect_mini_1500: 56838114935171,
    rect_mini_2500: 56838115066243,
    rect_mini_5000: 56838115197315,
	rect_mini_6000: 57971803750787,
    // Bierdeckel
    beerdeckel_1:   56876594856323,
    beerdeckel_5:   56876232737155,
    beerdeckel_10:  56876232769923,
    beerdeckel_25:  56876232802691,
    beerdeckel_50:  56876232835459,
    beerdeckel_100: 56876232868227,     
    beerdeckel_250: 56876594889091,
    beerdeckel_500: 56876594921859,
    beerdeckel_1000: 56876594954627,
    beerdeckel_1500: 56876594987395,
    beerdeckel_2500: 56876595020163,
    beerdeckel_5000: 56876595052931,
    // Hoodies weiß
    hoodie_white_s:   56878195376515,
    hoodie_white_m:   56878195409283,
    hoodie_white_l:   56878195442051,
    hoodie_white_xl:  56878195474819,
    hoodie_white_xxl: 56878195507587,
    // Hoodies schwarz
    hoodie_black_s:   56878195212675,
    hoodie_black_m:   56878195245443,
    hoodie_black_l:   56878195278211,
    hoodie_black_xl:  56878195310979,
    hoodie_black_xxl: 56878195343747,
    // Fahnen
    flag_100x58: 56877972423043,
    flag_150x86: 56877972455811,
    flag_200x115: 56877972488579,
    flag_300x173: 56877972521347,
    // T-Shirts weiß
    tshirt_white_s:   56846716141955,
    tshirt_white_m:   56846716174723,
    tshirt_white_l:   56846716207491,
    tshirt_white_xl:  56846716240259,
    tshirt_white_xxl: 56846716273027,
    tshirt_white_xxxl:57450697818499,
    // T-Shirts schwarz
    tshirt_black_s:   56846716305795,
    tshirt_black_m:   56846716338563,
    tshirt_black_l:   56846716371331,
    tshirt_black_xl:  56846716404099,
    tshirt_black_xxl: 56846716436867,
    tshirt_black_xxxl:57450697851267,
    // Tassen
	    mug_ceramic: 56846452949379,
	    mug_enamel:  56846452982147
	  };

	  const B2B_BUNDLE_CONFIG = {
	    office: {
	      title: 'Büro-Paket',
	      tiers: {
	        starter: { label: 'Starter', priceCents: 13900, compareAtCents: 15193, stickers: 100, mugs: 6, variants: { oval: 62059572167043, rect: 62059572199811 } },
	        team: { label: 'Team', priceCents: 26900, compareAtCents: 29387, stickers: 250, mugs: 12, variants: { oval: 62059572232579, rect: 62059572265347 } },
	        gross: { label: 'Groß', priceCents: 47900, compareAtCents: 52775, stickers: 500, mugs: 24, variants: { oval: 62059572298115, rect: 62059572330883 } }
	      }
	    },
	    team: {
	      title: 'Team-Paket',
	      tiers: {
	        starter: { label: 'Starter', priceCents: 26900, compareAtCents: 29989, stickers: 250, shirts: 5, mugs: 5, variants: { oval: 62059572396419, rect: 62059572429187 } },
	        team: { label: 'Team', priceCents: 48900, compareAtCents: 53979, stickers: 500, shirts: 10, mugs: 10, variants: { oval: 62059572461955, rect: 62059572494723 } },
	        gross: { label: 'Groß', priceCents: 93900, compareAtCents: 103959, stickers: 1000, shirts: 20, mugs: 20, variants: { oval: 62059572527491, rect: 62059572560259 } }
	      }
	    },
	    visibility: {
	      title: 'Sichtbarkeits-Paket',
	      tiers: {
	        starter: { label: 'Starter', priceCents: 39900, compareAtCents: 44487, stickers: 250, mini: 250, shirts: 5, mugs: 5, flags: 1, variants: { oval: 62059572625795, rect: 62059572658563 } },
	        business: { label: 'Business', priceCents: 72900, compareAtCents: 80976, stickers: 500, mini: 500, shirts: 10, mugs: 10, flags: 2, variants: { oval: 62059572691331, rect: 62059572724099 } },
	        kampagne: { label: 'Kampagne', priceCents: 137900, compareAtCents: 152954, stickers: 1000, mini: 1000, shirts: 20, mugs: 20, flags: 4, variants: { oval: 62059572756867, rect: 62059572789635 } }
	      }
	    }
	  };

	  function readB2bBundlePreset() {
	    try {
	      const params = new URLSearchParams(window.location.search || '');
	      const key = String(params.get('b2b') || '').trim().toLowerCase();
	      const bundle = B2B_BUNDLE_CONFIG[key];
	      if (!bundle) return null;
	      const tierKey = String(params.get('tier') || 'starter').trim().toLowerCase();
	      const tier = bundle.tiers[tierKey] || bundle.tiers.starter || Object.values(bundle.tiers)[0];
	      const resolvedTierKey = Object.keys(bundle.tiers).find((candidate) => bundle.tiers[candidate] === tier) || 'starter';
	      const shape = String(params.get('shape') || 'oval').toLowerCase() === 'rect' ? 'rect' : 'oval';
	      return { key, title: bundle.title, tierKey: resolvedTierKey, tier, shape };
	    } catch (_) {
	      return null;
	    }
	  }

	  let B2B_PRESET = readB2bBundlePreset();
	  window.__nhB2bBundlePreset = B2B_PRESET;
	  const B2B_SELECTIONS = [];
	  let b2bSelectionSequence = 0;
	  window.__nhB2bSelections = B2B_SELECTIONS;

	  const STICKER_VARIANT_KEYS = Object.keys(SHOPIFY_VARIANT_MAP).filter(key => key.startsWith('oval_') || key.startsWith('rect_'));
	  const BEERDECKEL_VARIANT_KEYS = Object.keys(SHOPIFY_VARIANT_MAP).filter(key => key.startsWith('beerdeckel_'));
	  const FLAG_VARIANT_KEYS = Object.keys(SHOPIFY_VARIANT_MAP).filter(key => key.startsWith('flag_'));
	  const FLAG_SIZE_LABELS = {
	    '100x58': '100 × 58 cm',
	    '150x86': '150 × 86,5 cm',
	    '200x115': '200 × 115,5 cm',
	    '300x173': '300 × 173,4 cm'
	  };
	  const flagSizeLabel = size => FLAG_SIZE_LABELS[size] || (String(size || '').includes('x') ? String(size).replace('x', ' × ') + ' cm' : String(size || ''));
	  const TSHIRT_VARIANT_KEYS = Object.keys(SHOPIFY_VARIANT_MAP).filter(key => key.startsWith('tshirt_'));
	  const HOODIE_VARIANT_KEYS = Object.keys(SHOPIFY_VARIANT_MAP).filter(key => key.startsWith('hoodie_'));
	  const MUG_VARIANT_KEYS = Object.keys(SHOPIFY_VARIANT_MAP).filter(key => key.startsWith('mug_'));
	  const VARIANT_ID_TO_KEY = new Map();
	  Object.entries(SHOPIFY_VARIANT_MAP).forEach(([key, value]) => {
	    const id = Number(value);
	    if (!Number.isFinite(id) || id <= 0) return;
	    if (!VARIANT_ID_TO_KEY.has(id)) VARIANT_ID_TO_KEY.set(id, key);
	  });
	  const DEFAULT_EXPORT_PROFILE_KEY = (typeof window !== 'undefined' && window.__defaultExportProfileKey) || 'sticker';

  function productTypeForVariantKey(key) {
    if (!key) return DEFAULT_EXPORT_PROFILE_KEY;
    if (key.startsWith('oval_normal_')) return 'sticker_normal_oval';
    if (key.startsWith('rect_normal_')) return 'sticker_normal_rect';
    if (key.startsWith('oval_mini_')) return 'sticker_mini_oval';
    if (key.startsWith('rect_mini_')) return 'sticker_mini_rect';
    if (key.startsWith('beerdeckel_')) return 'beerdeckel';
    if (key.startsWith('flag_')) return key;
    if (key.startsWith('tshirt_')) return 'tshirt';
    if (key.startsWith('hoodie_')) return 'hoodie';
    if (key.startsWith('mug_enamel')) return 'mug_enamel';
    if (key.startsWith('mug_ceramic')) return 'mug_ceramic';
    if (key.startsWith('mug_')) return 'mug_ceramic';
    return 'sticker';
  }

  function getIdPrefixForProfile(profileKey) {
    try {
      const profiles = window.__exportProfiles || {};
      const profile = profiles[profileKey];
      return profile && profile.idPrefix ? profile.idPrefix : null;
    } catch (err) {
      console.warn('idPrefix lookup failed', err);
      return null;
    }
  }

  function exportProfilesForSelection(selection) {
    const set = new Set();
    selection.forEach(item => set.add(productTypeForVariantKey(item.key)));
    const list = Array.from(set);
    return list.length ? list : [DEFAULT_EXPORT_PROFILE_KEY];
  }

	  const stickerSelection = { normalOval: 0, normalRect: 0, miniOval: 0, miniRect: 0 };
		  let beerdeckelSelection = 0;
		  const flagVariantState = new Map();
		  const EXPRESS_SURCHARGE_CENTS = 2999;
		  const EXPRESS_MIN_PIECES = 30;
		  const STANDARD_PRODUCTION_TIME_LABEL = 'Standard (7–10 Werktage)';
		  const EXPRESS_PRODUCTION_TIME_LABEL = 'Express (48h)';
		  const expressSelectionByGroupKey = new Map(); // groupKey -> boolean
	  const hoodieVariantState = new Map();
	  const tshirtVariantState = new Map();
	  const mugVariantState = new Map();
  const PREVIEW_STORAGE_PREFIX = 'NH_PREVIEW_';
const PREVIEW_MAX_EDGE = 360;
const priceCache = new Map(); // key -> { ready: boolean, price: number|null }
let refreshSummaries = () => {};
let refreshTotal = () => {};
let exportWarmupTimer = null;
let lastExportWarmSignature = '';
const previewUploadCache = window.__nhPreviewUploadCache || new Map();
window.__nhPreviewUploadCache = previewUploadCache;
		  const DEBUG_PROGRESS_MODE = /[?&]nh_debug_progress=1/.test(window.location.search) || (window.location.hash && /nh_debug_progress=1/.test(window.location.hash));
		  const getShapeType = () => {
	    try {
	      if (window.__nhUseReorderAvailability) {
	        const shape = window.__nhReorderShape;
	        if (shape === 'oval' || shape === 'rect' || shape === 'both') return shape;
	      }
	    } catch (_) { /* noop */ }
	    if (typeof window.getCurrentShapeType === 'function') {
	      try {
	        const shape = window.getCurrentShapeType();
	        if (shape === 'oval' || shape === 'rect' || shape === 'both') return shape;
	      } catch (err) { /* noop */ }
	    }
	    const activeChoice = document.querySelector('[data-shape-choice][aria-pressed="true"]');
	    const selectedShape = activeChoice && activeChoice.getAttribute('data-shape-choice');
	    if (selectedShape === 'oval' || selectedShape === 'rect') return selectedShape;
	    return 'oval';
		  };

	  function resolveExpressProductionVariantId() {
	    const raw = window.__NH_EXPRESS_PRODUCTION_VARIANT_ID;
	    const id = Number(raw);
	    return Number.isFinite(id) && id > 0 ? id : null;
	  }

		  let __nhExpressVariantIdPromise = null;
		  function ensureExpressProductionVariantIdLoaded() {
		    const existing = resolveExpressProductionVariantId();
		    if (existing) return Promise.resolve(existing);
		    if (__nhExpressVariantIdPromise) return __nhExpressVariantIdPromise;

		    __nhExpressVariantIdPromise = (async () => {
		      const urls = [];
		      try {
		        const host = String(window.location.hostname || '');
		        if (/^www\\./i.test(host)) {
		          const altHost = host.replace(/^www\\./i, '');
		          urls.push(`${window.location.protocol}//${altHost}/products/expressproduktion.js`);
		        }
		      } catch (_) { /* noop */ }
		      urls.push('/products/expressproduktion.js');

		      const seen = new Set();
		      for (const url of urls) {
		        const safeUrl = String(url || '').trim();
		        if (!safeUrl || seen.has(safeUrl)) continue;
		        seen.add(safeUrl);
		        try {
		          const res = await fetch(safeUrl, {
		            method: 'GET',
		            credentials: 'omit',
		            headers: { 'Accept': 'application/json' },
		            redirect: 'follow'
		          });
		          if (!res.ok) continue;

		          let data = null;
		          try {
		            data = await res.json();
		          } catch (_) {
		            const text = await res.text().catch(() => '');
		            try { data = JSON.parse(text); } catch (_) { data = null; }
		          }

		          const variants = Array.isArray(data?.variants) ? data.variants : [];
		          const chosen = variants.find((v) => v && v.available === true) || variants[0] || null;
		          const id = Number(chosen?.id);
		          if (Number.isFinite(id) && id > 0) {
		            window.__NH_EXPRESS_PRODUCTION_VARIANT_ID = id;
		            return id;
		          }
		        } catch (err) {
		          console.warn('Express-Variant-ID konnte nicht geladen werden', safeUrl, err);
		        }
		      }
		      return null;
		    })().catch((err) => {
		      console.warn('Express-Variant-ID konnte nicht geladen werden', err);
		      return null;
		    });

		    return __nhExpressVariantIdPromise;
		  }

		  function expressGroupKeyForVariantKey(key) {
		    const groupKey = productTypeForVariantKey(key);
		    if (groupKey === 'beerdeckel') return groupKey;
		    if (typeof groupKey === 'string' && groupKey.startsWith('sticker_')) return groupKey;
		    return null;
		  }

		  function packPiecesFromVariantKey(key) {
		    const match = String(key || '').match(/_(\d+)$/);
		    if (!match) return null;
		    const value = parseInt(match[1], 10);
		    return Number.isFinite(value) ? value : null;
		  }

		  function meetsExpressMinimumForVariantKey(key, quantity = 1) {
		    const groupKey = expressGroupKeyForVariantKey(key);
		    if (!groupKey) return false;
		    const piecesPerUnit = packPiecesFromVariantKey(key);
		    if (!piecesPerUnit) return false;
		    const qty = Math.max(1, parseInt(quantity, 10) || 1);
		    return piecesPerUnit * qty >= EXPRESS_MIN_PIECES;
		  }

		  function isExpressSelectedForVariantKey(key) {
		    const groupKey = expressGroupKeyForVariantKey(key);
		    if (!groupKey) return false;
		    if (!meetsExpressMinimumForVariantKey(key, 1)) return false;
		    return expressSelectionByGroupKey.get(groupKey) === true;
		  }

		  function pruneExpressSelections(selection) {
		    const active = new Set();
		    const eligible = new Map(); // groupKey -> boolean
		    selection.forEach(item => {
		      const groupKey = expressGroupKeyForVariantKey(item.key);
		      if (!groupKey) return;
		      active.add(groupKey);
		      const ok = meetsExpressMinimumForVariantKey(item.key, item.quantity || 1);
		      if (ok) {
		        eligible.set(groupKey, true);
		      } else if (!eligible.has(groupKey)) {
		        eligible.set(groupKey, false);
		      }
		    });
		    Array.from(expressSelectionByGroupKey.keys()).forEach(groupKey => {
		      if (!active.has(groupKey) || eligible.get(groupKey) === false) {
		        expressSelectionByGroupKey.delete(groupKey);
		      }
		    });
		  }

	  function expressSurchargeForSelection(selection) {
	    let total = 0;
	    selection.forEach(item => {
	      if (isExpressSelectedForVariantKey(item.key)) total += EXPRESS_SURCHARGE_CENTS;
	    });
	    return total;
	  }

	  function productionTimeLabelForVariantKey(key) {
	    return isExpressSelectedForVariantKey(key) ? EXPRESS_PRODUCTION_TIME_LABEL : STANDARD_PRODUCTION_TIME_LABEL;
	  }

	  function expressTargetLabelForVariantKey(key) {
	    if (!key) return '';
	    const stickerMatch = key.match(/^(oval|rect)_(normal|mini)_(\d+)$/);
	    if (stickerMatch) {
	      const shapeLabel = stickerMatch[1] === 'rect' ? 'Rechteckig' : 'Oval';
	      const sizeLabel = stickerMatch[2] === 'mini' ? 'Mini' : 'Normal';
	      return `Aufkleber ${sizeLabel} ${shapeLabel} (${stickerMatch[3]} Stk)`;
	    }
	    const bd = key.match(/^beerdeckel_(\d+)$/);
	    if (bd) return `Bierdeckel (${bd[1]} Stk)`;
	    return key;
	  }

	  function requestDesignExportWarmup() {
	    // Warmup deaktiviert: PDFs erst beim Checkout erzeugen.
	    if (exportWarmupTimer) {
	      clearTimeout(exportWarmupTimer);
      exportWarmupTimer = null;
    }
    // Kein scheduleDesignExportPreparation mehr.
  }

  function safeSessionStorage() {
    try {
      return window.sessionStorage || null;
    } catch (err) {
      console.warn('SessionStorage unavailable', err);
      return null;
    }
  }

  function previewStorageKey(designId) {
    return `${PREVIEW_STORAGE_PREFIX}${designId}`;
  }

function readPersistedPreview(designId) {
  if (!designId) return '';
  const store = safeSessionStorage();
  if (!store) return '';
  try {
    return store.getItem(previewStorageKey(designId)) || '';
  } catch (err) {
    console.warn('Preview lookup failed', err);
    return '';
  }
}

function latestPreviewCandidate(designId) {
    const candidates = [
      window.__lastPreviewDataUrl,
      window.__pendingPreviewDataUrl
    ];
    for (const source of candidates) {
      if (typeof source === 'string' && source.startsWith('data:image')) {
        return source;
      }
  }
  return readPersistedPreview(designId);
}

async function uploadPreviewImage(designId, dataUrl) {
  if (!dataUrl || typeof dataUrl !== 'string') return '';
  const endpoint = typeof NETLIFY_FN === 'string' ? NETLIFY_FN : (window.NETLIFY_FN || '');
  if (!endpoint) return '';

  const payload = {
    type: 'preview',
    id: designId || '',
    previewBase64: dataUrl,
    fileName: `${designId || 'design'}-preview.jpg`
  };

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const text = await response.text();
  let json;
  try {
    json = JSON.parse(text);
  } catch (err) {
    throw new Error('Preview upload fehlgeschlagen (kein JSON)');
  }

  if (!json.ok) {
    throw new Error(json.error || 'Preview upload fehlgeschlagen');
  }

  return json.viewUrl || '';
}

async function ensurePreviewUploaded(designId, previewDataUrl) {
  if (!previewDataUrl || typeof previewDataUrl !== 'string') return '';
  const cacheKey = designId || previewDataUrl.slice(0, 120);
  if (previewUploadCache.has(cacheKey)) {
    return previewUploadCache.get(cacheKey);
  }

  let optimized = previewDataUrl;
  try {
    optimized = await compressPreviewData(previewDataUrl, 480);
  } catch (err) {
    console.warn('Preview komprimieren fehlgeschlagen', err);
  }

  try {
    const remoteUrl = await uploadPreviewImage(designId, optimized);
    if (remoteUrl) {
      previewUploadCache.set(cacheKey, remoteUrl);
    }
    return remoteUrl || '';
  } catch (err) {
    console.warn('Preview Upload fehlgeschlagen', err);
    previewUploadCache.set(cacheKey, '');
    return '';
  }
}

  function getLoadingModalElements() {
    const modal = document.getElementById('loading-modal');
    if (!modal) return { modal: null, dialog: null };
    return { modal, dialog: modal.querySelector('.loading-dialog') };
  }

  function appendProgressDebug(label) {
    // Nur im Debug-Modus überhaupt etwas anzeigen
    if (!DEBUG_PROGRESS_MODE) return;

    const { modal, dialog } = getLoadingModalElements();
    if (!modal || !dialog) return;
    let list = modal.querySelector('.loading-debug-log');
    if (!list) {
      list = document.createElement('div');
      list.className = 'loading-debug-log';
      list.setAttribute('aria-live', 'polite');
      dialog.appendChild(list);
    }
    const entry = document.createElement('div');
    entry.textContent = `[${new Date().toLocaleTimeString()}] ${label}`;
    list.appendChild(entry);
    // Liste begrenzen, damit sie nicht unendlich wächst
    while (list.children.length > 12) {
      list.removeChild(list.firstChild);
    }
  }

  function buildDebugContinueButton(label, action) {
    // Button nur im Debug-Modus bauen
    if (!DEBUG_PROGRESS_MODE) return null;

    const { modal, dialog } = getLoadingModalElements();
    if (!modal || !dialog) return null;
    let wrapper = modal.querySelector('.loading-debug-actions');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'loading-debug-actions';
      dialog.appendChild(wrapper);
    }
    let btn = wrapper.querySelector('button');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn debug-continue';
      wrapper.appendChild(btn);
    }
    btn.textContent = label;
    btn.onclick = action;
    return btn;
  }

  function writeCartTabLoading(tab) {
    if (!tab || tab.closed) return;
    try {
      const doc = tab.document;
      if (!doc) return;
      doc.open();
      doc.write(`<!doctype html>
<html lang="de">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#ffd500" />
    <title>Warenkorb wird vorbereitet…</title>
    <style>
      :root {
        color-scheme: light;
        --nh-yellow: #ffd500;
        --nh-ink: #111111;
        --nh-muted: #5d626a;
        --nh-line: #d9d9d4;
        --nh-surface: #ffffff;
        --nh-background: #f4f4f2;
      }
      * { box-sizing: border-box; }
      html, body { min-height: 100%; margin: 0; }
      body {
        background: var(--nh-background);
        color: var(--nh-ink);
        font-family: Arial, Helvetica, sans-serif;
      }
      .page {
        min-height: 100vh;
        min-height: 100svh;
        display: grid;
        grid-template-rows: 84px 1fr auto;
      }
      .brandbar {
        display: flex;
        align-items: center;
        background: var(--nh-yellow);
        border-bottom: 2px solid var(--nh-ink);
      }
      .brandbar__inner {
        width: min(720px, calc(100% - 32px));
        margin: 0 auto;
        display: flex;
        align-items: center;
        gap: 14px;
      }
      .brandmark {
        width: 54px;
        height: 54px;
        flex: 0 0 54px;
        display: grid;
        place-items: center;
        border: 2px solid var(--nh-ink);
        border-radius: 50%;
        background: var(--nh-yellow);
        font-size: 12px;
        font-weight: 900;
        line-height: 0.9;
        text-align: center;
      }
      .brandcopy { min-width: 0; }
      .brandname {
        margin: 0;
        font-size: 18px;
        font-weight: 900;
        line-height: 1.1;
      }
      .brandclaim {
        margin: 4px 0 0;
        font-size: 11px;
        font-weight: 700;
        line-height: 1.2;
        text-transform: uppercase;
      }
      .wrap {
        display: grid;
        place-items: center;
        padding: 48px 16px;
      }
      .card {
        width: min(640px, 100%);
        border: 1px solid var(--nh-line);
        border-top: 6px solid var(--nh-yellow);
        border-radius: 8px;
        background: var(--nh-surface);
        box-shadow: 0 16px 36px rgba(17, 17, 17, 0.10);
        padding: 34px;
      }
      .eyebrow {
        margin: 0 0 10px;
        color: #7a6500;
        font-size: 12px;
        font-weight: 900;
        line-height: 1.2;
        text-transform: uppercase;
      }
      .title {
        margin: 0;
        max-width: 520px;
        font-size: 34px;
        font-weight: 900;
        line-height: 1.08;
      }
      .subtitle {
        margin: 14px 0 0;
        max-width: 560px;
        color: var(--nh-muted);
        font-size: 17px;
        line-height: 1.5;
      }
      .progress-meta {
        margin-top: 26px;
        display: flex;
        justify-content: space-between;
        gap: 16px;
        font-size: 12px;
        font-weight: 800;
      }
      .progress-meta span:last-child {
        color: var(--nh-muted);
        font-weight: 700;
      }
      .bar {
        height: 12px;
        margin-top: 9px;
        overflow: hidden;
        border: 1px solid #cecec8;
        border-radius: 3px;
        background: #e9e9e5;
      }
      .bar > div {
        width: 8%;
        min-width: 12px;
        height: 100%;
        border-radius: 2px;
        background: var(--nh-yellow);
        transition: width 180ms ease;
      }
      .steps {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 10px;
        margin-top: 24px;
      }
      .step {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #393b3f;
        font-size: 12px;
        font-weight: 800;
        line-height: 1.25;
      }
      .step__number {
        width: 24px;
        height: 24px;
        flex: 0 0 24px;
        display: grid;
        place-items: center;
        border: 1px solid var(--nh-ink);
        border-radius: 50%;
        background: var(--nh-yellow);
        color: var(--nh-ink);
        font-size: 11px;
        font-weight: 900;
      }
      .hint {
        margin: 24px 0 0;
        padding-top: 18px;
        border-top: 1px solid var(--nh-line);
        color: var(--nh-muted);
        font-size: 13px;
        line-height: 1.45;
      }
      .page-footer {
        padding: 0 16px 22px;
        color: #6b6f75;
        font-size: 11px;
        font-weight: 800;
        text-align: center;
        text-transform: uppercase;
      }
      @media (max-width: 520px) {
        .page { grid-template-rows: 72px 1fr auto; }
        .brandbar__inner { width: min(100% - 24px, 720px); gap: 10px; }
        .brandmark { width: 44px; height: 44px; flex-basis: 44px; font-size: 10px; }
        .brandname { font-size: 16px; }
        .brandclaim { font-size: 9px; }
        .wrap { align-items: start; padding: 30px 12px; }
        .card { padding: 24px 20px; }
        .title { font-size: 28px; }
        .subtitle { font-size: 15px; }
        .steps { gap: 6px; }
        .step { align-items: flex-start; gap: 5px; font-size: 10px; }
        .step__number { width: 20px; height: 20px; flex-basis: 20px; font-size: 9px; }
      }
      @media (prefers-reduced-motion: reduce) {
        .bar > div { transition: none; }
      }
    </style>
  </head>
  <body>
    <div class="page">
      <header class="brandbar" aria-label="Nett hier">
        <div class="brandbar__inner">
          <div class="brandmark" aria-hidden="true">NETT<br>HIER.</div>
          <div class="brandcopy">
            <p class="brandname">Nett hier.</p>
            <p class="brandclaim">Dein Motiv. Dein Produkt.</p>
          </div>
        </div>
      </header>
      <main class="wrap">
        <section class="card" role="status" aria-live="polite">
          <p class="eyebrow">Deine Bestellung</p>
          <h1 class="title">Dein Warenkorb wird vorbereitet</h1>
          <p class="subtitle" id="nh-cart-status">Wir sichern dein Design, erstellen die benötigten Druckdateien und legen deine Auswahl anschließend in den Warenkorb.</p>
          <div class="progress-meta"><span>Fortschritt</span><span>Bitte kurz warten</span></div>
          <div class="bar" aria-hidden="true"><div id="nh-cart-progress"></div></div>
          <div class="steps" aria-hidden="true">
            <div class="step"><span class="step__number">1</span><span>Design sichern</span></div>
            <div class="step"><span class="step__number">2</span><span>Druckdaten erstellen</span></div>
            <div class="step"><span class="step__number">3</span><span>Warenkorb öffnen</span></div>
          </div>
          <p class="hint">Dieses Fenster wechselt automatisch zum Warenkorb. Dein Entwurf bleibt im Editor geöffnet.</p>
        </section>
      </main>
      <footer class="page-footer">Nett hier. Sicher bestellen.</footer>
    </div>
  </body>
</html>`);
      doc.close();
    } catch (_) {
      // ignore
    }
  }

  function updateCartTabProgress(value) {
    const tab = window.__nhCartTab;
    if (!tab || tab.closed) return;
    try {
      const doc = tab.document;
      const bar = doc && doc.getElementById ? doc.getElementById('nh-cart-progress') : null;
      if (!bar) return;
      const clamped = Math.max(0, Math.min(1, Number(value) || 0));
      bar.style.width = `${Math.round(clamped * 100)}%`;
    } catch (_) {
      // ignore
    }
  }

  function writeCartTabError(message) {
    const tab = window.__nhCartTab;
    if (!tab || tab.closed) return;
    try {
      const safeMessage = String(message || 'Bitte versuch es erneut.')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
      const doc = tab.document;
      if (!doc) return;
      doc.open();
      doc.write(`<!doctype html>
<html lang="de">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#ffd500" />
    <title>Bestellung fehlgeschlagen</title>
    <style>
      :root {
        color-scheme: light;
        --nh-yellow: #ffd500;
        --nh-ink: #111111;
        --nh-muted: #5d626a;
        --nh-line: #d9d9d4;
        --nh-background: #f4f4f2;
      }
      * { box-sizing: border-box; }
      html, body { min-height: 100%; margin: 0; }
      body { background: var(--nh-background); color: var(--nh-ink); font-family: Arial, Helvetica, sans-serif; }
      .page { min-height: 100vh; min-height: 100svh; display: grid; grid-template-rows: 84px 1fr auto; }
      .brandbar { display: flex; align-items: center; background: var(--nh-yellow); border-bottom: 2px solid var(--nh-ink); }
      .brandbar__inner { width: min(720px, calc(100% - 32px)); margin: 0 auto; display: flex; align-items: center; gap: 14px; }
      .brandmark { width: 54px; height: 54px; flex: 0 0 54px; display: grid; place-items: center; border: 2px solid var(--nh-ink); border-radius: 50%; font-size: 12px; font-weight: 900; line-height: 0.9; text-align: center; }
      .brandname { margin: 0; font-size: 18px; font-weight: 900; line-height: 1.1; }
      .brandclaim { margin: 4px 0 0; font-size: 11px; font-weight: 700; line-height: 1.2; text-transform: uppercase; }
      .wrap { display: grid; place-items: center; padding: 48px 16px; }
      .card { width: min(640px, 100%); border: 1px solid var(--nh-line); border-top: 6px solid var(--nh-yellow); border-radius: 8px; background: #fff; box-shadow: 0 16px 36px rgba(17, 17, 17, 0.10); padding: 34px; }
      .eyebrow { margin: 0 0 10px; color: #a1261d; font-size: 12px; font-weight: 900; line-height: 1.2; text-transform: uppercase; }
      .title { margin: 0; font-size: 34px; font-weight: 900; line-height: 1.08; }
      .subtitle { margin: 14px 0 0; color: var(--nh-muted); font-size: 17px; line-height: 1.5; }
      .action { width: 100%; min-height: 52px; margin-top: 24px; border: 1px solid var(--nh-ink); border-radius: 4px; background: var(--nh-yellow); color: var(--nh-ink); font: inherit; font-size: 15px; font-weight: 900; cursor: pointer; }
      .action:hover { background: #e5c000; }
      .action:focus-visible { outline: 3px solid var(--nh-ink); outline-offset: 3px; }
      .page-footer { padding: 0 16px 22px; color: #6b6f75; font-size: 11px; font-weight: 800; text-align: center; text-transform: uppercase; }
      @media (max-width: 520px) {
        .page { grid-template-rows: 72px 1fr auto; }
        .brandbar__inner { width: min(100% - 24px, 720px); gap: 10px; }
        .brandmark { width: 44px; height: 44px; flex-basis: 44px; font-size: 10px; }
        .brandname { font-size: 16px; }
        .brandclaim { font-size: 9px; }
        .wrap { align-items: start; padding: 30px 12px; }
        .card { padding: 24px 20px; }
        .title { font-size: 28px; }
        .subtitle { font-size: 15px; }
      }
    </style>
  </head>
  <body>
    <div class="page">
      <header class="brandbar" aria-label="Nett hier">
        <div class="brandbar__inner">
          <div class="brandmark" aria-hidden="true">NETT<br>HIER.</div>
          <div>
            <p class="brandname">Nett hier.</p>
            <p class="brandclaim">Dein Motiv. Dein Produkt.</p>
          </div>
        </div>
      </header>
      <main class="wrap">
        <section class="card" role="alert" aria-live="assertive">
          <p class="eyebrow">Bestellung unterbrochen</p>
          <h1 class="title">Das hat noch nicht geklappt</h1>
          <p class="subtitle">${safeMessage}</p>
          <p class="subtitle">Dein Entwurf bleibt im Editor erhalten. Schließe dieses Fenster und versuche es dort bitte noch einmal.</p>
          <button class="action" type="button" onclick="window.close()">Zurück zum Editor</button>
        </section>
      </main>
      <footer class="page-footer">Nett hier. Sicher bestellen.</footer>
    </div>
  </body>
</html>`);
      doc.close();
    } catch (_) {
      // ignore
    }
  }

  function loadImageFromDataUrl(dataUrl) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err || new Error('Preview image failed to load'));
      img.src = dataUrl;
    });
  }

  async function compressPreviewData(dataUrl, maxEdge = PREVIEW_MAX_EDGE) {
    if (!dataUrl) return '';
    try {
      const img = await new Promise((resolve, reject) => {
        const el = new Image();
        el.onload = () => resolve(el);
        el.onerror = reject;
        el.src = dataUrl;
      });
      const width = img.naturalWidth || img.width || 0;
      const height = img.naturalHeight || img.height || 0;
      if (!width || !height) return dataUrl;

      const largestSide = Math.max(width, height);
      const needsResize = largestSide > maxEdge;
      const needsCompress = dataUrl.length > 120000;

      if (!needsResize && !needsCompress) {
        return dataUrl;
      }

      const scale = needsResize ? (maxEdge / largestSide) : 1;
      const canvasEl = document.createElement('canvas');
      canvasEl.width = Math.max(1, Math.round(width * scale));
      canvasEl.height = Math.max(1, Math.round(height * scale));
      const ctx = canvasEl.getContext('2d');
      ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);
      return canvasEl.toDataURL('image/jpeg', 0.82);
    } catch (err) {
      console.warn('Design preview thumbnail failed', err);
      return dataUrl;
    }
  }

  async function resolvePreviewForCheckout(designId) {
    if (!designId) return '';
    const cached = window.__lastCheckoutPreview;
    if (cached && cached.id === designId) {
      return cached.value || '';
    }
    const candidate = latestPreviewCandidate(designId);
    if (!candidate) return '';
    const processed = await compressPreviewData(candidate);
    window.__lastCheckoutPreview = { id: designId, value: processed };
    return processed;
  }

  const originalHandleExport = window.handleExport;
  const originalUploadPdfBase64 = window.uploadPdfBase64;

  const clamp = (value, min, max) => {
    if (Number.isNaN(value) || typeof value !== 'number') return min;
    return Math.min(Math.max(value, min), max);
  };

  function setVariantQuantity(key, quantity) {
    const safeValue = Math.max(0, quantity || 0);
    document.querySelectorAll(`[data-variant-key="${key}"]`).forEach(input => {
      input.value = safeValue;
    });
  }

  function zeroVariantKeys(keys) {
    keys.forEach(key => setVariantQuantity(key, 0));
  }

  if (typeof originalUploadPdfBase64 === 'function') {
    window.uploadPdfBase64 = async function(){
      const result = await originalUploadPdfBase64.apply(this, arguments);
      if (result && result.viewUrl) {
        window.__lastDesignPdfUrl = result.viewUrl;
      }
      return result;
    };
  }

  function isProductAuditMode() {
    try {
      return new URLSearchParams(window.location.search || '').has('audit-products');
    } catch (_) {
      return false;
    }
  }

  function isShopifyContext() {
    return isProductAuditMode() || typeof Shopify !== 'undefined' || /myshopify\.com$/.test(window.location.hostname);
  }

  function getLatestDesignId() {
    return window.__lastDesignId || (typeof safeGetItem === 'function' ? safeGetItem('NH_LAST_ID') : null);
  }

  async function ensureDesignExported(profileKeys = [], profileQuantities) {
    const normalizedProfiles = Array.from(new Set((profileKeys || []).filter(Boolean)));
    const profilesForSignature = normalizedProfiles.length ? normalizedProfiles : [DEFAULT_EXPORT_PROFILE_KEY];

    const snapshot = (typeof currentDesignFingerprint === 'function')
      ? currentDesignFingerprint()
      : null;

    const desiredSignature = `${snapshot || 'unknown'}::${profilesForSignature.join('|')}`;

    let exportResult = null;

    // Direkt beim Checkout exportieren (Warmup deaktiviert)
    if (typeof window.beginDesignExport === 'function') {
      exportResult = await window.beginDesignExport(profilesForSignature);
    }
    let latestExports = exportResult || window.__lastDesignExports || {};
    let results = latestExports.results || {};

    // Sicherstellen, dass alle gewünschten Profile ein Ergebnis haben
    const missingProfiles = profilesForSignature.filter((p) => !results[p]);
    if (missingProfiles.length && typeof window.beginDesignExport === 'function') {
      try {
        const fresh = await window.beginDesignExport(profilesForSignature);
        if (fresh && fresh.results) {
          latestExports = fresh;
          results = fresh.results;
        }
      } catch (err) {
        console.warn('Re-Export wegen fehlender Profile fehlgeschlagen', missingProfiles, err);
      }
    }

    const primaryProfile = latestExports.primaryProfile || profilesForSignature[0] || DEFAULT_EXPORT_PROFILE_KEY;
    const primaryResult = results[primaryProfile] || Object.values(results)[0] || null;
    const primaryId = primaryResult?.id || getLatestDesignId();
    if (!primaryId) throw new Error('Design-ID konnte nicht ermittelt werden.');
    return {
      primaryId,
      results,
      primaryProfile
    };
  }

	  function collectSelectedVariants() {
    const entries = [];
    document.querySelectorAll('[data-variant-key]').forEach(input => {
      const qty = parseInt(input.value, 10);
      if (qty && qty > 0) {
        entries.push({
          key: input.dataset.variantKey,
          quantity: qty
        });
      }
    });
	    return entries;
	  }

	  function b2bShirtDistributionFromEntries(entries) {
	    const labels = { white: 'Weiß', black: 'Schwarz' };
	    const sizes = { s: 'S', m: 'M', l: 'L', xl: 'XL', xxl: 'XXL', xxxl: 'XXXL' };
	    const rows = [];
	    (entries || []).forEach(([key, quantity]) => {
	      if (!quantity) return;
	      const parts = String(key).split('_');
	      rows.push(`${labels[parts[1]] || parts[1]} ${sizes[parts[2]] || String(parts[2] || '').toUpperCase()}: ${quantity}`);
	    });
	    return rows.join(', ');
	  }

	  function b2bShirtDistribution() {
	    return b2bShirtDistributionFromEntries(Array.from(tshirtVariantState.entries()));
	  }

	  function b2bSelectionForExport(preset = B2B_PRESET, quantityMultiplier = 1, shirtDistribution = null) {
	    if (!preset) return [];
	    const tier = preset.tier;
	    const multiplier = Math.max(1, parseInt(quantityMultiplier, 10) || 1);
	    const shapePrefix = preset.shape === 'rect' ? 'rect' : 'oval';
	    const entries = [{ key: `${shapePrefix}_normal_${tier.stickers}`, quantity: multiplier }];
	    if (tier.mini) entries.push({ key: `${shapePrefix}_mini_${tier.mini}`, quantity: multiplier });
	    const shirtEntries = Array.isArray(shirtDistribution)
	      ? shirtDistribution
	      : Array.from(tshirtVariantState.entries());
	    shirtEntries.forEach(([key, quantity]) => {
	      if (quantity > 0) entries.push({ key, quantity: quantity * multiplier });
	    });
	    if (tier.mugs) entries.push({ key: 'mug_ceramic', quantity: tier.mugs * multiplier });
	    if (tier.flags) entries.push({ key: 'flag_150x86', quantity: tier.flags * multiplier });
	    return entries;
	  }

  function formatMoney(cents) {
    const value = Number.isFinite(cents) ? cents / 100 : 0;
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
  }

  function sumPrices(selection) {
    return selection.reduce((total, item) => {
      const entry = priceCache.get(item.key);
      if (entry && entry.ready && entry.price != null) {
        total += entry.price * item.quantity;
      }
      return total;
    }, 0);
  }

  function ensurePriceLoaded(key) {
    if (priceCache.has(key)) {
      const entry = priceCache.get(key);
      if (entry && entry.ready) return;
    }
    const variantId = resolveVariantId(key);
    if (!variantId) {
      priceCache.set(key, { ready: true, price: null });
      return;
    }
    priceCache.set(key, { ready: false, price: null });
    const query = window.location && window.location.search ? window.location.search : '';
    fetch(`/variants/${variantId}.js${query}`)
      .then(res => res.ok ? res.json() : Promise.reject(new Error(`Variant fetch failed (${res.status})`)))
      .then(data => {
        if (!data || data.price == null) throw new Error('Variant price missing');
        const raw = Number(data.price);
        let cents = Number.isFinite(raw) ? raw : 0;
        if (cents < 50 && typeof data.price === 'string') {
          const parsed = parseFloat(data.price);
          if (Number.isFinite(parsed)) cents = Math.round(parsed * 100);
        }
        priceCache.set(key, { ready: true, price: cents });
        try { refreshSummaries(); } catch (err) { /* noop */ }
        try { refreshTotal(); } catch (err2) { /* noop */ }
      })
      .catch((err) => {
        console.warn('Preis konnte nicht geladen werden', key, err);
        priceCache.set(key, { ready: true, price: null });
        try { refreshSummaries(); } catch (err2) { /* noop */ }
        try { refreshTotal(); } catch (err3) { /* noop */ }
      });
  }

  function priceLabelForKey(key) {
    const entry = priceCache.get(key);
    if (!entry) {
      ensurePriceLoaded(key);
      return 'lädt...';
    }
    if (!entry.ready) return 'lädt...';
    if (entry.price == null) return '---';
    return formatMoney(entry.price);
  }

	  function setupProductSelectorUi() {
	    const root = document.getElementById('shopifySelector');
	    if (!root || window.__shopifySelectorInitialized) return;
	    window.__shopifySelectorInitialized = true;

	    const summaries = {
	      stickers: root.querySelector('[data-summary="stickers"]'),
	      beerdeckel: root.querySelector('[data-summary="beerdeckel"]'),
	      flag: root.querySelector('[data-summary="flag"]'),
	      tshirt: root.querySelector('[data-summary="tshirt"]'),
	      hoodie: root.querySelector('[data-summary="hoodie"]'),
	      mug: root.querySelector('[data-summary="mug"]')
	    };
	    const totalLabel = document.getElementById('selector-total');
	    const selectionList = document.getElementById('selector-items') || document.getElementById('selector-selection-list');
	    const infoModal = document.getElementById('product-info-modal');
	    const infoTitle = document.getElementById('product-info-title');
	    const infoContent = document.getElementById('product-info-content');
	    let lastInfoTrigger = null;
	    const modeSwitch = root.querySelector('[data-selector-mode-switch]');
	    const productGrid = root.querySelector('#selector-product-grid');
	    const b2bCatalog = root.querySelector('[data-selector-b2b-catalog]');
	    const exportModal = root.closest('#export-modal');
	    const selectorTitle = exportModal && exportModal.querySelector('.selector-title');
	    const selectorSubtitle = exportModal && exportModal.querySelector('.selector-subtitle');
	    const summaryHint = root.querySelector('.selector-summary-hint');
	    const selectionValidation = root.querySelector('[data-selection-validation]');
	    const checkoutHint = root.querySelector('.selector-checkout-hint');
	    const checkoutButton = root.querySelector('#shopify-checkout-btn');
	    const summaryFooter = root.querySelector('.selector-summary-footer');
	    let b2bShirtConfig = root.querySelector('[data-b2b-shirt-config]');
	    if (!b2bShirtConfig && summaryFooter) {
	      b2bShirtConfig = document.createElement('section');
	      b2bShirtConfig.className = 'selector-b2b-shirt-config';
	      b2bShirtConfig.setAttribute('data-b2b-shirt-config', '');
	      b2bShirtConfig.hidden = true;
	      summaryFooter.insertAdjacentElement('beforebegin', b2bShirtConfig);
	    }
	    const selectorDefaults = {
	      title: selectorTitle ? selectorTitle.textContent : 'Produkte auswählen',
	      subtitle: selectorSubtitle ? selectorSubtitle.textContent : 'Wähle die passenden Produkte zu deinem Design und lege sie anschließend in den Warenkorb.',
	      summaryHint: summaryHint ? summaryHint.textContent : 'Hier siehst du alle ausgewählten Firmenpakete und Einzelprodukte.',
	      checkoutHint: checkoutHint ? checkoutHint.textContent : 'Alle Positionen werden gemeinsam mit deinem aktuellen Design in den Warenkorb gelegt.',
	      checkout: checkoutButton ? checkoutButton.childNodes[0]?.textContent || 'Alles in den Warenkorb ' : 'Alles in den Warenkorb '
	    };
	    let standardSelectionSnapshot = null;
	    const expandedB2bShirtEditors = new Set();

		    const PRODUCT_INFO = {
		      stickers: {
		        title: 'Aufkleber',
		        intro: 'Du hast die Wahl – oval oder rechteckig, passend zu deinem Motiv.',
		        bullets: [
		          'Normal: 14,5 × 8,2 cm (z.B. Auto, Türen, große Flächen)',
		          'Mini: 7,4 × 4,1 cm (z.B. Laptop, Flaschen, Notizbücher)',
		          'Material: hochwertige Qualitätsfolie – wetterfest & robust',
		          'Produktionszeit: Standard 7–10 Werktage',
		          `Optional: Expressproduktion (48h) ab ${EXPRESS_MIN_PIECES} Stk +${formatMoney(EXPRESS_SURCHARGE_CENTS)}`
		        ]
		      },
	      flag: {
	        title: 'Fahne',
	        intro: 'Deine „Nett hier.“-Fahne zum Selbstdesignen – für Balkon, Garten, Festival & mehr.',
	        bullets: [
	          'Outdoor-geeigneter Fahnenstoff mit knalligem Druck',
	          'Größen: 100×58, 150×86,5, 200×115,5, 300×173,4 cm',
	          'Dein Motiv wird als Unikat auf die Fahne gedruckt',
	          'Produktionszeit: 7–10 Werktage'
	        ]
	      },
		      beerdeckel: {
		        title: 'Bierdeckel',
		        intro: 'Nett hier? Dann bitte auch auf dem Tisch.',
		        bullets: [
		          'Format: oval, 13 × 9,5 cm',
		          'Material: 1,5 mm Bierdeckelpappe (nachhaltig, biologisch abbaubar, kompostierbar)',
		          'Druck: 4/4-farbig – beidseitig bedruckt',
		          'Produktionszeit: Standard 7–10 Werktage',
		          `Optional: Expressproduktion (48h) ab ${EXPRESS_MIN_PIECES} Stk +${formatMoney(EXPRESS_SURCHARGE_CENTS)}`
		        ]
		      },
	      tshirt: {
	        title: 'T‑Shirt',
	        intro: 'Premium Shirt-Basis für dein „Nett hier.“ Motiv.',
	        bullets: [
	          'Rohling: Stanley/Stella Creator 2.0 (STTU169)',
	          '100% Bio-Baumwolle, 180 g/m², Regular Fit',
	          'Druck: DTG/DTF – kräftige Farben & feine Details',
	          'Produktionszeit: 7–10 Werktage (bis zur Übergabe an den Versanddienstleister)',
	          'Pflege: auf links bei 30°C waschen, kein Trockner, nicht über den Druck bügeln'
	        ]
	      },
	      hoodie: {
	        title: 'Kapuzenpullover',
	        intro: 'Bio-Hoodies statt 08/15 – nachhaltig & bequem.',
	        bullets: [
	          'Rohling: Stanley/Stella Drummer',
	          '85% Bio-Baumwolle, 15% recyceltes Polyester',
	          'Öko-Tex-, OCS- und RCS-zertifiziert',
	          'Hochwertiger Druck für langlebige Motive',
	          'Produktionszeit: 7–10 Werktage'
	        ]
	      },
	      mug: {
	        title: 'Tasse',
	        intro: 'Keramik oder Emaille – du entscheidest.',
	        bullets: [
	          'Keramik: 330 ml · Druckbereich ca. 14,5 × 8,2 cm · ORCA-Beschichtung (spülmaschinenfest)',
	          'Emaille: 375 ml · Druckbereich ca. 12 × 7 cm · Handwäsche empfohlen',
	          'Produktionszeit: 7–10 Werktage (bis zur Übergabe an den Versanddienstleister)'
	        ]
	      }
	    };

	    function isProductInfoOpen() {
	      return !!infoModal && infoModal.getAttribute('aria-hidden') === 'false';
	    }

	    function buildProductInfoHtml(entry) {
	      if (!entry) return '';
	      const parts = [];
	      if (entry.intro) parts.push(`<p>${escapeHtml(entry.intro)}</p>`);
	      if (Array.isArray(entry.bullets) && entry.bullets.length) {
	        const items = entry.bullets.map((bullet) => `<li>${escapeHtml(bullet)}</li>`).join('');
	        parts.push(`<ul>${items}</ul>`);
	      }
	      return parts.join('');
	    }

	    function openProductInfo(key, triggerEl = null) {
	      if (!infoModal || !infoTitle || !infoContent) return;
	      const entry = PRODUCT_INFO[key];
	      if (!entry) return;

	      lastInfoTrigger = triggerEl || document.activeElement;
	      infoTitle.textContent = entry.title || 'Produktinfo';
	      infoContent.innerHTML = buildProductInfoHtml(entry);
	      infoModal.setAttribute('aria-hidden', 'false');

	      const closeBtn = infoModal.querySelector('.product-info-close');
	      closeBtn?.focus?.();
	    }

	    function closeProductInfo() {
	      if (!infoModal) return;
	      infoModal.setAttribute('aria-hidden', 'true');
	      if (infoContent) infoContent.innerHTML = '';
	      if (lastInfoTrigger && typeof lastInfoTrigger.focus === 'function') {
	        lastInfoTrigger.focus();
	      }
	      lastInfoTrigger = null;
	    }

	    root.addEventListener('click', (event) => {
	      const button = event.target && event.target.closest ? event.target.closest('[data-product-info]') : null;
	      if (!button) return;
	      event.preventDefault();
	      event.stopPropagation();
	      openProductInfo(button.getAttribute('data-product-info'), button);
	    });

	    if (infoModal) {
	      infoModal.addEventListener('click', (event) => {
	        const dismiss = event.target && event.target.closest ? event.target.closest('[data-dismiss="product-info-modal"]') : null;
	        const closeBtn = event.target && event.target.closest ? event.target.closest('.product-info-close') : null;
	        if (!dismiss && !closeBtn) return;
	        event.preventDefault();
	        closeProductInfo();
	      });
	    }

	    document.addEventListener('keydown', (event) => {
	      if (event.key !== 'Escape') return;
	      if (!isProductInfoOpen()) return;
	      event.preventDefault();
	      closeProductInfo();
	    });

	    function parseVariantKey(key) {
	      // returns { product, variant, badge, isPack }
	      if (key.startsWith('oval_') || key.startsWith('rect_')) {
        const parts = key.split('_'); // [shape, size, count]
        const shape = parts[0] === 'rect' ? 'Rechteckig' : 'Oval';
        const size = parts[1] === 'mini' ? 'Mini' : 'Normal';
        const pack = parts[2] || '';
        return { product: 'Aufkleber', variant: `${size} · ${shape}`, badge: pack ? `${pack} Stk` : 'Aufkleber', isPack: true };
      }
      if (key.startsWith('beerdeckel_')) {
        const pack = key.split('_')[1] || '';
        return { product: 'Bierdeckel', variant: 'Rund', badge: pack ? `${pack} Stk` : 'Bierdeckel', isPack: true };
      }
      if (key.startsWith('flag_')) {
        const size = key.split('_')[1] || '';
        return { product: 'Fahne', variant: flagSizeLabel(size), badge: '', isPack: false };
      }
      if (key.startsWith('tshirt_')) {
        const parts = key.split('_'); // tshirt color size
        const color = parts[1] === 'black' ? 'Schwarz' : 'Weiß';
        const size = (parts[2] || '').toUpperCase();
        return { product: 'T‑Shirt', variant: `${color} · ${size}`, badge: '', isPack: false };
      }
      if (key.startsWith('hoodie_')) {
        const parts = key.split('_');
        const color = parts[1] === 'black' ? 'Schwarz' : 'Weiß';
        const size = (parts[2] || '').toUpperCase();
        return { product: 'Kapuzenpullover', variant: `${color} · ${size}`, badge: '', isPack: false };
      }
      if (key.startsWith('mug_')) {
        const type = key.split('_')[1] === 'enamel' ? 'Emaille' : 'Keramik';
        return { product: 'Tasse', variant: type, badge: '', isPack: false };
      }
      return { product: 'Produkt', variant: key, badge: '', isPack: false };
    }

    function getLinePrice(key) {
      const entry = priceCache.get(key);
      if (!entry) {
        ensurePriceLoaded(key);
        return { ready: false, price: null };
      }
      if (!entry.ready) return { ready: false, price: null };
      return { ready: true, price: entry.price };
    }

	    function renderB2bSelectionList() {
	      if (!selectionList || !B2B_PRESET) return;
	      const tier = B2B_PRESET.tier;
	      const shapeLabel = B2B_PRESET.shape === 'rect' ? 'Rechteckig' : 'Oval';
	      const rows = [
	        ['Aufkleber Normal', `${tier.stickers} Stück · ${shapeLabel}`]
	      ];
	      if (tier.mini) rows.push(['Aufkleber Mini', `${tier.mini} Stück · ${shapeLabel}`]);
	      if (tier.shirts) {
	        const selected = totalTshirtQuantity();
	        const distribution = b2bShirtDistribution();
	        rows.push(['T-Shirts', `${selected} von ${tier.shirts} verteilt${distribution ? ` · ${distribution}` : ''}`]);
	      }
	      if (tier.mugs) rows.push(['Keramiktassen', `${tier.mugs} Stück`]);
	      if (tier.flags) rows.push(['Fahne 150 × 86,5 cm', `${tier.flags} Stück`]);

	      const activeRows = rows.map(([title, meta]) => `
	        <div class="selector-item selector-item--b2b">
	          <div class="selector-item__left">
	            <p class="selector-item__title">${escapeHtml(title)}</p>
	            <p class="selector-item__meta">${escapeHtml(meta)}</p>
	          </div>
	          <div class="selector-item__right"><span class="selector-item__badge">inklusive</span></div>
	        </div>
	      `).join('');
	      const savedRows = B2B_SELECTIONS.map((item) => b2bSavedRowMarkup(item)).join('');
	      selectionList.innerHTML = `
	        ${savedRows
	          ? `<div class="selector-selection-group-label"><span>Bereits ausgewählt</span><strong>${B2B_SELECTIONS.length === 1 ? '1 Paketposition' : `${B2B_SELECTIONS.length} Paketpositionen`}</strong></div>${savedRows}`
	          : ''}
	        <section class="selector-active-package" aria-label="Aktuell vorbereitetes Firmenpaket">
	          <div class="selector-active-package__header">
	            <div>
	              <span>Wird gerade vorbereitet</span>
	              <strong>${escapeHtml(B2B_PRESET.title)} · ${escapeHtml(B2B_PRESET.tier.label)}</strong>
	            </div>
	            <b>Noch nicht hinzugefügt</b>
	          </div>
	          <div class="selector-active-package__items">${activeRows}</div>
	        </section>
	      `;
	    }

	    function renderSelectionList(selection) {
	      if (!selectionList) return;
	      if (B2B_PRESET) {
	        renderB2bSelectionList();
	        return;
	      }

	      const individualSelection = Array.isArray(selection) ? selection : [];
	      if (!individualSelection.length && !B2B_SELECTIONS.length) {
	        selectionList.innerHTML = '<div class="selector-empty-state" id="selector-empty-state">Noch nichts ausgewählt.</div>';
	        return;
	      }

	      const rows = B2B_SELECTIONS.map((item) => b2bSavedRowMarkup(item));
	      rows.push(...individualSelection.map(({ key, quantity }) => {
		        const info = parseVariantKey(key);
		        const priceInfo = getLinePrice(key);
		        const expressGroupKey = expressGroupKeyForVariantKey(key);
		        const meetsMinForExpress = expressGroupKey ? meetsExpressMinimumForVariantKey(key, quantity) : false;
		        const hasExpressVariant = !!resolveExpressProductionVariantId();
		        const expressDisabled = !!expressGroupKey && (!hasExpressVariant || !meetsMinForExpress);
		        const expressChecked = !expressDisabled && !!expressGroupKey && expressSelectionByGroupKey.get(expressGroupKey) === true;
		        const expressLabelText = !hasExpressVariant
		          ? 'Express aktuell nicht verfügbar'
		          : (!meetsMinForExpress ? `Express erst ab ${EXPRESS_MIN_PIECES} Stück` : `Expressproduktion (48h) +${escapeHtml(formatMoney(EXPRESS_SURCHARGE_CENTS))}`);

	        // Badge logic: pack products show pack size, apparel shows ×qty
	        const badge = info.isPack ? (info.badge || 'Auswahl') : `×${quantity}`;

	        // Price display
	        let meta = info.variant;
	        if (!priceInfo.ready) {
	          meta += ' · Preis lädt…';
	        } else if (priceInfo.ready && priceInfo.price != null) {
	          const unit = priceInfo.price;
	          const line = unit * quantity;
	          if (quantity > 1) {
	            meta += ` · ${formatMoney(unit)} · ${formatMoney(line)}`;
	          } else {
	            meta += ` · ${formatMoney(unit)}`;
	          }
	        }
	        if (isExpressSelectedForVariantKey(key)) {
	          meta += ` · Express +${formatMoney(EXPRESS_SURCHARGE_CENTS)}`;
	        }

		        const expressToggle = expressGroupKey
		          ? `
		              <label class="selector-express ${expressDisabled ? 'is-disabled' : ''}" ${(!meetsMinForExpress && hasExpressVariant) ? `title="Express erst ab ${EXPRESS_MIN_PIECES} Stück verfügbar"` : ''}>
		                <input class="selector-express__input" type="checkbox" data-express-group="${escapeHtml(expressGroupKey)}" ${expressChecked ? 'checked' : ''} ${expressDisabled ? 'disabled' : ''}/>
		                <span class="selector-express__toggle" aria-hidden="true"></span>
		                <span class="selector-express__label">${expressLabelText}</span>
		              </label>
		            `
		          : '';

	        return `
	          <div class="selector-item">
	            <div class="selector-item__left">
	              <p class="selector-item__title">${escapeHtml(info.product)}</p>
	              <p class="selector-item__meta">${escapeHtml(meta)}</p>
	              ${expressToggle}
	            </div>
		            <div class="selector-item__right">
	              <span class="selector-item__badge">${escapeHtml(badge)}</span>
	              <button class="selector-item__remove" type="button" aria-label="Entfernen" data-remove-key="${escapeHtml(key)}">✕</button>
	            </div>
	          </div>
	        `;
	      }));

      selectionList.innerHTML = rows.join('');

	      selectionList.querySelectorAll('[data-remove-key]').forEach(btn => {
	        btn.addEventListener('click', () => {
	          const key = btn.getAttribute('data-remove-key');
	          if (!key) return;
	          clearSelectionForKey(key);
	          try { refreshSummaries(); } catch (err) { /* noop */ }
	          try { refreshTotal(); } catch (err2) { /* noop */ }
	        });
	      });

	      selectionList.querySelectorAll('[data-express-group]').forEach(input => {
	        input.addEventListener('change', () => {
	          const groupKey = input.getAttribute('data-express-group');
	          if (!groupKey) return;
	          if (input.checked) {
	            expressSelectionByGroupKey.set(groupKey, true);
	          } else {
	            expressSelectionByGroupKey.delete(groupKey);
	          }
	          try { refreshTotal(); } catch (err) { /* noop */ }
	        });
	      });
	    }

    function clearSelectionForKey(key) {
      // Apparel & mugs: use the visible inputs so UI stays consistent.
      if (key.startsWith('tshirt_')) {
        const parts = key.split('_');
        const color = parts[1] === 'black' ? 'black' : 'white';
        const size = (parts[2] || '').toLowerCase();
        const input = root.querySelector(`[data-input="tshirt-variant"][data-color="${color}"][data-size="${size}"]`);
        if (input) {
          input.value = 0;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      }
      if (key.startsWith('hoodie_')) {
        const parts = key.split('_');
        const color = parts[1] === 'black' ? 'black' : 'white';
        const size = (parts[2] || '').toLowerCase();
        const input = root.querySelector(`[data-input="hoodie-variant"][data-color="${color}"][data-size="${size}"]`);
        if (input) {
          input.value = 0;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      }
      if (key.startsWith('mug_')) {
        const type = key.split('_')[1] === 'enamel' ? 'enamel' : 'ceramic';
        const input = root.querySelector(`[data-input="mug-variant"][data-type="${type}"]`);
        if (input) {
          input.value = 0;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      }
      if (key.startsWith('flag_')) {
        const size = key.slice('flag_'.length);
        const input = root.querySelector(`[data-input="flag-variant"][data-size="${size}"]`);
        if (input) {
          input.value = 0;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      }

      // Pack/selector products: click the “0” pill in the right group.
      const clickZero = (group) => {
        const container = root.querySelector(`[data-pill-group="${group}"]`);
        if (!container) return false;
        const zero = container.querySelector('.pill[data-value="0"]');
        if (zero && !zero.disabled) {
          zero.click();
          return true;
        }
        return false;
      };

      if (key.startsWith('oval_normal_')) return void clickZero('stickers-qty-normal-oval');
      if (key.startsWith('oval_mini_')) return void clickZero('stickers-qty-mini-oval');
      if (key.startsWith('rect_normal_')) return void clickZero('stickers-qty-normal-rect');
      if (key.startsWith('rect_mini_')) return void clickZero('stickers-qty-mini-rect');
      if (key.startsWith('beerdeckel_')) return void clickZero('beerdeckel-qty');

      // Fallback: zero input value
      setVariantQuantity(key, 0);
    }

	    function escapeHtml(str) {
	      return String(str || '')
	        .replaceAll('&', '&amp;')
	        .replaceAll('<', '&lt;')
	        .replaceAll('>', '&gt;')
	        .replaceAll('"', '&quot;')
	        .replaceAll("'", '&#039;');
	    }

	    function b2bContentsForTier(tier) {
	      const rows = [
	        [`${tier.stickers || 0} Aufkleber`, 'Normal']
	      ];
	      if (tier.mini) rows.push([`${tier.mini} Aufkleber`, 'Mini']);
	      if (tier.shirts) rows.push([`${tier.shirts} T-Shirts`, 'Größen frei aufteilen']);
	      if (tier.mugs) rows.push([`${tier.mugs} Keramiktassen`, '330 ml']);
	      if (tier.flags) rows.push([`${tier.flags} ${tier.flags === 1 ? 'Fahne' : 'Fahnen'}`, '150 × 86,5 cm']);
	      return rows;
	    }

	    function b2bSavedUnits() {
	      return B2B_SELECTIONS.reduce((sum, item) => sum + Math.max(1, parseInt(item.quantity, 10) || 1), 0);
	    }

	    function b2bSavedTotalCents() {
	      return B2B_SELECTIONS.reduce((sum, item) => {
	        const quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
	        return sum + ((item.tier?.priceCents || 0) * quantity);
	      }, 0);
	    }

	    const b2bShirtColors = [
	      { key: 'white', label: 'Weiß' },
	      { key: 'black', label: 'Schwarz' }
	    ];
	    const b2bShirtSizes = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl'];

	    function b2bSavedShirtEntries(item) {
	      return Array.isArray(item?.shirtDistribution)
	        ? item.shirtDistribution
	          .map(([key, quantity]) => [String(key), Math.max(0, parseInt(quantity, 10) || 0)])
	          .filter(([key, quantity]) => key.startsWith('tshirt_') && quantity > 0)
	        : [];
	    }

	    function b2bSavedShirtState(item) {
	      const required = Math.max(0, parseInt(item?.tier?.shirts, 10) || 0);
	      const entries = b2bSavedShirtEntries(item);
	      const total = entries.reduce((sum, [, quantity]) => sum + quantity, 0);
	      return {
	        required,
	        entries,
	        total,
	        complete: !required || total === required
	      };
	    }

	    function b2bIncompleteSavedSelections() {
	      return B2B_SELECTIONS.filter((item) => !b2bSavedShirtState(item).complete);
	    }

	    function b2bSavedShirtEditorMarkup(item) {
	      const state = b2bSavedShirtState(item);
	      if (!state.required) return '';

	      const values = new Map(state.entries);
	      const expanded = expandedB2bShirtEditors.has(item.uid);
	      const remaining = Math.max(0, state.required - state.total);
	      const colorMarkup = b2bShirtColors.map((color) => `
	        <div class="selector-b2b-shirt-config__color">
	          <div class="selector-b2b-shirt-config__color-title">
	            <span aria-hidden="true" class="selector-b2b-shirt-config__swatch is-${color.key}"></span>
	            <strong>${color.label}</strong>
	          </div>
	          <div class="selector-b2b-shirt-config__sizes">
	            ${b2bShirtSizes.map((size) => {
	              const key = `tshirt_${color.key}_${size}`;
	              const quantity = Math.max(0, parseInt(values.get(key), 10) || 0);
	              const otherTotal = Math.max(0, state.total - quantity);
	              const maxForSize = Math.max(0, state.required - otherTotal);
	              const label = size.toUpperCase();
	              const accessibleName = `${color.label} · Größe ${label}`;
	              return `
	                <div class="selector-b2b-shirt-config__size">
	                  <span>${label}</span>
	                  <div class="selector-b2b-shirt-config__control" data-b2b-saved-shirt-control>
	                    <button aria-label="Weniger ${accessibleName}" data-b2b-saved-shirt-step="-1" data-color="${color.key}" data-size="${size}" type="button" ${quantity <= 0 ? 'disabled' : ''}>−</button>
	                    <input aria-label="${accessibleName} in diesem Firmenpaket" data-b2b-saved-shirt-value data-color="${color.key}" data-size="${size}" inputmode="numeric" max="${maxForSize}" min="0" pattern="[0-9]*" type="number" value="${quantity}">
	                    <button aria-label="Mehr ${accessibleName}" data-b2b-saved-shirt-step="1" data-color="${color.key}" data-size="${size}" type="button" ${state.total >= state.required ? 'disabled' : ''}>+</button>
	                  </div>
	                </div>
	              `;
	            }).join('')}
	          </div>
	        </div>
	      `).join('');

	      return `
	        <button
	          aria-controls="b2b-shirt-panel-${escapeHtml(item.uid)}"
	          aria-expanded="${expanded ? 'true' : 'false'}"
	          class="selector-b2b-saved-shirt-toggle ${state.complete ? 'is-complete' : 'is-incomplete'}"
	          data-b2b-saved-shirt-toggle
	          type="button"
	        >
	          <span>
	            <small>T-Shirts je Paket</small>
	            <strong>Größenverteilung anpassen</strong>
	          </span>
	          <b>${state.total} von ${state.required}</b>
	          <i aria-hidden="true"></i>
	        </button>
	        <div
	          class="selector-b2b-saved-shirt-panel ${state.complete ? 'is-complete' : 'is-incomplete'}"
	          id="b2b-shirt-panel-${escapeHtml(item.uid)}"
	          data-b2b-saved-shirt-panel
	          ${expanded ? '' : 'hidden'}
	        >
	          <p>Lege die Verteilung je Paket fest. Bei mehreren gleichen Paketen gilt sie für jedes Paket identisch.</p>
	          <div class="selector-b2b-shirt-config__progress" aria-hidden="true">
	            <span style="width: ${Math.min(100, (state.total / state.required) * 100)}%"></span>
	          </div>
	          <div class="selector-b2b-shirt-config__colors">${colorMarkup}</div>
	          <p class="selector-b2b-shirt-config__help">
	            ${remaining
	              ? `Noch ${remaining} ${remaining === 1 ? 'T-Shirt' : 'T-Shirts'} verteilen.`
	              : 'Verteilung vollständig.'}
	          </p>
	        </div>
	      `;
	    }

	    function setB2bSavedShirtQuantity(item, colorValue, sizeValue, requestedQuantity) {
	      const state = b2bSavedShirtState(item);
	      if (!state.required) return;
	      const color = colorValue === 'black' ? 'black' : 'white';
	      const size = b2bShirtSizes.includes(String(sizeValue || '').toLowerCase())
	        ? String(sizeValue).toLowerCase()
	        : 's';
	      const key = `tshirt_${color}_${size}`;
	      const values = new Map(state.entries);
	      const current = Math.max(0, parseInt(values.get(key), 10) || 0);
	      const otherTotal = Math.max(0, state.total - current);
	      const maxForSize = Math.max(0, state.required - otherTotal);
	      const quantity = clamp(parseInt(requestedQuantity, 10) || 0, 0, maxForSize);

	      if (quantity > 0) values.set(key, quantity);
	      else values.delete(key);
	      item.shirtDistribution = b2bShirtColors.flatMap((shirtColor) => {
	        return b2bShirtSizes.flatMap((shirtSize) => {
	          const shirtKey = `tshirt_${shirtColor.key}_${shirtSize}`;
	          const shirtQuantity = Math.max(0, parseInt(values.get(shirtKey), 10) || 0);
	          return shirtQuantity > 0 ? [[shirtKey, shirtQuantity]] : [];
	        });
	      });
	      expandedB2bShirtEditors.add(item.uid);
	      refreshTotal();
	    }

	    function b2bSavedRowMarkup(item) {
	      const quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
	      const shapeLabel = item.shape === 'rect' ? 'Rechteckig' : 'Oval';
	      const contents = b2bContentsForTier(item.tier).map(([label]) => label).join(' · ');
	      const shirtState = b2bSavedShirtState(item);
	      const shirtDistribution = b2bShirtDistributionFromEntries(shirtState.entries);
	      const shirtStatus = shirtState.required
	        ? (shirtState.complete
	          ? `T-Shirt-Größen je Paket: ${shirtDistribution}`
	          : `T-Shirt-Größen unvollständig: ${shirtState.total} von ${shirtState.required}`)
	        : '';
	      return `
	        <div class="selector-item selector-item--b2b-saved ${shirtState.complete ? '' : 'is-incomplete'}" data-b2b-saved-id="${escapeHtml(item.uid)}">
	          <div class="selector-b2b-saved__main">
	            <div class="selector-b2b-selection__copy">
	              <strong>${escapeHtml(item.title)} · ${escapeHtml(item.tier.label)}</strong>
	              <span>${escapeHtml(contents)} · ${escapeHtml(shapeLabel)}</span>
	              ${shirtStatus ? `<small class="${shirtState.complete ? '' : 'is-warning'}">${escapeHtml(shirtStatus)}</small>` : ''}
	            </div>
	            <div class="selector-b2b-selection__actions">
	              <div class="selector-b2b-selection__quantity" aria-label="Anzahl ${escapeHtml(item.title)}">
	                <button aria-label="Ein Paket weniger" data-b2b-saved-step="-1" type="button">−</button>
	                <strong aria-label="${quantity} Pakete">${quantity}</strong>
	                <button aria-label="Ein Paket mehr" data-b2b-saved-step="1" type="button">+</button>
	              </div>
	              <span class="selector-b2b-selection__line-price">${escapeHtml(formatMoney((item.tier.priceCents || 0) * quantity))}</span>
	              <button class="selector-item__remove" data-b2b-saved-remove type="button" aria-label="${escapeHtml(item.title)} entfernen">✕</button>
	            </div>
	          </div>
	          ${b2bSavedShirtEditorMarkup(item)}
	        </div>
	      `;
	    }

	    function renderB2bSavedSelections() {
	      renderSelectionList(B2B_PRESET ? [] : collectSelectedVariants());
	    }

	    function captureStandardSelectionState() {
	      return {
	        stickers: { ...stickerSelection },
	        beerdeckel: beerdeckelSelection,
	        flags: Array.from(flagVariantState.entries()),
	        tshirts: Array.from(tshirtVariantState.entries()),
	        hoodies: Array.from(hoodieVariantState.entries()),
	        mugs: Array.from(mugVariantState.entries()),
	        express: Array.from(expressSelectionByGroupKey.entries())
	      };
	    }

	    function restoreStandardSelectionState(snapshot) {
	      if (!snapshot) return;
	      Object.assign(stickerSelection, snapshot.stickers || {});
	      beerdeckelSelection = parseInt(snapshot.beerdeckel, 10) || 0;
	      const restoreMap = (target, entries) => {
	        target.clear();
	        (entries || []).forEach(([key, value]) => {
	          const quantity = parseInt(value, 10) || 0;
	          if (quantity > 0 || target === expressSelectionByGroupKey) target.set(key, value);
	        });
	      };
	      restoreMap(flagVariantState, snapshot.flags);
	      restoreMap(tshirtVariantState, snapshot.tshirts);
	      restoreMap(hoodieVariantState, snapshot.hoodies);
	      restoreMap(mugVariantState, snapshot.mugs);
	      restoreMap(expressSelectionByGroupKey, snapshot.express);
	    }

	    function setSelectorModeButton(mode) {
	      if (!modeSwitch) return;
	      modeSwitch.querySelectorAll('[data-selector-mode]').forEach((button) => {
	        const active = button.dataset.selectorMode === mode;
	        button.classList.toggle('is-active', active);
	        button.setAttribute('aria-pressed', String(active));
	      });
	    }

	    function showB2bCatalog() {
	      if (!b2bCatalog || !productGrid) return;
	      renderB2bCatalog();
	      renderB2bSavedSelections();
	      b2bCatalog.hidden = false;
	      productGrid.hidden = true;
	      const banner = root.querySelector(':scope > .b2b-editor-banner');
	      if (banner) banner.hidden = true;
	      setSelectorModeButton('b2b');
	      b2bCatalog.scrollIntoView({ block: 'start', behavior: 'smooth' });
	    }

	    function showProductGrid(mode = B2B_PRESET ? 'b2b' : 'single') {
	      if (b2bCatalog) b2bCatalog.hidden = true;
	      if (productGrid) productGrid.hidden = false;
	      const banner = root.querySelector(':scope > .b2b-editor-banner');
	      if (banner) banner.hidden = mode !== 'b2b';
	      setSelectorModeButton(mode);
	    }

	    function renderB2bCatalogCard(card) {
	      const packageKey = String(card?.dataset?.b2bChoice || '');
	      const bundle = B2B_BUNDLE_CONFIG[packageKey];
	      const ui = card && card.querySelector('[data-b2b-choice-ui]');
	      if (!bundle || !ui) return;

	      if (!card.dataset.b2bTier) {
	        card.dataset.b2bTier = B2B_PRESET?.key === packageKey
	          ? B2B_PRESET.tierKey
	          : Object.keys(bundle.tiers)[0];
	      }
	      const currentShape = getShapeType();
	      card.dataset.b2bShape = B2B_PRESET?.key === packageKey
	        ? B2B_PRESET.shape
	        : (currentShape === 'rect' ? 'rect' : 'oval');

	      const tierKey = bundle.tiers[card.dataset.b2bTier]
	        ? card.dataset.b2bTier
	        : Object.keys(bundle.tiers)[0];
	      const tier = bundle.tiers[tierKey];
	      const shape = card.dataset.b2bShape === 'rect' ? 'rect' : 'oval';
	      const saving = Math.max(0, (tier.compareAtCents || 0) - (tier.priceCents || 0));
	      const contents = b2bContentsForTier(tier);

	      card.dataset.b2bTier = tierKey;
	      card.dataset.b2bShape = shape;
	      card.classList.toggle(
	        'is-selected',
	        !!B2B_PRESET && B2B_PRESET.key === packageKey && B2B_PRESET.tierKey === tierKey && B2B_PRESET.shape === shape
	      );

	      ui.innerHTML = `
	        <div class="selector-b2b-package__field">
	          <span class="selector-b2b-package__label">Paketgröße</span>
	          <div class="selector-b2b-package__segments" role="group" aria-label="Paketgröße für ${escapeHtml(bundle.title)}">
	            ${Object.entries(bundle.tiers).map(([key, option]) => `
	              <button
	                aria-pressed="${key === tierKey ? 'true' : 'false'}"
	                data-b2b-tier-choice="${escapeHtml(key)}"
	                type="button"
	              >${escapeHtml(option.label)}</button>
	            `).join('')}
	          </div>
	        </div>
	        <ul class="selector-b2b-package__contents" role="list">
	          ${contents.map(([label, meta]) => `
	            <li><span>${escapeHtml(label)}</span><small>${escapeHtml(meta)}</small></li>
	          `).join('')}
	          <li><span>1 gemeinsames Design</span><small>auf allen Produkten</small></li>
	        </ul>
	        <div class="selector-b2b-package__design-shape">
	          <span>Form deines Designs</span>
	          <strong>${shape === 'rect' ? 'Rechteckig' : 'Oval'}</strong>
	        </div>
	        <div class="selector-b2b-package__price">
	          <div><span>Paketpreis</span><strong>${escapeHtml(formatMoney(tier.priceCents))}</strong></div>
	          <div><del>${escapeHtml(formatMoney(tier.compareAtCents))}</del><span>${escapeHtml(formatMoney(saving))} sparen</span></div>
	        </div>
	        <button class="selector-b2b-package__choose" data-b2b-activate type="button">
	          Paket konfigurieren
	        </button>
	      `;
	    }

	    function renderB2bCatalog() {
	      if (!b2bCatalog) return;
	      b2bCatalog.querySelectorAll('[data-b2b-choice]').forEach(renderB2bCatalogCard);
	    }

	    function updateB2bUrl(preset) {
	      try {
	        const url = new URL(window.location.href);
	        ['b2b', 'tier', 'shape'].forEach((key) => url.searchParams.delete(key));
	        if (preset) {
	          url.searchParams.set('b2b', preset.key);
	          url.searchParams.set('tier', preset.tierKey);
	          url.searchParams.set('shape', preset.shape);
	        }
	        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
	      } catch (_) { /* noop */ }
	    }

	    function clearB2bSelectionState() {
	      stickerSelection.normalOval = 0;
	      stickerSelection.normalRect = 0;
	      stickerSelection.miniOval = 0;
	      stickerSelection.miniRect = 0;
	      beerdeckelSelection = 0;
	      flagVariantState.clear();
	      tshirtVariantState.clear();
	      hoodieVariantState.clear();
	      mugVariantState.clear();
	      expressSelectionByGroupKey.clear();
	      root.querySelectorAll(
	        'input[data-input="tshirt-variant"], input[data-input="hoodie-variant"], input[data-input="mug-variant"], input[data-input="flag-variant"]'
	      ).forEach((input) => {
	        input.value = '0';
	      });
	    }

	    function restoreStandardSelectorControls() {
	      root.querySelectorAll('[data-product]').forEach((card) => {
	        card.hidden = false;
	        card.style.display = '';
	        card.classList.remove('is-b2b-fixed');
	        const headerButton = card.querySelector('.product-card__header-btn');
	        if (headerButton) {
	          headerButton.disabled = false;
	          headerButton.removeAttribute('aria-disabled');
	        }
	      });
	      root.querySelectorAll(
	        '[data-pill-group^="stickers-qty-"] .pill, [data-product="flag"] input, [data-product="flag"] [data-qty-step], [data-product="mug"] input, [data-product="mug"] [data-qty-step]'
	      ).forEach((control) => {
	        control.disabled = false;
	        control.setAttribute('aria-disabled', 'false');
	      });
	      root.querySelectorAll('[data-product="flag"] [data-flag-size], [data-product="mug"] .mug-variant-card').forEach((card) => {
	        card.hidden = false;
	        card.style.display = '';
	      });
	      root.querySelectorAll('[data-input="tshirt-variant"]').forEach((input) => {
	        input.max = '99';
	      });
	      document.querySelectorAll('[data-shape-choice]').forEach((button) => {
	        button.disabled = false;
	        button.setAttribute('aria-disabled', 'false');
	        if (button.title === 'Die Form wurde im Firmenpaket festgelegt.') button.removeAttribute('title');
	      });
	    }

	    function deactivateB2bPreset(targetMode = 'single') {
	      const hadActivePreset = !!B2B_PRESET;
	      if (hadActivePreset) {
	        B2B_PRESET = null;
	        window.__nhB2bBundlePreset = null;
	        updateB2bUrl(null);
	        clearB2bSelectionState();
	        restoreStandardSelectorControls();
	        restoreStandardSelectionState(standardSelectionSnapshot);
	        standardSelectionSnapshot = null;
	      }
	      root.classList.remove('shopify-selector--b2b');
	      delete root.dataset.b2bDecorated;
	      root.querySelector(':scope > .b2b-editor-banner')?.remove();
	      if (selectorTitle) selectorTitle.textContent = selectorDefaults.title;
	      if (selectorSubtitle) selectorSubtitle.textContent = selectorDefaults.subtitle;
	      if (summaryHint) {
	        summaryHint.textContent = B2B_SELECTIONS.length
	          ? 'Firmenpakete und Einzelprodukte bleiben in dieser gemeinsamen Auswahl erhalten.'
	          : selectorDefaults.summaryHint;
	      }
	      if (checkoutHint) checkoutHint.textContent = selectorDefaults.checkoutHint;
	      if (checkoutButton?.firstChild) checkoutButton.firstChild.textContent = selectorDefaults.checkout;
	      if (targetMode === 'b2b') {
	        showB2bCatalog();
	      } else {
	        showProductGrid('single');
	      }
	      applyShapeAndSync(true);
	      renderB2bCatalog();
	      renderB2bSavedSelections();
	    }

	    function activateB2bPreset(card) {
	      const packageKey = String(card?.dataset?.b2bChoice || '');
	      const bundle = B2B_BUNDLE_CONFIG[packageKey];
	      if (!bundle) return;
	      const tierKey = bundle.tiers[card.dataset.b2bTier]
	        ? card.dataset.b2bTier
	        : Object.keys(bundle.tiers)[0];
	      const currentShape = getShapeType();
	      const shape = currentShape === 'rect' ? 'rect' : 'oval';

	      if (!B2B_PRESET) standardSelectionSnapshot = captureStandardSelectionState();
	      clearB2bSelectionState();
	      B2B_PRESET = {
	        key: packageKey,
	        title: bundle.title,
	        tierKey,
	        tier: bundle.tiers[tierKey],
	        shape
	      };
	      window.__nhB2bBundlePreset = B2B_PRESET;
	      updateB2bUrl(B2B_PRESET);
	      showProductGrid('b2b');
	      decorateB2bSelector();
	      enforceB2bCanvasShape();
	      applyShapeAndSync(true);
	      renderB2bCatalog();
	    }

	    function queueActiveB2bPreset() {
	      if (!B2B_PRESET) throw new Error('Bitte wähle zuerst ein Firmenpaket aus.');
	      const requiredShirts = B2B_PRESET.tier.shirts || 0;
	      const selectedShirts = totalTshirtQuantity();
	      if (requiredShirts && selectedShirts !== requiredShirts) {
	        throw new Error(`Bitte verteile genau ${requiredShirts} T-Shirts auf Farbe und Größe. Aktuell verteilt: ${selectedShirts}.`);
	      }

	      const queuedPreset = B2B_PRESET;
	      const item = {
	        uid: `b2b-${Date.now().toString(36)}-${++b2bSelectionSequence}`,
	        key: queuedPreset.key,
	        title: queuedPreset.title,
	        tierKey: queuedPreset.tierKey,
	        tier: queuedPreset.tier,
	        shape: queuedPreset.shape,
	        quantity: 1,
	        shirtDistribution: Array.from(tshirtVariantState.entries()).filter(([, quantity]) => quantity > 0)
	      };
	      B2B_SELECTIONS.push(item);
	      deactivateB2bPreset('b2b');
	      renderB2bSavedSelections();
	      refreshTotal();
	      return item;
	    }

	    window.nhQueueActiveB2bPreset = queueActiveB2bPreset;

	    function setSelectionValidation(message = '') {
	      if (!selectionValidation) return;
	      selectionValidation.textContent = message;
	      selectionValidation.hidden = !message;
	    }

	    refreshTotal = () => {
	      const checkoutButton = root?.querySelector('#shopify-checkout-btn');
	      if (B2B_PRESET) {
	        if (totalLabel) totalLabel.textContent = `Paketpreis: ${formatMoney(B2B_PRESET.tier.priceCents)}`;
	        if (checkoutButton) {
	          const requiredShirts = B2B_PRESET.tier.shirts || 0;
	          const selectedShirts = totalTshirtQuantity();
	          const packageReady = !requiredShirts || selectedShirts === requiredShirts;
	          checkoutButton.disabled = !packageReady;
	          checkoutButton.setAttribute('aria-disabled', String(!packageReady));
	          checkoutButton.title = packageReady
	            ? ''
	            : `Noch ${Math.max(0, requiredShirts - selectedShirts)} T-Shirt-Größen verteilen`;
	          setSelectionValidation(packageReady
	            ? ''
	            : `Dieses Paket ist noch nicht vollständig: ${selectedShirts} von ${requiredShirts} T-Shirts verteilt.`);
	        }
	        renderB2bSelectionList();
	        return;
	      }
	      const selection = collectSelectedVariants();
	      const incompleteBundles = b2bIncompleteSavedSelections();
	      if (checkoutButton) {
	        const hasSelection = selection.length > 0 || B2B_SELECTIONS.length > 0;
	        const canCheckout = hasSelection && incompleteBundles.length === 0;
	        checkoutButton.disabled = !canCheckout;
	        checkoutButton.setAttribute('aria-disabled', String(!canCheckout));
	        checkoutButton.title = incompleteBundles.length
	          ? 'Bitte zuerst alle T-Shirt-Größen in den Firmenpaketen vervollständigen.'
	          : '';
	      }
	      if (incompleteBundles.length) {
	        const labels = incompleteBundles
	          .slice(0, 2)
	          .map((item) => `${item.title} · ${item.tier.label}`);
	        const additional = incompleteBundles.length > 2
	          ? ` und ${incompleteBundles.length - 2} ${incompleteBundles.length - 2 === 1 ? 'weiterem Paket' : 'weiteren Paketen'}`
	          : '';
	        setSelectionValidation(
	          `Öffne bei ${labels.join(', ')}${additional} „Größenverteilung anpassen“ und vervollständige die T-Shirt-Größen.`
	        );
	      } else {
	        setSelectionValidation('');
	      }
	      selection.forEach(item => ensurePriceLoaded(item.key));
	      pruneExpressSelections(selection);
	      const subtotal = sumPrices(selection);
	      const surcharge = expressSurchargeForSelection(selection);
	      const pricesReady = selection.every(item => {
	        const entry = priceCache.get(item.key);
	        return entry && entry.ready && entry.price != null;
	      });
	      const total = subtotal + surcharge + b2bSavedTotalCents();
	      if (totalLabel) {
	        totalLabel.textContent = pricesReady && total > 0 ? `Gesamt: ${formatMoney(total)}` : 'Gesamt: —';
	      }
	      try { renderSelectionList(selection); } catch (err) { /* noop */ }
	    };

    function enforceShapeAvailability() {
      const shape = getShapeType(); // 'oval' | 'rect' | 'both'
      const allowOval = shape === 'oval' || shape === 'both';
      const allowRect = shape === 'rect' || shape === 'both';

	      const reorderAvailability = (() => {
	        try {
	          const enabled = window.__nhUseReorderAvailability === true || (typeof isReorderPage === 'function' && isReorderPage());
	          if (!enabled) return null;
	        } catch (_) { /* noop */ }
	        const raw = window.__nhReorderAvailableProfiles;
	        return raw && typeof raw === 'object' ? raw : null;
	      })();

      const isProfileAvailable = (profileKey) => {
        if (!reorderAvailability) return true;
        return reorderAvailability[profileKey] === true;
      };

      const hasAnyFlag = (
        isProfileAvailable('flag_100x58') ||
        isProfileAvailable('flag_150x86') ||
        isProfileAvailable('flag_200x115') ||
        isProfileAvailable('flag_300x173')
      );

      const allowStickerNormalOval = allowOval && isProfileAvailable('sticker_normal_oval');
      const allowStickerMiniOval = allowOval && isProfileAvailable('sticker_mini_oval');
      const allowStickerNormalRect = allowRect && isProfileAvailable('sticker_normal_rect');
      const allowStickerMiniRect = allowRect && isProfileAvailable('sticker_mini_rect');
      const allowBeerdeckel = allowOval && isProfileAvailable('beerdeckel');
	      const allowFlag = hasAnyFlag;

      if (!allowStickerNormalOval) {
        stickerSelection.normalOval = 0;
      }
      if (!allowStickerMiniOval) {
        stickerSelection.miniOval = 0;
      }
      if (!allowBeerdeckel) {
        beerdeckelSelection = 0;
      }
      if (!allowStickerNormalRect) {
        stickerSelection.normalRect = 0;
      }
      if (!allowStickerMiniRect) {
        stickerSelection.miniRect = 0;
      }
      if (!allowFlag) {
        flagVariantState.clear();
      } else {
        flagVariantState.forEach((quantity, key) => {
          if (!quantity || !isProfileAvailable(key)) flagVariantState.delete(key);
        });
      }

      const disableGroups = (selector, disabled) => {
        const container = root || document;
        container.querySelectorAll(selector).forEach(group => {
          group.classList.toggle('is-disabled', !!disabled);
          const field = group.closest('.product-field');
          const displayTarget = field || group;
          displayTarget.style.display = disabled ? 'none' : '';
          displayTarget.hidden = !!disabled;
          group.querySelectorAll('.pill').forEach(btn => {
            btn.disabled = !!disabled;
            btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          });
        });
      };

      disableGroups('[data-pill-group="stickers-qty-normal-oval"]', !allowStickerNormalOval);
      disableGroups('[data-pill-group="stickers-qty-mini-oval"]', !allowStickerMiniOval);
	      disableGroups('[data-pill-group="stickers-qty-normal-rect"]', !allowStickerNormalRect);
	      disableGroups('[data-pill-group="stickers-qty-mini-rect"]', !allowStickerMiniRect);
	      disableGroups('[data-pill-group="beerdeckel-qty"]', !allowBeerdeckel);

	      {
	        const container = root || document;
	        const setCardVisible = (productKey, visible) => {
	          const card = container.querySelector(`[data-product="${productKey}"]`);
	          if (!card) return;
	          card.style.display = visible ? '' : 'none';
	        };

	        if (reorderAvailability) {
	          const hasStickers = !!(allowStickerNormalOval || allowStickerNormalRect || allowStickerMiniOval || allowStickerMiniRect);
	          setCardVisible('stickers', hasStickers);

	          const allowTshirt = isProfileAvailable('tshirt');
	          setCardVisible('tshirt', allowTshirt);
	          if (!allowTshirt) {
	            tshirtVariantState.clear();
	            try {
	              container.querySelectorAll('input[data-input="tshirt-variant"]').forEach((el) => { el.value = '0'; });
	            } catch (_) { /* noop */ }
	          }

	          const allowHoodie = isProfileAvailable('hoodie');
	          setCardVisible('hoodie', allowHoodie);
	          if (!allowHoodie) {
	            hoodieVariantState.clear();
	            try {
	              container.querySelectorAll('input[data-input="hoodie-variant"]').forEach((el) => { el.value = '0'; });
	            } catch (_) { /* noop */ }
	          }

	          const allowMugCeramic = isProfileAvailable('mug_ceramic');
	          const allowMugEnamel = isProfileAvailable('mug_enamel');
	          const allowMug = allowMugCeramic || allowMugEnamel;
	          setCardVisible('mug', allowMug);
	          if (!allowMug) {
	            mugVariantState.clear();
	            try {
	              container.querySelectorAll('input[data-input="mug-variant"]').forEach((el) => { el.value = '0'; });
	            } catch (_) { /* noop */ }
	          } else {
	            try {
	              container.querySelectorAll('[data-product="mug"] .mug-variant-card').forEach((card) => {
	                const input = card.querySelector('input[data-input="mug-variant"]');
	                const type = input && input.dataset ? String(input.dataset.type || '') : '';
	                if (type === 'enamel') {
	                  card.style.display = allowMugEnamel ? '' : 'none';
	                } else if (type === 'ceramic') {
	                  card.style.display = allowMugCeramic ? '' : 'none';
	                }
	              });
	            } catch (_) { /* noop */ }
	            if (!allowMugCeramic) {
	              mugVariantState.delete('mug_ceramic');
	              try { container.querySelectorAll('input[data-input="mug-variant"][data-type="ceramic"]').forEach((el) => { el.value = '0'; }); } catch (_) { /* noop */ }
	            }
	            if (!allowMugEnamel) {
	              mugVariantState.delete('mug_enamel');
	              try { container.querySelectorAll('input[data-input="mug-variant"][data-type="enamel"]').forEach((el) => { el.value = '0'; }); } catch (_) { /* noop */ }
	            }
	          }
	        } else {
	          setCardVisible('stickers', true);
	          setCardVisible('tshirt', true);
	          setCardVisible('hoodie', true);
	          setCardVisible('mug', true);
	          try {
	            container.querySelectorAll('[data-product="mug"] .mug-variant-card').forEach((card) => { card.style.display = ''; });
	          } catch (_) { /* noop */ }
	        }
	      }

      const beerCard = (root || document).querySelector('[data-product="beerdeckel"]');
      if (beerCard) {
        beerCard.classList.toggle('is-disabled', !allowBeerdeckel);
        beerCard.style.display = (reorderAvailability && !allowBeerdeckel) ? 'none' : '';
        beerCard.setAttribute('aria-disabled', allowBeerdeckel ? 'false' : 'true');
        beerCard.style.opacity = allowBeerdeckel ? '' : '0.6';
        beerCard.querySelectorAll('button, .pill').forEach(node => {
          node.disabled = !allowBeerdeckel;
          node.setAttribute('aria-disabled', allowBeerdeckel ? 'false' : 'true');
        });
        const note = beerCard.querySelector('[data-beerdeckel-note]');
        if (note) {
          note.textContent = allowBeerdeckel ? '' : (allowOval ? 'Für dieses Design nicht verfügbar' : 'Nur bei ovaler Form bestellbar');
          note.style.display = allowBeerdeckel ? 'none' : '';
        }
      }

      const flagCard = (root || document).querySelector('[data-product="flag"]');
      if (flagCard) {
        flagCard.classList.toggle('is-disabled', !allowFlag);
        flagCard.style.display = (reorderAvailability && !allowFlag) ? 'none' : '';
        flagCard.setAttribute('aria-disabled', allowFlag ? 'false' : 'true');
        flagCard.style.opacity = allowFlag ? '' : '0.6';
        flagCard.querySelectorAll('.product-card__header-btn, .product-card__info-btn').forEach(node => {
          node.disabled = !allowFlag;
          node.setAttribute('aria-disabled', allowFlag ? 'false' : 'true');
        });
        flagCard.querySelectorAll('[data-flag-size]').forEach(sizeCard => {
          const input = sizeCard.querySelector('[data-input="flag-variant"]');
          const size = input && input.dataset ? String(input.dataset.size || '') : '';
          const key = size ? `flag_${size}` : '';
          const available = !!(allowFlag && key && isProfileAvailable(key));
          sizeCard.hidden = !!(reorderAvailability && !available);
          sizeCard.style.display = (reorderAvailability && !available) ? 'none' : '';
          sizeCard.querySelectorAll('input, [data-qty-step]').forEach(control => {
            control.disabled = !available;
            control.setAttribute('aria-disabled', available ? 'false' : 'true');
          });
          if (!available && key) {
            flagVariantState.delete(key);
            if (input) input.value = '0';
          }
        });
        const note = flagCard.querySelector('[data-flag-note]');
        if (note) {
          const usesWhiteFlagSurface = allowOval && !allowRect;
          note.textContent = !allowFlag
            ? 'Für dieses Design nicht verfügbar'
            : (usesWhiteFlagSurface
              ? 'Dein ovales Design bleibt vollständig sichtbar; die rechteckige Fahnenfläche außerhalb des Ovals wird weiß.'
              : '');
          note.style.display = (!allowFlag || usesWhiteFlagSurface) ? '' : 'none';
        }
      }
    }

    function stickerSummary() {
      const combos = [];
      if (stickerSelection.normalOval) {
        const key = `oval_normal_${stickerSelection.normalOval}`;
        ensurePriceLoaded(key);
        combos.push(`Normal Oval: ${stickerSelection.normalOval} Stk (${priceLabelForKey(key)})`);
      }
      if (stickerSelection.normalRect) {
        const key = `rect_normal_${stickerSelection.normalRect}`;
        ensurePriceLoaded(key);
        combos.push(`Normal Rechteckig: ${stickerSelection.normalRect} Stk (${priceLabelForKey(key)})`);
      }
      if (stickerSelection.miniOval) {
        const key = `oval_mini_${stickerSelection.miniOval}`;
        ensurePriceLoaded(key);
        combos.push(`Mini Oval: ${stickerSelection.miniOval} Stk (${priceLabelForKey(key)})`);
      }
      if (stickerSelection.miniRect) {
        const key = `rect_mini_${stickerSelection.miniRect}`;
        ensurePriceLoaded(key);
        combos.push(`Mini Rechteckig: ${stickerSelection.miniRect} Stk (${priceLabelForKey(key)})`);
      }
      return combos.length ? combos.join(' · ') : 'Noch nichts ausgewählt';
    }

    function beerdeckelSummary() {
      if (!beerdeckelSelection) return 'Noch nichts ausgewählt';
      const key = `beerdeckel_${beerdeckelSelection}`;
      ensurePriceLoaded(key);
      return `${beerdeckelSelection} Stk (${priceLabelForKey(key)})`;
    }

    const sizeLabels = {
      s: 'S',
      m: 'M',
      l: 'L',
      xl: 'XL',
      xxl: 'XXL',
      xxxl: 'XXXL'
    };
    const mugTypeLabels = {
      ceramic: 'Keramik',
      enamel: 'Emaille'
    };

    function hoodieSummary() {
      if (!hoodieVariantState.size) return 'Noch nichts ausgewählt';
      const bucket = { white: [], black: [] };
      let total = 0;
      hoodieVariantState.forEach((qty, key) => {
        if (!qty) return;
        total += qty;
        const [, color, size] = key.split('_');
        const sizeLabel = (size || '').toUpperCase();
        ensurePriceLoaded(key);
        const label = `${sizeLabel}: ${qty} × ${priceLabelForKey(key)}`;
        if (bucket[color]) bucket[color].push(label);
      });
      const colorParts = [];
      if (bucket.white.length) colorParts.push(`Weiß (${bucket.white.join(', ')})`);
      if (bucket.black.length) colorParts.push(`Schwarz (${bucket.black.join(', ')})`);
      const qtyLabel = total === 1 ? '1 Stück' : `${total} Stück`;
      return colorParts.length ? `${qtyLabel} · ${colorParts.join(' · ')}` : qtyLabel;
    }

    function flagSummary() {
      if (!flagVariantState.size) return 'Noch nichts ausgewählt';
      let total = 0;
      const selections = [];
      flagVariantState.forEach((quantity, key) => {
        if (!quantity) return;
        total += quantity;
        const size = key.slice('flag_'.length);
        ensurePriceLoaded(key);
        selections.push({ quantity, label: flagSizeLabel(size) });
      });
      const quantityLabel = total === 1 ? '1 Stück' : `${total} Stück`;
      if (selections.length === 1) return `${quantityLabel} · ${selections[0].label}`;
      return selections.length ? `${quantityLabel} · ${selections.length} Größen` : quantityLabel;
    }

    function totalTshirtQuantity() {
      let total = 0;
      tshirtVariantState.forEach(qty => { total += qty || 0; });
      return total;
    }

    function tshirtSummary() {
      if (!tshirtVariantState.size) return 'Noch nichts ausgewählt';
      const total = totalTshirtQuantity();
      const bucket = {
        white: [],
        black: []
      };
      tshirtVariantState.forEach((qty, key) => {
        if (!qty) return;
        const [, color, size] = key.split('_');
        const sizeLabel = sizeLabels[size] || size.toUpperCase();
        ensurePriceLoaded(key);
        const label = `${sizeLabel}: ${qty} × ${priceLabelForKey(key)}`;
        if (bucket[color]) bucket[color].push(label);
      });
      const colorParts = [];
      if (bucket.white.length) colorParts.push(`Weiß (${bucket.white.join(', ')})`);
      if (bucket.black.length) colorParts.push(`Schwarz (${bucket.black.join(', ')})`);
      const qtyLabel = total === 1 ? '1 Stück' : `${total} Stück`;
      return colorParts.length ? `${qtyLabel} · ${colorParts.join(' · ')}` : qtyLabel;
    }

    function totalMugQuantity() {
      let total = 0;
      mugVariantState.forEach(qty => { total += qty || 0; });
      return total;
    }

    function mugSummary() {
      if (!mugVariantState.size) return 'Noch nichts ausgewählt';
      const total = totalMugQuantity();
      const parts = [];
      mugVariantState.forEach((qty, key) => {
        if (!qty) return;
        const [, type] = key.split('_');
        const label = mugTypeLabels[type] || type;
        ensurePriceLoaded(key);
        parts.push(`${label}: ${qty} × ${priceLabelForKey(key)}`);
      });
      const qtyLabel = total === 1 ? '1 Stück' : `${total} Stück`;
      return parts.length ? `${qtyLabel} · ${parts.join(' · ')}` : qtyLabel;
    }

  function syncStickerInputs() {
    zeroVariantKeys(STICKER_VARIANT_KEYS);
    if (stickerSelection.normalOval) setVariantQuantity(`oval_normal_${stickerSelection.normalOval}`, 1);
    if (stickerSelection.normalRect) setVariantQuantity(`rect_normal_${stickerSelection.normalRect}`, 1);
    if (stickerSelection.miniOval) setVariantQuantity(`oval_mini_${stickerSelection.miniOval}`, 1);
    if (stickerSelection.miniRect) setVariantQuantity(`rect_mini_${stickerSelection.miniRect}`, 1);
  }

    function syncBeerdeckelInputs() {
      zeroVariantKeys(BEERDECKEL_VARIANT_KEYS);
      if (beerdeckelSelection) setVariantQuantity(`beerdeckel_${beerdeckelSelection}`, 1);
    }

    function syncFlagInputs() {
      zeroVariantKeys(FLAG_VARIANT_KEYS);
      flagVariantState.forEach((quantity, key) => {
        if (quantity > 0) setVariantQuantity(key, quantity);
      });
    }

    function syncStickerPills() {
      const pairs = [
        ['stickers-qty-normal-oval', stickerSelection.normalOval],
        ['stickers-qty-normal-rect', stickerSelection.normalRect],
        ['stickers-qty-mini-oval', stickerSelection.miniOval],
        ['stickers-qty-mini-rect', stickerSelection.miniRect]
      ];
      pairs.forEach(([groupKey, value]) => {
        const group = root.querySelector(`[data-pill-group="${groupKey}"]`);
        if (!group) return;
        group.querySelectorAll('.pill').forEach(btn => btn.classList.remove('is-active'));
        const target = group.querySelector(`.pill[data-value="${value}"]`);
        if (target) target.classList.add('is-active');
      });
    }

    function syncBeerdeckelPills() {
      const group = root.querySelector('[data-pill-group="beerdeckel-qty"]');
      if (!group) return;
      group.querySelectorAll('.pill').forEach(btn => btn.classList.remove('is-active'));
      const target = group.querySelector(`.pill[data-value="${beerdeckelSelection}"]`);
      if (target) target.classList.add('is-active');
    }

    function syncTshirtInputs() {
      zeroVariantKeys(TSHIRT_VARIANT_KEYS);
      tshirtVariantState.forEach((qty, key) => {
        if (qty > 0) setVariantQuantity(key, qty);
      });
    }

    function syncMugInputs() {
      zeroVariantKeys(MUG_VARIANT_KEYS);
      mugVariantState.forEach((qty, key) => {
        if (qty > 0) setVariantQuantity(key, qty);
      });
    }

    function syncHoodieInputs() {
      zeroVariantKeys(HOODIE_VARIANT_KEYS);
      hoodieVariantState.forEach((qty, key) => {
        if (qty > 0) setVariantQuantity(key, qty);
      });
    }

	    function updateSummaries() {
      if (summaries.stickers) summaries.stickers.textContent = stickerSummary();
      if (summaries.beerdeckel) {
        const shape = getShapeType();
        const allowOval = shape === 'oval' || shape === 'both';
        summaries.beerdeckel.textContent = allowOval ? beerdeckelSummary() : 'Nur bei ovaler Form bestellbar';
      }
      if (summaries.flag) summaries.flag.textContent = flagSummary();
      if (summaries.hoodie) summaries.hoodie.textContent = hoodieSummary();
      if (summaries.tshirt) summaries.tshirt.textContent = tshirtSummary();
	      if (summaries.mug) summaries.mug.textContent = mugSummary();
	      if (B2B_PRESET) {
	        const tier = B2B_PRESET.tier;
	        const shapeLabel = B2B_PRESET.shape === 'rect' ? 'Rechteckig' : 'Oval';
	        if (summaries.stickers) summaries.stickers.textContent = `${tier.stickers} Normal${tier.mini ? ` + ${tier.mini} Mini` : ''} · ${shapeLabel} · im Paket`;
	        if (summaries.tshirt && tier.shirts) summaries.tshirt.textContent = `${tier.shirts} enthalten · unten Größen verteilen`;
	        if (summaries.mug && tier.mugs) summaries.mug.textContent = `${tier.mugs} Keramiktassen · im Paket`;
	        if (summaries.flag && tier.flags) summaries.flag.textContent = `${tier.flags} × 150 × 86,5 cm · im Paket`;
	      }
	      try { renderSelectionList(collectSelectedVariants()); } catch (err) { /* noop */ }
	    }
    refreshSummaries = updateSummaries;

    function hydrateTshirtState() {
      tshirtVariantState.clear();
      root.querySelectorAll('[data-input="tshirt-variant"]').forEach(input => {
        const color = input.dataset.color === 'black' ? 'black' : 'white';
        const size = (input.dataset.size || '').toLowerCase();
        const value = clamp(parseInt(input.value, 10) || 0, 0, 99);
        input.value = value;
        if (value > 0) {
          const key = `tshirt_${color}_${size}`;
          tshirtVariantState.set(key, value);
        }
      });
    }

    function hydrateMugState() {
      mugVariantState.clear();
      root.querySelectorAll('[data-input="mug-variant"]').forEach(input => {
        const type = input.dataset.type === 'enamel' ? 'enamel' : 'ceramic';
        const value = clamp(parseInt(input.value, 10) || 0, 0, 99);
        input.value = value;
        if (value > 0) {
          const key = `mug_${type}`;
          mugVariantState.set(key, value);
        }
      });
    }

    function hydrateFlagState() {
      flagVariantState.clear();
      root.querySelectorAll('[data-input="flag-variant"]').forEach(input => {
        const size = String(input.dataset.size || '');
        const value = clamp(parseInt(input.value, 10) || 0, 0, 99);
        input.value = value;
        if (size && value > 0) flagVariantState.set(`flag_${size}`, value);
      });
    }

    function hydrateHoodieState() {
      hoodieVariantState.clear();
      root.querySelectorAll('[data-input="hoodie-variant"]').forEach(input => {
        const color = input.dataset.color === 'black' ? 'black' : 'white';
        const size = (input.dataset.size || '').toLowerCase();
        const value = clamp(parseInt(input.value, 10) || 0, 0, 99);
        input.value = value;
        if (value > 0) {
          const key = `hoodie_${color}_${size}`;
          hoodieVariantState.set(key, value);
        }
      });
    }

	    function updateB2bShirtConfigState() {
	      if (!b2bShirtConfig || !B2B_PRESET?.tier?.shirts || b2bShirtConfig.hidden) return;
	      const required = B2B_PRESET.tier.shirts;
	      const total = totalTshirtQuantity();
	      const remaining = Math.max(0, required - total);
	      b2bShirtConfig.classList.toggle('is-complete', total === required);

	      const status = b2bShirtConfig.querySelector('[data-b2b-shirt-status]');
	      if (status) status.textContent = `${total} von ${required}`;
	      const help = b2bShirtConfig.querySelector('[data-b2b-shirt-help]');
	      if (help) {
	        help.textContent = remaining
	          ? `Noch ${remaining} ${remaining === 1 ? 'T-Shirt' : 'T-Shirts'} verteilen.`
	          : 'Verteilung vollständig. Das Paket kann hinzugefügt werden.';
	      }
	      const progress = b2bShirtConfig.querySelector('[data-b2b-shirt-progress]');
	      if (progress) progress.style.width = `${Math.min(100, (total / required) * 100)}%`;

	      b2bShirtConfig.querySelectorAll('[data-b2b-shirt-value]').forEach((input) => {
	        const color = input.dataset.color === 'black' ? 'black' : 'white';
	        const size = String(input.dataset.size || '').toLowerCase();
	        const key = `tshirt_${color}_${size}`;
	        const current = Math.max(0, parseInt(tshirtVariantState.get(key), 10) || 0);
	        let otherTotal = 0;
	        tshirtVariantState.forEach((quantity, stateKey) => {
	          if (stateKey !== key) otherTotal += quantity || 0;
	        });
	        input.value = String(current);
	        input.max = String(Math.max(0, required - otherTotal));
	        const control = input.closest('[data-b2b-shirt-control]');
	        const minus = control?.querySelector('[data-b2b-shirt-step="-1"]');
	        const plus = control?.querySelector('[data-b2b-shirt-step="1"]');
	        if (minus) minus.disabled = current <= 0;
	        if (plus) plus.disabled = total >= required;
	      });
	    }

	    function renderB2bShirtConfig() {
	      if (!b2bShirtConfig) return;
	      const required = B2B_PRESET?.tier?.shirts || 0;
	      if (!B2B_PRESET || !required) {
	        b2bShirtConfig.hidden = true;
	        b2bShirtConfig.removeAttribute('data-b2b-shirt-signature');
	        return;
	      }

	      const signature = `${B2B_PRESET.key}:${B2B_PRESET.tierKey}:${required}`;
	      if (b2bShirtConfig.dataset.b2bShirtSignature !== signature) {
	        const colors = [
	          { key: 'white', label: 'Weiß' },
	          { key: 'black', label: 'Schwarz' }
	        ];
	        const sizes = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl'];
	        const colorMarkup = colors.map((color) => `
	          <div class="selector-b2b-shirt-config__color">
	            <div class="selector-b2b-shirt-config__color-title">
	              <span aria-hidden="true" class="selector-b2b-shirt-config__swatch is-${color.key}"></span>
	              <strong>${color.label}</strong>
	            </div>
	            <div class="selector-b2b-shirt-config__sizes">
	              ${sizes.map((size) => {
	                const sizeLabel = sizeLabels[size] || size.toUpperCase();
	                const accessibleName = `${color.label} · Größe ${sizeLabel}`;
	                return `
	                  <div class="selector-b2b-shirt-config__size">
	                    <span>${sizeLabel}</span>
	                    <div class="selector-b2b-shirt-config__control" data-b2b-shirt-control>
	                      <button aria-label="Weniger ${accessibleName}" data-b2b-shirt-step="-1" data-color="${color.key}" data-size="${size}" type="button">−</button>
	                      <input aria-label="${accessibleName} im Firmenpaket" data-b2b-shirt-value data-color="${color.key}" data-size="${size}" inputmode="numeric" min="0" pattern="[0-9]*" type="number" value="0">
	                      <button aria-label="Mehr ${accessibleName}" data-b2b-shirt-step="1" data-color="${color.key}" data-size="${size}" type="button">+</button>
	                    </div>
	                  </div>
	                `;
	              }).join('')}
	            </div>
	          </div>
	        `).join('');

	        b2bShirtConfig.innerHTML = `
	          <div class="selector-b2b-shirt-config__header">
	            <div>
	              <span>Im Paket enthalten</span>
	              <strong>T-Shirt-Größen verteilen</strong>
	            </div>
	            <b data-b2b-shirt-status>0 von ${required}</b>
	          </div>
	          <p>Lege Farbe und Größe für insgesamt ${required} T-Shirts fest. Die Verteilung gilt je Paket.</p>
	          <div class="selector-b2b-shirt-config__progress" aria-hidden="true">
	            <span data-b2b-shirt-progress></span>
	          </div>
	          <div class="selector-b2b-shirt-config__colors">${colorMarkup}</div>
	          <p class="selector-b2b-shirt-config__help" data-b2b-shirt-help></p>
	        `;
	        b2bShirtConfig.dataset.b2bShirtSignature = signature;
	      }

	      b2bShirtConfig.hidden = false;
	      updateB2bShirtConfigState();
	    }

	    function setB2bShirtQuantity(colorValue, sizeValue, requestedQuantity) {
	      if (!B2B_PRESET?.tier?.shirts) return;
	      const color = colorValue === 'black' ? 'black' : 'white';
	      const size = String(sizeValue || '').toLowerCase();
	      const key = `tshirt_${color}_${size}`;
	      let otherTotal = 0;
	      tshirtVariantState.forEach((quantity, stateKey) => {
	        if (stateKey !== key) otherTotal += quantity || 0;
	      });
	      const maxForSize = Math.max(0, B2B_PRESET.tier.shirts - otherTotal);
	      const quantity = clamp(parseInt(requestedQuantity, 10) || 0, 0, maxForSize);
	      const sourceInput = root.querySelector(
	        `[data-input="tshirt-variant"][data-color="${color}"][data-size="${size}"]`
	      );
	      if (sourceInput) {
	        sourceInput.value = String(quantity);
	        sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
	      } else {
	        if (quantity > 0) tshirtVariantState.set(key, quantity);
	        else tshirtVariantState.delete(key);
	        syncUi();
	      }
	    }

	    function enforceB2bLocks() {
	      if (!B2B_PRESET) return;
	      const tier = B2B_PRESET.tier;
	      const isRect = B2B_PRESET.shape === 'rect';

	      stickerSelection.normalOval = isRect ? 0 : tier.stickers;
	      stickerSelection.normalRect = isRect ? tier.stickers : 0;
	      stickerSelection.miniOval = !isRect && tier.mini ? tier.mini : 0;
	      stickerSelection.miniRect = isRect && tier.mini ? tier.mini : 0;
	      beerdeckelSelection = 0;
	      hoodieVariantState.clear();
	      mugVariantState.clear();
	      if (tier.mugs) mugVariantState.set('mug_ceramic', tier.mugs);
	      flagVariantState.clear();
	      if (tier.flags) flagVariantState.set('flag_150x86', tier.flags);

	      const visibleProducts = new Set(['stickers', 'mug']);
	      if (tier.shirts) visibleProducts.add('tshirt');
	      if (tier.flags) visibleProducts.add('flag');
	      root.querySelectorAll('[data-product]').forEach((card) => {
	        const key = card.getAttribute('data-product');
	        const isVisible = visibleProducts.has(key);
	        const isFixed = isVisible;
	        card.style.display = isVisible ? '' : 'none';
	        card.classList.toggle('is-b2b-fixed', isFixed);
	        const headerButton = card.querySelector('.product-card__header-btn');
	        const body = card.querySelector('.product-card__body');
	        if (headerButton) {
	          headerButton.disabled = isFixed;
	          headerButton.setAttribute('aria-disabled', String(isFixed));
	          if (isFixed) headerButton.setAttribute('aria-expanded', 'false');
	        }
	        if (isFixed && body) body.hidden = true;
	      });

	      root.querySelectorAll('[data-pill-group^="stickers-qty-"] .pill').forEach((button) => {
	        button.disabled = true;
	        button.setAttribute('aria-disabled', 'true');
	      });
	      root.querySelectorAll('[data-product="flag"] input, [data-product="flag"] [data-qty-step]').forEach((control) => {
	        control.disabled = true;
	        control.setAttribute('aria-disabled', 'true');
	      });
	      root.querySelectorAll('[data-product="flag"] [data-flag-size]').forEach((card) => {
	        const input = card.querySelector('[data-input="flag-variant"]');
	        const included = !!(tier.flags && input && input.dataset.size === '150x86');
	        card.style.display = included ? '' : 'none';
	        card.hidden = !included;
	        if (input) input.value = included ? String(tier.flags) : '0';
	      });
	      root.querySelectorAll('[data-product="mug"] input, [data-product="mug"] [data-qty-step]').forEach((control) => {
	        control.disabled = true;
	        control.setAttribute('aria-disabled', 'true');
	      });
	      root.querySelectorAll('[data-input="mug-variant"]').forEach((input) => {
	        input.value = input.dataset.type === 'ceramic' ? String(tier.mugs || 0) : '0';
	      });
	      root.querySelectorAll('[data-product="mug"] .mug-variant-card').forEach((card) => {
	        const input = card.querySelector('[data-input="mug-variant"]');
	        card.style.display = input && input.dataset.type === 'ceramic' ? '' : 'none';
	      });
	      root.querySelectorAll('[data-input="tshirt-variant"]').forEach((input) => {
	        input.max = String(tier.shirts || 0);
	      });
	    }

	    function decorateB2bSelector() {
	      if (!B2B_PRESET) return;
	      root.dataset.b2bDecorated = 'true';
	      root.classList.add('shopify-selector--b2b');
	      if (selectorTitle) selectorTitle.textContent = `${B2B_PRESET.title} · ${B2B_PRESET.tier.label}`;
	      if (selectorSubtitle) {
	        selectorSubtitle.textContent = B2B_PRESET.tier.shirts
	          ? 'Verteile die enthaltenen T-Shirts auf Farbe und Größe und füge das Paket danach deiner Auswahl hinzu.'
	          : 'Prüfe die festen Paketbestandteile und füge das Paket danach deiner gemeinsamen Auswahl hinzu.';
	      }
	      let banner = root.querySelector(':scope > .b2b-editor-banner');
	      if (!banner) {
	        banner = document.createElement('div');
	        banner.className = 'b2b-editor-banner';
	        if (modeSwitch) {
	          modeSwitch.insertAdjacentElement('afterend', banner);
	        } else {
	          root.prepend(banner);
	        }
	      }
	      banner.innerHTML = `
	        <div><span>Firmenpaket</span><strong>${escapeHtml(B2B_PRESET.title)} · ${escapeHtml(B2B_PRESET.tier.label)}</strong></div>
	        <div><span>Aufkleberform</span><strong>${B2B_PRESET.shape === 'rect' ? 'Rechteckig' : 'Oval'}</strong></div>
	        <div><span>Paketpreis</span><strong>${escapeHtml(formatMoney(B2B_PRESET.tier.priceCents))}</strong></div>
	      `;
	      if (summaryHint) summaryHint.textContent = 'Dieses Paket wird erst nach deiner Bestätigung zur gemeinsamen Auswahl hinzugefügt.';
	      if (checkoutHint) {
	        checkoutHint.textContent = 'Nach dem Hinzufügen kannst du weitere Firmenpakete oder Einzelprodukte auswählen und anschließend alles gemeinsam bestellen.';
	      }
	      if (checkoutButton?.firstChild) checkoutButton.firstChild.textContent = 'Paket zur Auswahl hinzufügen ';
	    }

	    let lastShapeApplied = null;
	    function applyShapeAndSync(force = false) {
      const shape = getShapeType();
      if (!force && shape === lastShapeApplied) return;
	      lastShapeApplied = shape;
	      enforceShapeAvailability();
	      enforceB2bLocks();
	      syncStickerInputs();
      syncStickerPills();
      syncBeerdeckelInputs();
      syncBeerdeckelPills();
      syncFlagInputs();
      hydrateHoodieState();
      syncTshirtInputs();
      syncHoodieInputs();
      syncMugInputs();
      updateSummaries();
      renderB2bShirtConfig();
      refreshTotal();
    }

    function syncUi() {
      applyShapeAndSync(true);
      requestDesignExportWarmup();
    }

    function toggleCard(button) {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const card = button.closest('.product-card');
      const body = card ? card.querySelector('.product-card__body') : null;
      if (body) body.hidden = expanded;
    }

	    renderB2bCatalog();
	    renderB2bSavedSelections();
	    showProductGrid(B2B_PRESET ? 'b2b' : 'single');
	    hydrateTshirtState();
	    hydrateMugState();
	    hydrateFlagState();
	    hydrateHoodieState();
	    decorateB2bSelector();
	    syncUi();
	    applyShapeAndSync(true);

	    window.nhResetProductSelection = function () {
	      try {
	        stickerSelection.normalOval = 0;
	        stickerSelection.normalRect = 0;
	        stickerSelection.miniOval = 0;
	        stickerSelection.miniRect = 0;
	        beerdeckelSelection = 0;
	        flagVariantState.clear();
	        tshirtVariantState.clear();
	        hoodieVariantState.clear();
	        mugVariantState.clear();
	        expressSelectionByGroupKey.clear();
	      } catch (_) { /* noop */ }

	      try {
	        root.querySelectorAll('input[data-input="tshirt-variant"], input[data-input="hoodie-variant"], input[data-input="mug-variant"], input[data-input="flag-variant"]').forEach((el) => {
	          el.value = '0';
	        });
	      } catch (_) { /* noop */ }

	      try { applyShapeAndSync(true); } catch (_) { /* noop */ }
	    };

		    // Nachbestellen-Page lädt die Express-Variant-ID nicht via Liquid -> per JS nachholen.
		    ensureExpressProductionVariantIdLoaded().then((id) => {
		      if (!id) return;
		      try { refreshSummaries(); } catch (_) { /* noop */ }
	      try { refreshTotal(); } catch (_) { /* noop */ }
	    });

    // Wiederholt prüfen, ob die Form gewechselt hat (z.B. nach Laden)
    setInterval(() => applyShapeAndSync(false), 600);

    // Reorder-Page: allow forcing a sync after updating availability/shape.
    root.addEventListener('nh:force-sync', () => {
      applyShapeAndSync(true);
    });

	    root.addEventListener('click', (event) => {
	      const modeButton = event.target.closest('[data-selector-mode]');
	      if (modeButton && root.contains(modeButton)) {
	        const mode = modeButton.dataset.selectorMode;
	        if (mode === 'b2b') {
	          if (B2B_PRESET) {
	            deactivateB2bPreset('b2b');
	          } else {
	            showB2bCatalog();
	          }
	        } else {
	          deactivateB2bPreset('single');
	        }
	        return;
	      }

	      const savedShirtToggle = event.target.closest('[data-b2b-saved-shirt-toggle]');
	      if (savedShirtToggle) {
	        const row = savedShirtToggle.closest('[data-b2b-saved-id]');
	        const uid = String(row?.dataset?.b2bSavedId || '');
	        const panel = row?.querySelector('[data-b2b-saved-shirt-panel]');
	        const expanded = savedShirtToggle.getAttribute('aria-expanded') === 'true';
	        savedShirtToggle.setAttribute('aria-expanded', String(!expanded));
	        if (panel) panel.hidden = expanded;
	        if (uid) {
	          if (expanded) expandedB2bShirtEditors.delete(uid);
	          else expandedB2bShirtEditors.add(uid);
	        }
	        return;
	      }

	      const savedShirtStep = event.target.closest('[data-b2b-saved-shirt-step]');
	      if (savedShirtStep) {
	        const row = savedShirtStep.closest('[data-b2b-saved-id]');
	        const uid = String(row?.dataset?.b2bSavedId || '');
	        const item = B2B_SELECTIONS.find((entry) => entry.uid === uid);
	        if (!item) return;
	        const color = savedShirtStep.dataset.color;
	        const size = savedShirtStep.dataset.size;
	        const key = `tshirt_${color === 'black' ? 'black' : 'white'}_${String(size || '').toLowerCase()}`;
	        const current = Math.max(0, parseInt(new Map(b2bSavedShirtEntries(item)).get(key), 10) || 0);
	        const step = parseInt(savedShirtStep.dataset.b2bSavedShirtStep, 10) || 0;
	        setB2bSavedShirtQuantity(item, color, size, current + step);
	        return;
	      }

	      const b2bShirtStep = event.target.closest('[data-b2b-shirt-step]');
	      if (b2bShirtStep) {
	        const color = b2bShirtStep.dataset.color;
	        const size = b2bShirtStep.dataset.size;
	        const key = `tshirt_${color === 'black' ? 'black' : 'white'}_${String(size || '').toLowerCase()}`;
	        const current = Math.max(0, parseInt(tshirtVariantState.get(key), 10) || 0);
	        const step = parseInt(b2bShirtStep.dataset.b2bShirtStep, 10) || 0;
	        setB2bShirtQuantity(color, size, current + step);
	        return;
	      }

	      const savedBundleAction = event.target.closest('[data-b2b-saved-step], [data-b2b-saved-remove]');
	      if (savedBundleAction) {
	        const row = savedBundleAction.closest('[data-b2b-saved-id]');
	        const uid = String(row?.dataset?.b2bSavedId || '');
	        const index = B2B_SELECTIONS.findIndex((item) => item.uid === uid);
	        if (index < 0) return;
	        if (savedBundleAction.hasAttribute('data-b2b-saved-remove')) {
	          B2B_SELECTIONS.splice(index, 1);
	          expandedB2bShirtEditors.delete(uid);
	        } else {
	          const step = parseInt(savedBundleAction.dataset.b2bSavedStep, 10) || 0;
	          const current = Math.max(1, parseInt(B2B_SELECTIONS[index].quantity, 10) || 1);
	          B2B_SELECTIONS[index].quantity = clamp(current + step, 1, 99);
	        }
	        refreshTotal();
	        return;
	      }

	      const tierButton = event.target.closest('[data-b2b-tier-choice]');
	      if (tierButton) {
	        const card = tierButton.closest('[data-b2b-choice]');
	        const packageKey = String(card?.dataset?.b2bChoice || '');
	        const bundle = B2B_BUNDLE_CONFIG[packageKey];
	        const tierKey = String(tierButton.dataset.b2bTierChoice || '');
	        if (card && bundle?.tiers?.[tierKey]) {
	          card.dataset.b2bTier = tierKey;
	          renderB2bCatalogCard(card);
	        }
	        return;
	      }

	      const activateButton = event.target.closest('[data-b2b-activate]');
	      if (activateButton) {
	        activateB2bPreset(activateButton.closest('[data-b2b-choice]'));
	        return;
	      }

	      const headerBtn = event.target.closest('.product-card__header-btn');
	      if (headerBtn) {
	        toggleCard(headerBtn);
        return;
      }

      const qtyBtn = event.target.closest('[data-qty-step]');
      if (qtyBtn) {
        const control = qtyBtn.closest('[data-qty-control]');
        const input = control ? control.querySelector('input') : null;
        if (input) {
          const step = parseInt(qtyBtn.dataset.qtyStep, 10) || 0;
          const min = Number.isFinite(parseInt(input.min, 10)) ? parseInt(input.min, 10) : 0;
          const max = Number.isFinite(parseInt(input.max, 10)) ? parseInt(input.max, 10) : 999;
          const current = parseInt(input.value, 10) || 0;
          const next = clamp(current + step, min, max);
          if (next !== current) {
            input.value = next;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
        return;
      }

      const pill = event.target.closest('.pill-select .pill');
      if (!pill) return;

      const group = pill.closest('[data-pill-group]');
      if (!group) return;

      group.querySelectorAll('.pill').forEach(btn => btn.classList.remove('is-active'));
      pill.classList.add('is-active');

      const value = pill.dataset.value;
      switch (group.dataset.pillGroup) {
        case 'stickers-qty-normal-oval':
          stickerSelection.normalOval = parseInt(value, 10) || 0;
          break;
        case 'stickers-qty-normal-rect':
          stickerSelection.normalRect = parseInt(value, 10) || 0;
          break;
        case 'stickers-qty-mini-oval':
          stickerSelection.miniOval = parseInt(value, 10) || 0;
          break;
        case 'stickers-qty-mini-rect':
          stickerSelection.miniRect = parseInt(value, 10) || 0;
          break;
        case 'beerdeckel-qty':
          beerdeckelSelection = parseInt(value, 10) || 0;
          break;
        default:
          break;
      }
      syncUi();
    });

	    root.addEventListener('change', (event) => {
	      if (!event.target.matches('[data-b2b-saved-shirt-value]')) return;
	      const row = event.target.closest('[data-b2b-saved-id]');
	      const uid = String(row?.dataset?.b2bSavedId || '');
	      const item = B2B_SELECTIONS.find((entry) => entry.uid === uid);
	      if (!item) return;
	      setB2bSavedShirtQuantity(
	        item,
	        event.target.dataset.color,
	        event.target.dataset.size,
	        event.target.value
	      );
	    });

    root.addEventListener('input', (event) => {
      // Keine Paket-Inputs mehr für Sticker

	      if (event.target.matches('[data-b2b-shirt-value]')) {
	        setB2bShirtQuantity(
	          event.target.dataset.color,
	          event.target.dataset.size,
	          event.target.value
	        );
	        return;
	      }

	      if (event.target.matches('[data-input="flag-variant"]')) {
        const size = String(event.target.dataset.size || '');
        const key = `flag_${size}`;
        const value = clamp(parseInt(event.target.value, 10) || 0, 0, 99);
        event.target.value = value;
        if (size && value > 0) {
          flagVariantState.set(key, value);
        } else {
          flagVariantState.delete(key);
        }
        syncUi();
        return;
      }

	      if (event.target.matches('[data-input="tshirt-variant"]')) {
        const color = event.target.dataset.color === 'black' ? 'black' : 'white';
        const size = (event.target.dataset.size || '').toLowerCase();
        const key = `tshirt_${color}_${size}`;
	        let value = clamp(parseInt(event.target.value, 10) || 0, 0, 99);
	        if (B2B_PRESET && B2B_PRESET.tier.shirts) {
	          let otherTotal = 0;
	          tshirtVariantState.forEach((quantity, stateKey) => {
	            if (stateKey !== key) otherTotal += quantity || 0;
	          });
	          value = Math.min(value, Math.max(0, B2B_PRESET.tier.shirts - otherTotal));
	        }
	        event.target.value = value;
        if (value > 0) {
          tshirtVariantState.set(key, value);
        } else {
          tshirtVariantState.delete(key);
        }
        syncUi();
        return;
      }

      if (event.target.matches('[data-input="hoodie-variant"]')) {
        const color = event.target.dataset.color === 'black' ? 'black' : 'white';
        const size = (event.target.dataset.size || '').toLowerCase();
        const key = `hoodie_${color}_${size}`;
        const value = clamp(parseInt(event.target.value, 10) || 0, 0, 99);
        event.target.value = value;
        if (value > 0) {
          hoodieVariantState.set(key, value);
        } else {
          hoodieVariantState.delete(key);
        }
        syncUi();
        return;
      }

      if (event.target.matches('[data-input="mug-variant"]')) {
        const type = event.target.dataset.type === 'enamel' ? 'enamel' : 'ceramic';
        const key = `mug_${type}`;
        const value = clamp(parseInt(event.target.value, 10) || 0, 0, 99);
        event.target.value = value;
        if (value > 0) {
          mugVariantState.set(key, value);
        } else {
          mugVariantState.delete(key);
        }
        syncUi();
      }
    });
  }

  function resolveVariantId(key) {
    const value = SHOPIFY_VARIANT_MAP[key];
    if (!value) return null;
    if (typeof value === 'string' && value.toUpperCase().includes('REPLACE_WITH_VARIANT_ID')) {
      return null;
    }
    return value;
  }

function buildLineItemProperties(designId, previewDataUrl, pdfUrl, previewRemoteUrl) {
  const props = {};

  // Bisherige Editor-Properties
  if (designId)        props['Design-ID']         = designId;
  if (previewDataUrl)  props['_Design-Vorschau']  = previewDataUrl;
  if (previewRemoteUrl) props['Design-Vorschau']  = previewRemoteUrl;
  if (pdfUrl)          props['_Design-Link']      = pdfUrl;

  // 🔴 NEU: Onlineprinters-kompatible Properties (unterstrichen, damit im Checkout ausgeblendet)
  // Editor-Flow = immer Mode "editor"
  props['_OP_MODE'] = 'editor';

  // erzeugte PDF-URL an Onlineprinters weitergeben
  if (pdfUrl) {
    props['_OP_PDF_URL'] = pdfUrl;
  }

  // OPTIONAL: wenn du später eine OP-Artikel-ID pro Produkt hast:
  // props['_OP_ARTICLE_ID'] = 'DEINE_ARTIKEL_ID';

  return props;
}

  async function addProductsToCart(items) {
    const payload = {
      items: items.map(({ id, quantity, properties }) => ({
        id,
        quantity,
        properties: properties || {}
      }))
    };

    if (isProductAuditMode()) {
      window.__nhLastCartPayload = JSON.parse(JSON.stringify(payload));
      let auditNode = document.getElementById('nh-audit-cart-payload');
      if (!auditNode) {
        auditNode = document.createElement('script');
        auditNode.id = 'nh-audit-cart-payload';
        auditNode.type = 'application/json';
        auditNode.hidden = true;
        document.body.appendChild(auditNode);
      }
      auditNode.textContent = JSON.stringify(window.__nhLastCartPayload);
      window.dispatchEvent(new CustomEvent('nh:audit-cart-payload', {
        detail: window.__nhLastCartPayload
      }));
      return;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      let description = 'Produkte konnten nicht in den Warenkorb gelegt werden.';
      if (text) {
        if (text.trim().startsWith('<')) {
          description = 'Shop-Session oder Vorschau-Login nötig (Server liefert HTML statt JSON). Bitte kurz erneut versuchen oder im Shop einloggen.';
        } else {
          try {
            const data = JSON.parse(text);
            description = data.description || description;
          } catch {
            description = text.slice(0, 180) || description;
          }
        }
      }
      throw new Error(description);
    }
  }

  function isCartPath() {
    try {
      const path = window.location && window.location.pathname ? window.location.pathname : '';
      return path === '/cart' || path.startsWith('/cart/');
    } catch (err) {
      return false;
    }
  }

  async function fetchCartJson() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error(`Cart fetch failed (${response.status})`);
    return response.json();
  }

  async function postCartChange(payload) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error(`Cart change failed (${response.status})`);
    return response.json().catch(() => null);
  }

  function resolveVariantKeyFromCartItem(item) {
    const props = item && item.properties;
    if (props && typeof props === 'object') {
      const explicit = props._NH_VARIANT_KEY;
      if (explicit) return String(explicit);
    }
    const variantId = Number(item && item.variant_id);
    if (Number.isFinite(variantId) && VARIANT_ID_TO_KEY.has(variantId)) {
      return VARIANT_ID_TO_KEY.get(variantId);
    }
    return null;
  }

  function resolveBundleIdFromCartItem(item) {
    const props = item && item.properties;
    if (!props || typeof props !== 'object') return null;
    const raw = props._NH_BUNDLE_ID;
    if (raw) return String(raw);
    const designId = props['Design-ID'];
    const variantKey = resolveVariantKeyFromCartItem(item);
    if (designId && variantKey) return `${designId}::${variantKey}`;
    return null;
  }

  function ensureCartExpressUiStyles() {
    if (!isCartPath()) return;
    if (document.getElementById('nh-cart-express-style')) return;
    const style = document.createElement('style');
    style.id = 'nh-cart-express-style';
    style.textContent = `
      .nh-cart-express { margin-top: 0.65rem; }
      .nh-express-toggle {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 8px 10px;
        border-radius: 14px;
        border: 1px solid rgba(15, 23, 42, 0.12);
        background: rgba(15, 23, 42, 0.04);
        color: #0f172a;
        font-size: 0.95rem;
        font-weight: 700;
        cursor: pointer;
        user-select: none;
        max-width: 100%;
      }
      .nh-express-toggle:hover { background: rgba(15, 23, 42, 0.06); }
      .nh-express-toggle.is-disabled { opacity: 0.6; cursor: not-allowed; }
      .nh-express-toggle.is-loading { opacity: 0.75; pointer-events: none; }

      .nh-express-toggle__input {
        position: absolute;
        opacity: 0;
        width: 1px;
        height: 1px;
        overflow: hidden;
      }

      .nh-express-toggle__switch {
        width: 44px;
        height: 24px;
        border-radius: 999px;
        background: rgba(15, 23, 42, 0.18);
        box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.14);
        position: relative;
        flex: 0 0 auto;
        transition: background 0.18s ease, box-shadow 0.18s ease;
      }
      .nh-express-toggle__switch::after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        width: 18px;
        height: 18px;
        border-radius: 999px;
        background: #ffffff;
        box-shadow: 0 10px 20px rgba(15, 23, 42, 0.18);
        transition: transform 0.18s ease;
      }
      .nh-express-toggle__input:checked + .nh-express-toggle__switch {
        background: rgba(34, 197, 94, 0.86);
        box-shadow: inset 0 0 0 1px rgba(22, 163, 74, 0.45);
      }
      .nh-express-toggle__input:checked + .nh-express-toggle__switch::after {
        transform: translateX(20px);
      }
      .nh-express-toggle__input:focus-visible + .nh-express-toggle__switch {
        outline: none;
        box-shadow: 0 0 0 4px rgba(255, 230, 0, 0.35), inset 0 0 0 1px rgba(15, 23, 42, 0.12);
      }

      .nh-express-toggle__label {
        line-height: 1.25;
        overflow-wrap: anywhere;
      }

	      @media (max-width: 640px) {
	        .nh-express-toggle {
	          padding: 7px 8px;
	          font-size: 0.92rem;
	          gap: 8px;
	        }
	        .nh-express-toggle__switch { width: 40px; height: 22px; }
	        .nh-express-toggle__switch::after { width: 16px; height: 16px; }
	        .nh-express-toggle__input:checked + .nh-express-toggle__switch::after { transform: translateX(18px); }
	      }

	      /* Express-Produkt selbst: keine veränderbare Menge; Zuordnung läuft über den Zielartikel */
	      [data-nh-express-line="1"] .cart-item__quantity-wrapper,
	      [data-nh-express-line="1"] .cart-item__quantity--mobile,
	      [data-nh-express-line="1"] .cart-item__quantity--desktop,
	      [data-nh-express-line="1"] quantity-input,
	      [data-nh-express-line="1"] .quantity,
	      [data-nh-express-line="1"] cart-remove-button,
	      [data-nh-express-line="1"] .cart-remove-button,
	      [data-nh-express-line="1"] a[href*="/cart/change"],
	      [data-nh-express-line="1"] button[name="remove"] {
	        display: none !important;
	      }
	    `;
	    document.head.appendChild(style);
	  }

	  function isExpressCartLineItem(item, { expressVariantId = null } = {}) {
	    const props = item && item.properties;
	    if (props && typeof props === 'object') {
	      if (props._NH_EXPRESS_FOR_KEY || props._NH_EXPRESS_FOR_BUNDLE) return true;
	    }
	    const variantId = Number(item && item.variant_id);
	    if (expressVariantId && Number.isFinite(variantId) && variantId === expressVariantId) return true;
	    return false;
	  }

	  function applyCartExpressLineItemUi(cart) {
	    if (!isCartPath() || !cart || !Array.isArray(cart.items)) return;
	    const expressVariantId = resolveExpressProductionVariantId();
	    cart.items.forEach((item, index) => {
	      const itemEl = getCartItemElementForLine(index + 1);
	      if (!itemEl) return;
	      const isExpress = isExpressCartLineItem(item, { expressVariantId });
	      if (isExpress) {
	        itemEl.setAttribute('data-nh-express-line', '1');
	        // Hard-disable any remaining qty inputs (if theme uses different markup)
	        itemEl
	          .querySelectorAll('input[type="number"], input[name="updates[]"], input.quantity__input')
	          .forEach((input) => {
	            try {
	              input.disabled = true;
	              input.setAttribute('aria-disabled', 'true');
	            } catch (_) { /* noop */ }
	          });
	      } else {
	        itemEl.removeAttribute('data-nh-express-line');
	      }
	    });
	  }

	  function getCartItemElementForLine(lineNumber) {
	    const byId = document.getElementById(`CartItem-${lineNumber}`);
	    if (byId) return byId;
	    const dawnItems = document.querySelectorAll('[id^="CartItem-"]');
    if (dawnItems && dawnItems.length >= lineNumber) return dawnItems[lineNumber - 1];
    const genericItems = document.querySelectorAll('.cart-item');
    if (genericItems && genericItems.length >= lineNumber) return genericItems[lineNumber - 1];
    return null;
  }

  function getCartItemExpressHost(itemEl) {
    if (!itemEl) return null;
    let host =
      itemEl.querySelector('.cart-item__details') ||
      itemEl.querySelector('[class*="cart-item__details"]') ||
      itemEl.querySelector('.cart-item__name') ||
      null;

    if (host && host.classList && host.classList.contains('cart-item__name')) {
      host = host.closest('td, .cart-item__details, .cart-item, div') || host;
    }

    if (!host) {
      host = itemEl.querySelector('td') || itemEl.querySelector('div') || itemEl;
    }

    if (host && host.tagName === 'TR') {
      host = itemEl.querySelector('td') || itemEl;
    }
    return host;
  }

		  function getExpressTargetsFromCart(cart) {
		    const targets = new Set();
		    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(item => {
		      const props = item && item.properties;
		      if (!props || typeof props !== 'object') return;
		      if (props._NH_EXPRESS_FOR_BUNDLE) targets.add(String(props._NH_EXPRESS_FOR_BUNDLE));
		      if (props._NH_EXPRESS_FOR_KEY) targets.add(String(props._NH_EXPRESS_FOR_KEY));
		    });
		    return targets;
		  }

		  function ensureCartDesignPreviewStyles() {
		    if (!isCartPath()) return;
		    if (document.getElementById('nh-cart-design-preview-style')) return;
		    const style = document.createElement('style');
		    style.id = 'nh-cart-design-preview-style';
		    style.textContent = `
		      .nh-cart-design-preview {
		        margin-top: 0.75rem;
		        display: inline-flex;
		        gap: 10px;
		        align-items: center;
		        padding: 8px 10px;
		        border-radius: 14px;
		        border: 1px solid rgba(15, 23, 42, 0.12);
		        background: rgba(15, 23, 42, 0.03);
		        max-width: 100%;
		      }
		      .nh-cart-design-preview__img {
		        width: 64px;
		        height: 64px;
		        object-fit: contain;
		        border-radius: 12px;
		        border: 1px solid rgba(15, 23, 42, 0.12);
		        background: #fff;
		        flex: 0 0 auto;
		      }
		      .nh-cart-design-preview__meta { display: grid; gap: 2px; }
		      .nh-cart-design-preview__label {
		        font-size: 0.9rem;
		        font-weight: 900;
		        letter-spacing: -0.01em;
		        color: rgba(15, 23, 42, 0.92);
		      }
		      .nh-cart-design-preview__id {
		        font-size: 0.9rem;
		        color: rgba(15, 23, 42, 0.65);
		        word-break: break-word;
		      }
		      @media (max-width: 749px) {
		        .nh-cart-design-preview__img { width: 54px; height: 54px; }
		      }
		    `;
		    document.head.appendChild(style);
		  }

		  function getCartItemDesignPreviewUrl(item) {
		    const props = item && item.properties;
		    if (!props || typeof props !== 'object') return '';
		    const preferred = props['Design-Vorschau'];
		    if (typeof preferred === 'string' && preferred.trim()) return preferred.trim();
		    const fallback = props['_Design-Vorschau'];
		    if (typeof fallback === 'string' && fallback.trim().startsWith('data:image') && fallback.length < 250000) {
		      return fallback.trim();
		    }
		    return '';
		  }

			  function applyCartDesignPreviewUi(cartData) {
		    if (!isCartPath()) return;
		    ensureCartDesignPreviewStyles();
		    if (!cartData || !Array.isArray(cartData.items)) return;

		    cartData.items.forEach((item, index) => {
		      const props = item && item.properties;
		      if (!props || typeof props !== 'object') return;
		      if (props._OP_MODE !== 'editor') return;

		      // Express-Zeilen sind eigene Produkte -> keine Design-Vorschau
		      if (props._NH_EXPRESS_FOR_BUNDLE || props._NH_EXPRESS_FOR_KEY) return;

		      const previewUrl = getCartItemDesignPreviewUrl(item);
		      if (!previewUrl) return;

		      const lineNumber = index + 1;
		      const itemEl = getCartItemElementForLine(lineNumber);
		      if (!itemEl) return;
		      const host =
		        itemEl.querySelector('.cart-item__details') ||
		        itemEl.querySelector('[class*="cart-item__details"]') ||
		        itemEl;
		      if (!host) return;

		      let wrapper = host.querySelector(`.nh-cart-design-preview[data-nh-line="${lineNumber}"]`);
		      if (!wrapper) {
		        wrapper = document.createElement('div');
		        wrapper.className = 'nh-cart-design-preview';
		        wrapper.dataset.nhLine = String(lineNumber);
		        host.appendChild(wrapper);
		      }

		      const designId = (props['Design-ID'] && String(props['Design-ID'])) || '';

		      let img = wrapper.querySelector('img.nh-cart-design-preview__img');
		      let meta = wrapper.querySelector('.nh-cart-design-preview__meta');
		      let idEl = wrapper.querySelector('.nh-cart-design-preview__id');
		      if (!img || !meta) {
		        wrapper.innerHTML = '';
		        img = document.createElement('img');
		        img.className = 'nh-cart-design-preview__img';
		        img.alt = 'Design Vorschau';
		        img.loading = 'lazy';
		        img.decoding = 'async';
		        wrapper.appendChild(img);

		        meta = document.createElement('div');
		        meta.className = 'nh-cart-design-preview__meta';
		        meta.innerHTML = `<div class="nh-cart-design-preview__label">Dein Design</div>`;
		        wrapper.appendChild(meta);
		        idEl = null;
		      }

		      if (img && img.getAttribute('src') !== previewUrl) {
		        img.setAttribute('src', previewUrl);
		      }

		      if (designId) {
		        if (!idEl) {
		          idEl = document.createElement('div');
		          idEl.className = 'nh-cart-design-preview__id';
		          meta.appendChild(idEl);
		        }
		        idEl.textContent = designId;
		      } else if (idEl) {
		        idEl.textContent = '';
		      }
			    });
			  }

			  function expressSurchargeLabelForQuantity(quantity) {
			    const safeQuantity = Math.max(1, parseInt(quantity, 10) || 1);
			    if (safeQuantity === 1) {
			      return `Für diesen Artikel · +${formatMoney(EXPRESS_SURCHARGE_CENTS)}`;
			    }
			    return `Für ${safeQuantity} Einheiten · ${safeQuantity} &times; ${formatMoney(EXPRESS_SURCHARGE_CENTS)} = +${formatMoney(EXPRESS_SURCHARGE_CENTS * safeQuantity)}`;
			  }

			  async function renderCartExpressControls(cart = null) {
		    if (!isCartPath()) return;
		    ensureCartExpressUiStyles();

		    const expressVariantId = resolveExpressProductionVariantId();
		    const cartData = cart || await fetchCartJson().catch(() => null);
		    if (!cartData || !Array.isArray(cartData.items)) return;

		    applyCartExpressLineItemUi(cartData);
			    const expressTargets = getExpressTargetsFromCart(cartData);

			    cartData.items.forEach((item, index) => {
			      if (isExpressCartLineItem(item, { expressVariantId })) return;

		      const variantKey = resolveVariantKeyFromCartItem(item);
	      if (!variantKey) return;
	      if (!expressGroupKeyForVariantKey(variantKey)) return;
	      const meetsMinForExpress = meetsExpressMinimumForVariantKey(variantKey, item.quantity);

		      const bundleId = resolveBundleIdFromCartItem(item);
		      const wantsExpress = meetsMinForExpress && (
		        (bundleId && expressTargets.has(String(bundleId))) ||
		        expressTargets.has(String(variantKey))
		      );

      const lineNumber = index + 1;
      const itemEl = getCartItemElementForLine(lineNumber);
      const host = getCartItemExpressHost(itemEl);
      if (!host) return;

      let wrapper = host.querySelector('.nh-cart-express');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'nh-cart-express';
        host.appendChild(wrapper);
      }

      let input = wrapper.querySelector('.nh-express-toggle__input');
      let label = wrapper.querySelector('.nh-express-toggle');
      if (!label || !input) {
        wrapper.innerHTML = '';

        label = document.createElement('label');
        label.className = 'nh-express-toggle';

        input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'nh-express-toggle__input';
        input.setAttribute('data-nh-express-toggle', '1');
        input.dataset.nhVariantKey = String(variantKey);
        if (bundleId) input.dataset.nhBundleId = String(bundleId);

        const switchEl = document.createElement('span');
        switchEl.className = 'nh-express-toggle__switch';
        switchEl.setAttribute('aria-hidden', 'true');

		        const labelEl = document.createElement('span');
		        labelEl.className = 'nh-express-toggle__label';
		        labelEl.innerHTML = meetsMinForExpress
		          ? `<strong>Expressproduktion (48h)</strong><small>${expressSurchargeLabelForQuantity(item.quantity)}</small>`
		          : `<strong>Expressproduktion</strong><small>Für diesen Artikel erst ab ${EXPRESS_MIN_PIECES} Stück</small>`;

        label.appendChild(input);
        label.appendChild(switchEl);
        label.appendChild(labelEl);
        wrapper.appendChild(label);
	      } else {
	        // Keep dataset in sync (in case we derived bundleId later)
	        input.dataset.nhVariantKey = String(variantKey);
	        if (bundleId) input.dataset.nhBundleId = String(bundleId);
	      }

	      const disabled = !expressVariantId || !meetsMinForExpress;
	      input.checked = !!wantsExpress;
	      input.disabled = disabled;
	      label.classList.toggle('is-disabled', disabled);
		      const labelEl = label.querySelector('.nh-express-toggle__label');
		      if (labelEl) {
		        labelEl.innerHTML = meetsMinForExpress
		          ? `<strong>Expressproduktion (48h)</strong><small>${expressSurchargeLabelForQuantity(item.quantity)}</small>`
		          : `<strong>Expressproduktion</strong><small>Für diesen Artikel erst ab ${EXPRESS_MIN_PIECES} Stück</small>`;
		      }
		    });
		  }

	  async function setCartExpressSelection({ variantKey, bundleId, enabled }) {
	    if (!isCartPath()) return;
	    const expressVariantId = resolveExpressProductionVariantId();
	    if (enabled && !expressVariantId) {
	      throw new Error('Expressproduktion ist gerade nicht verfügbar.');
		    }

		    const cart = await fetchCartJson();
		    let targetQuantity = 1;
		    if (enabled) {
			      const targetBundle = bundleId ? String(bundleId) : '';
			      const targetKey = variantKey ? String(variantKey) : '';
		      const mainItem = cart.items.find((item) => {
		        if (isExpressCartLineItem(item, { expressVariantId })) return false;
		        const vKey = resolveVariantKeyFromCartItem(item);
	        if (!vKey) return false;
	        if (targetKey && String(vKey) !== targetKey) return false;
	        if (!targetBundle) return true;
	        const bId = resolveBundleIdFromCartItem(item);
	        return bId && String(bId) === targetBundle;
	      });
		      targetQuantity = Math.max(1, parseInt(mainItem ? mainItem.quantity : 1, 10) || 1);
		      if (!meetsExpressMinimumForVariantKey(variantKey, targetQuantity)) {
		        throw new Error(`Express erst ab ${EXPRESS_MIN_PIECES} Stück verfügbar.`);
		      }
		    }
	    const targets = new Set();
	    if (bundleId) targets.add(String(bundleId));
	    if (variantKey) targets.add(String(variantKey));

    const matchingExpressItems = cart.items.filter(item => {
      const props = item && item.properties;
      if (!props || typeof props !== 'object') return false;
      const byBundle = props._NH_EXPRESS_FOR_BUNDLE;
      const byKey = props._NH_EXPRESS_FOR_KEY;
      if (!byBundle && !byKey) return false;
      return (
        (byBundle && targets.has(String(byBundle))) ||
        (byKey && targets.has(String(byKey)))
      );
    });

    if (enabled) {
	      if (!matchingExpressItems.length) {
	        await addProductsToCart([{
	          id: expressVariantId,
	          quantity: targetQuantity,
	          properties: {
            'Expressproduktion für': expressTargetLabelForVariantKey(variantKey),
            'Produktionszeit': EXPRESS_PRODUCTION_TIME_LABEL,
            ...(bundleId ? { '_NH_EXPRESS_FOR_BUNDLE': String(bundleId) } : {}),
            '_NH_EXPRESS_FOR_KEY': String(variantKey || '')
          }
        }]);
      }
    } else {
      for (const expressItem of matchingExpressItems) {
        await postCartChange({ id: expressItem.key, quantity: 0 });
      }
    }

    await syncCartExpressProductionTimes({ reloadAfter: true });
  }

  async function syncCartExpressProductionTimes({ reloadAfter = true } = {}) {
    if (!isCartPath()) return;
    if (window.__nhCartExpressSyncRunning) return;
    window.__nhCartExpressSyncRunning = true;

	    try {
	      const cart = await fetchCartJson();
	      if (!cart || !Array.isArray(cart.items)) return;
	      const expressVariantId = resolveExpressProductionVariantId();

      const expressTargets = new Set(); // bundleId OR variantKey
      const expressLineItems = [];

      cart.items.forEach(item => {
        const props = item && item.properties;
        if (!props || typeof props !== 'object') return;
        const byBundle = props._NH_EXPRESS_FOR_BUNDLE;
        const byKey = props._NH_EXPRESS_FOR_KEY;
        const target = byBundle || byKey;
        if (!target) return;
        expressTargets.add(String(target));
        expressLineItems.push(item);
      });

	      const mainLineItems = cart.items.filter(item => {
	        if (isExpressCartLineItem(item, { expressVariantId })) return false;
	        const variantKey = resolveVariantKeyFromCartItem(item);
	        return !!variantKey && !!expressGroupKeyForVariantKey(variantKey);
	      });

		      const mainTargetQuantities = new Map();
		      mainLineItems.forEach(item => {
		        const variantKey = resolveVariantKeyFromCartItem(item);
		        if (!variantKey) return;
		        if (!expressGroupKeyForVariantKey(variantKey)) return;
		        if (!meetsExpressMinimumForVariantKey(variantKey, item.quantity)) return;
		        const bundleId = resolveBundleIdFromCartItem(item);
		        const target = String(bundleId || variantKey);
		        const quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
		        mainTargetQuantities.set(target, (mainTargetQuantities.get(target) || 0) + quantity);
		      });

      const mutations = [];

	      // 1) Express exakt an die Menge des Ziel-Artikels koppeln.
	      const retainedExpressTargets = new Set();
	      expressLineItems.forEach(item => {
	        const props = item && item.properties;
	        if (!props || typeof props !== 'object') return;
	        const target = props._NH_EXPRESS_FOR_BUNDLE || props._NH_EXPRESS_FOR_KEY;
	        if (!target) return;
	        const targetKey = String(target);
	        const desiredQuantity = mainTargetQuantities.get(targetKey) || 0;
	        if (!desiredQuantity || retainedExpressTargets.has(targetKey)) {
	          mutations.push({ id: item.key, quantity: 0 });
	          return;
	        }
	        retainedExpressTargets.add(targetKey);
	        if (Number(item.quantity) !== desiredQuantity) {
	          mutations.push({ id: item.key, quantity: desiredQuantity });
	        }
	      });

	      // 2) Produktionszeit der Ziel-Artikel anhand der Express-Zeilen setzen
	      mainLineItems.forEach(item => {
	        const variantKey = resolveVariantKeyFromCartItem(item);
	        if (!variantKey) return;
	        if (!expressGroupKeyForVariantKey(variantKey)) return;

	        const bundleId = resolveBundleIdFromCartItem(item);
		        const meetsMinForExpress = meetsExpressMinimumForVariantKey(variantKey, item.quantity);
		        const wantsExpress = meetsMinForExpress && (
		          (bundleId && expressTargets.has(String(bundleId))) ||
		          expressTargets.has(String(variantKey))
		        );
	        const desired = wantsExpress ? EXPRESS_PRODUCTION_TIME_LABEL : STANDARD_PRODUCTION_TIME_LABEL;

        const props = item.properties || {};
        const current = props['Produktionszeit'];
        if (current === desired) return;

        const nextProps = { ...(props || {}) };
        nextProps['Produktionszeit'] = desired;
        nextProps['_NH_VARIANT_KEY'] = variantKey;
        if (bundleId) nextProps['_NH_BUNDLE_ID'] = bundleId;

        mutations.push({
          id: item.key,
          quantity: item.quantity,
          properties: nextProps
        });
      });

      if (!mutations.length) return;

      for (const payload of mutations) {
        await postCartChange(payload);
      }

      if (reloadAfter) {
        setTimeout(() => {
          try { window.location.reload(); } catch (_) { /* noop */ }
        }, 80);
      }
    } catch (err) {
      console.warn('[NH Express Sync] Fehler', err);
    } finally {
      window.__nhCartExpressSyncRunning = false;
    }
  }

  function isCartMutationUrl(url) {
    try {
      const value = String(url || '');
      return /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(value);
    } catch (err) {
      return false;
    }
  }

  function installCartMutationHooks(onCartMutated) {
    if (!isCartPath()) return;
    if (window.__nhCartMutationHooksInstalled) return;
    window.__nhCartMutationHooksInstalled = true;

    const callback = typeof onCartMutated === 'function' ? onCartMutated : () => {};

    try {
      const originalFetch = window.fetch;
      if (typeof originalFetch === 'function') {
        window.fetch = function(input, init) {
          const url = typeof input === 'string' ? input : (input && input.url) || '';
          const result = originalFetch.apply(this, arguments);
          if (isCartMutationUrl(url)) {
            Promise.resolve(result).then(callback, callback);
          }
          return result;
        };
      }
    } catch (err) {
      // ignore
    }

    try {
      const xhrProto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
      if (xhrProto && !xhrProto.__nhCartMutationWrapped) {
        xhrProto.__nhCartMutationWrapped = true;
        const originalOpen = xhrProto.open;
        const originalSend = xhrProto.send;
        xhrProto.open = function(method, url) {
          this.__nhCartUrl = url;
          return originalOpen.apply(this, arguments);
        };
        xhrProto.send = function(body) {
          const url = this.__nhCartUrl;
          if (isCartMutationUrl(url)) {
            this.addEventListener('loadend', callback, { once: true });
          }
          return originalSend.apply(this, arguments);
        };
      }
    } catch (err) {
      // ignore
    }
  }

  function setupCartExpressSync() {
    if (!isCartPath()) return;
    if (window.__nhCartExpressSyncSetup) return;
    window.__nhCartExpressSyncSetup = true;

    let timer = null;
    let renderTimer = null;
    const schedule = (delayMs = 220) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        syncCartExpressProductionTimes({ reloadAfter: true });
      }, Math.max(0, Number(delayMs) || 0));
    };

    const scheduleRender = (delayMs = 0) => {
      if (renderTimer) clearTimeout(renderTimer);
      renderTimer = setTimeout(() => {
        Promise.resolve(renderCartExpressControls()).catch(() => {});
      }, Math.max(0, Number(delayMs) || 0));
    };

    // Initial run
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        schedule();
        scheduleRender(0);
      }, { once: true });
    } else {
      schedule();
      scheduleRender(0);
    }

    // Catch AJAX-based cart updates (e.g. Dawn): observe DOM mutations
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(() => {
        schedule(350);
        scheduleRender(420);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Catch network-based cart updates (even if DOM is replaced)
    installCartMutationHooks(() => {
      schedule(650);
      scheduleRender(720);
    });

    if (!window.__nhCartExpressToggleBound) {
      window.__nhCartExpressToggleBound = true;
      // IMPORTANT: Dawn (cart-items) listens to ALL `change` events and can misinterpret our checkbox
      // as a quantity input -> shows the "Abstufungen..." quantity error briefly. Handle in capture
      // phase + stop propagation so only our handler runs.
      document.addEventListener('change', async (event) => {
        const input = event.target && event.target.closest
          ? event.target.closest('input[data-nh-express-toggle="1"]')
          : null;
        if (!input) return;

        try { event.stopPropagation(); } catch (_) { /* noop */ }

        const variantKey = input.dataset.nhVariantKey;
        const bundleId = input.dataset.nhBundleId;
        const enabled = !!input.checked;
        if (!variantKey) return;

        const label = input.closest('.nh-express-toggle');
        try {
          input.disabled = true;
          label?.classList?.add?.('is-loading');
          await setCartExpressSelection({ variantKey, bundleId, enabled });
        } catch (err) {
          console.warn('[NH Express Toggle] Fehler', err);
          input.checked = !enabled;
          alert(err && err.message ? err.message : 'Express konnte nicht aktualisiert werden. Bitte versuch es erneut.');
        } finally {
          input.disabled = false;
          label?.classList?.remove?.('is-loading');
        }
      }, true);
    }
  }

let lastProgressValue = 0;

function updateLoadingModalProgress(progress, { autoShow = false } = {}) {
  const loadingModal =
    document.getElementById('loading-modal') ||
    document.querySelector('.loading-modal');

  if (!loadingModal) {
    console.warn('[LoadingProgress] Kein #loading-modal/.loading-modal gefunden');
    return;
  }

  const progressBar =
    loadingModal.querySelector('.loading-progress__bar') ||
    loadingModal.querySelector('.loading-progress');

  if (!progressBar) {
    console.warn('[LoadingProgress] Kein .loading-progress__bar im Modal gefunden');
    return;
  }

  const clamped = Math.max(0, Math.min(1, Number(progress) || 0));
  const percent = Math.round(clamped * 100);
  progressBar.style.width = percent + '%';
  progressBar.dataset.value = String(clamped);
  lastProgressValue = clamped;

  if (autoShow && clamped > 0 && loadingModal.getAttribute('aria-hidden') === 'true') {
    loadingModal.setAttribute('aria-hidden', 'false');
  }
}

window.updateLoadingModalProgress = updateLoadingModalProgress;

		async function startShopifyCheckoutFromExistingAssets(selection, assets) {
		  if (!selection.length) {
		    throw new Error('Bitte mindestens eine Produktmenge auswählen.');
		  }
		  const profiles = assets && typeof assets === 'object' ? (assets.profiles || {}) : {};
		  pruneExpressSelections(selection);
		  const wantsExpress = selection.some(item => isExpressSelectedForVariantKey(item.key));
		  let expressProductionVariantId = wantsExpress ? resolveExpressProductionVariantId() : null;
		  if (wantsExpress && !expressProductionVariantId) {
		    expressProductionVariantId = await ensureExpressProductionVariantIdLoaded();
		  }
		  if (wantsExpress && !expressProductionVariantId) {
		    throw new Error('Expressproduktion ist gerade nicht verfügbar. Bitte entferne Express oder versuch es später erneut.');
		  }

		  const compressPreviewDataUrl = (dataUrl, { maxEdge = 220, quality = 0.76 } = {}) => {
		    const raw = String(dataUrl || '').trim();
		    if (!raw || !raw.startsWith('data:image')) return Promise.resolve('');
		    return new Promise((resolve) => {
		      try {
		        const img = new Image();
		        img.onload = () => {
		          const w = img.naturalWidth || img.width || 0;
		          const h = img.naturalHeight || img.height || 0;
		          if (!w || !h) return resolve('');
		          const largest = Math.max(w, h) || 1;
		          const scale = largest > maxEdge ? (maxEdge / largest) : 1;
		          const canvas = document.createElement('canvas');
		          canvas.width = Math.max(1, Math.round(w * scale));
		          canvas.height = Math.max(1, Math.round(h * scale));
		          const ctx = canvas.getContext('2d', { alpha: false });
		          if (!ctx) return resolve('');
		          ctx.fillStyle = '#ffffff';
		          ctx.fillRect(0, 0, canvas.width, canvas.height);
		          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
		          resolve(canvas.toDataURL('image/jpeg', quality));
		        };
		        img.onerror = () => resolve('');
		        img.src = raw;
		      } catch (_) {
		        resolve('');
		      }
		    });
		  };

		  const rawPreview = (() => {
		    if (assets && typeof assets.previewSource === 'string' && assets.previewSource.trim()) return assets.previewSource.trim();
		    if (assets && typeof assets.previewUrl === 'string' && assets.previewUrl.trim()) return assets.previewUrl.trim();
		    return '';
		  })();

		  let previewRemoteUrl = '';
		  let previewDataUrl = '';
		  if (rawPreview && /^https?:\/\//i.test(rawPreview)) {
		    previewRemoteUrl = rawPreview;
		  } else if (rawPreview && rawPreview.startsWith('data:image')) {
		    previewDataUrl = rawPreview;
		  }

		  if (previewDataUrl && previewDataUrl.length >= 240000) {
		    previewDataUrl = await compressPreviewDataUrl(previewDataUrl, { maxEdge: 200, quality: 0.74 });
		  }

		  if (!previewRemoteUrl && assets && typeof assets.previewUrl === 'string' && /^https?:\/\//i.test(assets.previewUrl)) {
		    previewRemoteUrl = assets.previewUrl;
		  }

		  if (!previewDataUrl) {
		    const anyPdf = Object.values(profiles || {}).find((entry) => entry && entry.pdfUrl)?.pdfUrl;
		    if (anyPdf && typeof window.nhPdfFirstPageThumbnailDataUrl === 'function') {
		      try {
		        previewDataUrl = await window.nhPdfFirstPageThumbnailDataUrl(anyPdf, 220);
		      } catch (err) {
		        console.warn('Design preview thumbnail failed', err);
		        previewDataUrl = '';
		      }
		    }
		  }
		  if (previewDataUrl && previewDataUrl.length >= 240000) {
		    previewDataUrl = await compressPreviewDataUrl(previewDataUrl, { maxEdge: 180, quality: 0.72 });
		  }

		  const bundleIdByVariantKey = new Map();
		  const lineItems = selection.map(item => {
		    const variantId = resolveVariantId(item.key);
		    if (!variantId) {
		      throw new Error(`Für "${item.key}" ist noch keine Variant-ID hinterlegt.`);
		    }
		    const profileKey = productTypeForVariantKey(item.key);
		    const asset = profiles && profiles[profileKey];
		    if (!asset || !asset.pdfUrl) {
		      throw new Error('Für dieses Design ist die Auswahl nicht verfügbar.');
		    }
		    const designId = asset.designId || assets.rawDesignId || '';
		    const pdfUrl = asset.pdfUrl;
		    const properties = buildLineItemProperties(designId, previewDataUrl || '', pdfUrl, previewRemoteUrl);
		    properties['Produktionszeit'] = productionTimeLabelForVariantKey(item.key);
		    properties['_NH_VARIANT_KEY'] = item.key;
		    const bundleId = `${designId || assets.rawDesignId || 'DESIGN'}::${item.key}`;
		    properties['_NH_BUNDLE_ID'] = bundleId;
		    bundleIdByVariantKey.set(item.key, bundleId);
		    return {
		      id: variantId,
		      quantity: item.quantity,
		      properties
		    };
		  });

		  if (wantsExpress && expressProductionVariantId) {
		    selection
		      .filter(item => isExpressSelectedForVariantKey(item.key))
		      .forEach(item => {
		        const bundleId = bundleIdByVariantKey.get(item.key) || item.key;
			        lineItems.push({
			          id: expressProductionVariantId,
			          quantity: Math.max(1, parseInt(item.quantity, 10) || 1),
			          properties: {
		            'Expressproduktion für': expressTargetLabelForVariantKey(item.key),
		            'Produktionszeit': EXPRESS_PRODUCTION_TIME_LABEL,
		            '_NH_EXPRESS_FOR_BUNDLE': bundleId,
		            '_NH_EXPRESS_FOR_KEY': item.key
		          }
		        });
		      });
		  }

		  updateLoadingModalProgress(Math.max(lastProgressValue, 0.6), { autoShow: true });
		  await addProductsToCart(lineItems);
		  updateLoadingModalProgress(Math.max(lastProgressValue, 0.85), { autoShow: true });
		  appendProgressDebug('Warenkorb wird vorbereitet …');

		  const proceedToCart = () => {
		    try {
		      const loadingModal = document.getElementById('loading-modal') || document.querySelector('.loading-modal');
		      if (loadingModal) loadingModal.setAttribute('aria-hidden', 'true');
		    } catch (_) { /* noop */ }

		    if (typeof window.closeExportModal === 'function') {
		      window.closeExportModal();
		    }
		    try { window.clearNhEditorReorderState?.(); } catch (_) { /* noop */ }

		    const cartUrl = '/cart';
		    const tab = window.__nhCartTab;
		    window.__nhCartTab = null;

		    try {
		      if (tab && !tab.closed) {
		        tab.location.href = cartUrl;
		        tab.focus();
		        return;
		      }
		    } catch (e) { /* noop */ }

		    window.open(cartUrl, '_blank', 'noopener');
		  };

		  if (DEBUG_PROGRESS_MODE) {
		    appendProgressDebug('Debug-Modus aktiv: Klicke auf „Zum Warenkorb“, sobald du den Verlauf gesehen hast.');
		    buildDebugContinueButton('Zum Warenkorb', () => {
		      updateLoadingModalProgress(1, { autoShow: false });
		      appendProgressDebug('Weiterleitung …');
		      proceedToCart();
		    });
		    return;
		  }

		  setTimeout(() => {
		    updateLoadingModalProgress(1, { autoShow: false });
		    appendProgressDebug('Weiterleitung …');
		    proceedToCart();
		  }, 600);
		}

		async function startB2bBundleCheckout() {
		  if (!B2B_PRESET) return;
		  const tier = B2B_PRESET.tier;
		  const requiredShirts = tier.shirts || 0;
		  const selectedShirts = Array.from(tshirtVariantState.values()).reduce((sum, quantity) => sum + (quantity || 0), 0);
		  if (requiredShirts && selectedShirts !== requiredShirts) {
		    throw new Error(`Bitte verteile genau ${requiredShirts} T-Shirts auf Farbe und Größe. Aktuell verteilt: ${selectedShirts}.`);
		  }

		  const parentVariantId = tier.variants && tier.variants[B2B_PRESET.shape];
		  if (!parentVariantId) throw new Error('Für dieses Firmenpaket fehlt die Bundle-Variante.');

		  const selection = b2bSelectionForExport();
		  const exportProfiles = exportProfilesForSelection(selection);
		  const profileTotals = new Map();
		  selection.forEach((item) => {
		    const profileKey = productTypeForVariantKey(item.key);
		    profileTotals.set(profileKey, (profileTotals.get(profileKey) || 0) + (item.quantity || 0));
		  });
		  const exportData = await ensureDesignExported(exportProfiles, profileTotals);
		  const primaryProfile = exportData.primaryProfile || exportProfiles[0];
		  const primaryResult = exportData.results[primaryProfile] || Object.values(exportData.results || {})[0] || {};
		  const primaryDesignId = primaryResult.id || exportData.primaryId;
		  const primaryPdfUrl = primaryResult.pdfUrl || window.__lastDesignPdfUrl || '';
		  const previewDataUrl = await resolvePreviewForCheckout(primaryDesignId);
		  const previewRemoteUrl = await ensurePreviewUploaded(primaryDesignId, previewDataUrl);

		  const properties = buildLineItemProperties(primaryDesignId, previewDataUrl, primaryPdfUrl, previewRemoteUrl);
		  const shapeLabel = B2B_PRESET.shape === 'rect' ? 'Rechteckig' : 'Oval';
		  const componentLabels = [`${tier.stickers} Aufkleber Normal (${shapeLabel})`];
		  if (tier.mini) componentLabels.push(`${tier.mini} Aufkleber Mini (${shapeLabel})`);
		  if (tier.shirts) componentLabels.push(`${tier.shirts} T-Shirts`);
		  if (tier.mugs) componentLabels.push(`${tier.mugs} Keramiktassen`);
		  if (tier.flags) componentLabels.push(`${tier.flags} Fahne${tier.flags === 1 ? '' : 'n'} 150 × 86,5 cm`);

		  properties['Paket'] = `${B2B_PRESET.title} · ${tier.label}`;
		  properties['Aufkleberform'] = shapeLabel;
		  properties['Ein Design für alle Produkte'] = 'Ja';
		  if (requiredShirts) properties['T-Shirt-Aufteilung'] = b2bShirtDistribution();
		  properties['Produktionszeit'] = STANDARD_PRODUCTION_TIME_LABEL;
		  properties['_NH_B2B_KEY'] = B2B_PRESET.key;
		  properties['_NH_B2B_TIER'] = B2B_PRESET.tierKey;
		  properties['_NH_B2B_SHAPE'] = B2B_PRESET.shape;
		  properties['_NH_B2B_COMPONENTS'] = componentLabels.join(' · ');
		  properties['_NH_VARIANT_KEY'] = `b2b_${B2B_PRESET.key}_${B2B_PRESET.tierKey}_${B2B_PRESET.shape}`;
		  properties['_NH_BUNDLE_ID'] = `${primaryDesignId || 'DESIGN'}::B2B::${parentVariantId}`;
		  properties['_OP_MODE'] = 'editor-b2b';

		  exportProfiles.forEach((profileKey) => {
		    const result = exportData.results[profileKey] || primaryResult;
		    if (!result) return;
		    const propertyKey = String(profileKey).toUpperCase().replace(/[^A-Z0-9]+/g, '_').slice(0, 28);
		    if (result.id) properties[`_NH_ID_${propertyKey}`] = result.id;
		    if (result.pdfUrl) properties[`_NH_PDF_${propertyKey}`] = result.pdfUrl;
		  });

		  updateLoadingModalProgress(Math.max(lastProgressValue, 0.6), { autoShow: true });
		  await addProductsToCart([{ id: parentVariantId, quantity: 1, properties }]);
		  updateLoadingModalProgress(Math.max(lastProgressValue, 0.85), { autoShow: true });
		  appendProgressDebug('Firmenpaket wird im Warenkorb vorbereitet …');

		  const proceedToCart = () => {
		    try {
		      const loadingModal = document.getElementById('loading-modal') || document.querySelector('.loading-modal');
		      if (loadingModal) loadingModal.setAttribute('aria-hidden', 'true');
		    } catch (_) { /* noop */ }
		    if (typeof window.closeExportModal === 'function') window.closeExportModal();
		    const cartUrl = '/cart';
		    const tab = window.__nhCartTab;
		    window.__nhCartTab = null;
		    try {
		      if (tab && !tab.closed) {
		        tab.location.href = cartUrl;
		        tab.focus();
		        return;
		      }
		    } catch (_) { /* noop */ }
		    window.open(cartUrl, '_blank', 'noopener');
		  };

		  setTimeout(() => {
		    updateLoadingModalProgress(1, { autoShow: false });
		    proceedToCart();
		  }, 600);
		}

		async function startShopifyCheckout(selection) {
		    const bundleSelections = B2B_SELECTIONS.slice();
		    if (!selection.length && !bundleSelections.length) {
		      throw new Error('Bitte mindestens eine Produktmenge auswählen.');
		    }
	    pruneExpressSelections(selection);
	    const wantsExpress = selection.some(item => isExpressSelectedForVariantKey(item.key));
	    const expressProductionVariantId = wantsExpress ? resolveExpressProductionVariantId() : null;
	    if (wantsExpress && !expressProductionVariantId) {
	      throw new Error('Expressproduktion ist gerade nicht verfügbar. Bitte entferne Express oder versuch es später erneut.');
	    }
	    const exportSelection = selection.slice();
	    bundleSelections.forEach((bundleSelection) => {
	      exportSelection.push(...b2bSelectionForExport(
	        bundleSelection,
	        bundleSelection.quantity,
	        bundleSelection.shirtDistribution
	      ));
	    });
	    const exportProfiles = exportProfilesForSelection(exportSelection);
	    const profileTotals = new Map();
	    exportSelection.forEach(item => {
	      const key = productTypeForVariantKey(item.key);
	      const prev = profileTotals.get(key) || 0;
      profileTotals.set(key, prev + (item.quantity || 0));
    });
    const exportData = await ensureDesignExported(exportProfiles, profileTotals);
    const designIdForPreview = exportData.primaryId;

    // Gemeinsamen Design-Code hinter dem Präfix extrahieren
    let sharedCodeSuffix = '';
    if (exportData.primaryId) {
      const idx = exportData.primaryId.indexOf('-');
      if (idx > -1 && idx < exportData.primaryId.length - 1) {
        sharedCodeSuffix = exportData.primaryId.slice(idx + 1);
      }
    }

	    const previewDataUrl = await resolvePreviewForCheckout(designIdForPreview);
	    const previewRemoteUrl = await ensurePreviewUploaded(designIdForPreview, previewDataUrl);

	    const bundleIdByVariantKey = new Map();
		    const lineItems = selection.map(item => {
		      const variantId = resolveVariantId(item.key);
		      if (!variantId) {
		        throw new Error(`Für "${item.key}" ist noch keine Variant-ID hinterlegt.`);
		      }
      const profileKey = productTypeForVariantKey(item.key);
      // 1. Direktes Export-Ergebnis für dieses Profil
      let exportResult = exportData.results[profileKey] || null;

      // 2. Fallback: primäres Profil nutzen, damit der Checkout nicht abbricht
      if (!exportResult) {
        const primary = exportData.results[exportData.primaryProfile] || null;
        exportResult = {
          id: (primary && primary.id) || exportData.primaryId,
          pdfUrl: (primary && primary.pdfUrl) || window.__lastDesignPdfUrl || "",
          profile: window.__exportProfiles && window.__exportProfiles[profileKey]
        };
        exportData.results[profileKey] = exportResult;
        console.warn(`Kein direktes Export-Ergebnis für Profil "${profileKey}" – verwende Fallback-ID`, {
          fallbackId: exportResult.id,
          primaryProfile: exportData.primaryProfile,
          primaryResult: primary,
          resultsKeys: Object.keys(exportData.results || {})
        });
      }

      const pdfUrl = exportResult.pdfUrl;

      // Baseline: falls alles klappt, nimm die vom Export berechnete ID
      let designId = exportResult.id || exportData.primaryId;

      // Präfix pro Profil erzwingen, falls möglich
		      const prefix = getIdPrefixForProfile(profileKey);
		      if (sharedCodeSuffix && prefix) {
		        designId = `${prefix}${sharedCodeSuffix}`;
		      }
		      const properties = buildLineItemProperties(designId, previewDataUrl, pdfUrl, previewRemoteUrl);
		      properties['Produktionszeit'] = productionTimeLabelForVariantKey(item.key);
		      properties['_NH_VARIANT_KEY'] = item.key;
		      const bundleId = `${designId}::${item.key}`;
		      properties['_NH_BUNDLE_ID'] = bundleId;
		      bundleIdByVariantKey.set(item.key, bundleId);
		      return {
		        id: variantId,
		        quantity: item.quantity,
		        properties
		      };
		    });

	    if (wantsExpress && expressProductionVariantId) {
	      selection
		        .filter(item => isExpressSelectedForVariantKey(item.key))
		        .forEach(item => {
		          const bundleId = bundleIdByVariantKey.get(item.key) || item.key;
			          lineItems.push({
			            id: expressProductionVariantId,
			            quantity: Math.max(1, parseInt(item.quantity, 10) || 1),
			            properties: {
		              'Expressproduktion für': expressTargetLabelForVariantKey(item.key),
		              'Produktionszeit': EXPRESS_PRODUCTION_TIME_LABEL,
		              '_NH_EXPRESS_FOR_BUNDLE': bundleId,
		              '_NH_EXPRESS_FOR_KEY': item.key
		            }
		          });
		        });
		    }

	    bundleSelections.forEach((bundleSelection) => {
	      const tier = bundleSelection.tier;
	      const packageQuantity = Math.max(1, parseInt(bundleSelection.quantity, 10) || 1);
	      const shirtDistribution = Array.isArray(bundleSelection.shirtDistribution)
	        ? bundleSelection.shirtDistribution
	        : [];
	      const requiredShirts = Math.max(0, parseInt(tier?.shirts, 10) || 0);
	      const selectedShirts = shirtDistribution.reduce((sum, entry) => {
	        return sum + Math.max(0, parseInt(entry?.[1], 10) || 0);
	      }, 0);

	      if (requiredShirts && selectedShirts !== requiredShirts) {
	        throw new Error(
	          `${bundleSelection.title} · ${tier.label}: Bitte verteile je Paket genau ${requiredShirts} T-Shirts.`
	        );
	      }

	      const parentVariantId = tier?.variants?.[bundleSelection.shape];
	      if (!parentVariantId) {
	        throw new Error(`${bundleSelection.title} · ${tier?.label || ''}: Die Bundle-Variante fehlt.`);
	      }

	      const bundleExportSelection = b2bSelectionForExport(bundleSelection, 1, shirtDistribution);
	      const bundleProfiles = exportProfilesForSelection(bundleExportSelection);
	      const primaryProfile = bundleProfiles.find((profileKey) => exportData.results[profileKey])
	        || exportData.primaryProfile
	        || bundleProfiles[0];
	      const primaryResult = exportData.results[primaryProfile]
	        || exportData.results[exportData.primaryProfile]
	        || Object.values(exportData.results || {})[0]
	        || {};
	      const primaryDesignId = primaryResult.id || exportData.primaryId;
	      const primaryPdfUrl = primaryResult.pdfUrl || window.__lastDesignPdfUrl || '';
	      const properties = buildLineItemProperties(
	        primaryDesignId,
	        previewDataUrl,
	        primaryPdfUrl,
	        previewRemoteUrl
	      );
	      const shapeLabel = bundleSelection.shape === 'rect' ? 'Rechteckig' : 'Oval';
	      const componentLabels = [`${tier.stickers} Aufkleber Normal (${shapeLabel})`];
	      if (tier.mini) componentLabels.push(`${tier.mini} Aufkleber Mini (${shapeLabel})`);
	      if (tier.shirts) componentLabels.push(`${tier.shirts} T-Shirts`);
	      if (tier.mugs) componentLabels.push(`${tier.mugs} Keramiktassen`);
	      if (tier.flags) {
	        componentLabels.push(`${tier.flags} Fahne${tier.flags === 1 ? '' : 'n'} 150 × 86,5 cm`);
	      }

	      properties['Paket'] = `${bundleSelection.title} · ${tier.label}`;
	      properties['Aufkleberform'] = shapeLabel;
	      properties['Ein Design für alle Produkte'] = 'Ja';
	      if (requiredShirts) {
	        properties['T-Shirt-Aufteilung'] = `Je Paket: ${b2bShirtDistributionFromEntries(shirtDistribution)}`;
	      }
	      properties['Produktionszeit'] = STANDARD_PRODUCTION_TIME_LABEL;
	      properties['_NH_B2B_KEY'] = bundleSelection.key;
	      properties['_NH_B2B_TIER'] = bundleSelection.tierKey;
	      properties['_NH_B2B_SHAPE'] = bundleSelection.shape;
	      properties['_NH_B2B_COMPONENTS'] = componentLabels.join(' · ');
	      properties['_NH_B2B_SELECTION_ID'] = bundleSelection.uid;
	      properties['_NH_VARIANT_KEY'] = `b2b_${bundleSelection.key}_${bundleSelection.tierKey}_${bundleSelection.shape}`;
	      properties['_NH_BUNDLE_ID'] = `${primaryDesignId || 'DESIGN'}::B2B::${parentVariantId}::${bundleSelection.uid}`;
	      properties['_OP_MODE'] = 'editor-b2b';

	      bundleProfiles.forEach((profileKey) => {
	        const result = exportData.results[profileKey] || primaryResult;
	        if (!result) return;
	        const propertyKey = String(profileKey).toUpperCase().replace(/[^A-Z0-9]+/g, '_').slice(0, 28);
	        if (result.id) properties[`_NH_ID_${propertyKey}`] = result.id;
	        if (result.pdfUrl) properties[`_NH_PDF_${propertyKey}`] = result.pdfUrl;
	      });

	      lineItems.push({
	        id: parentVariantId,
	        quantity: packageQuantity,
	        properties
	      });
	    });

	    updateLoadingModalProgress(Math.max(lastProgressValue, 0.6), { autoShow: true });

    await addProductsToCart(lineItems);
    updateLoadingModalProgress(Math.max(lastProgressValue, 0.85), { autoShow: true });
    appendProgressDebug('Design-Dateien hochgeladen. Warenkorb wird vorbereitet …');

	    if (isProductAuditMode()) {
	      updateLoadingModalProgress(1, { autoShow: false });
	      appendProgressDebug('Prüfmodus: Warenkorb-Daten wurden lokal erfasst.');
	      return;
	    }

		    const proceedToCart = () => {
		      try {
		        const loadingModal = document.getElementById('loading-modal') || document.querySelector('.loading-modal');
		        if (loadingModal) loadingModal.setAttribute('aria-hidden', 'true');
		      } catch (_) { /* noop */ }

		      if (typeof window.closeExportModal === 'function') {
		        window.closeExportModal();
		      }

	      const cartUrl = '/cart';
	      const tab = window.__nhCartTab;
	      window.__nhCartTab = null;

	      try {
	        if (tab && !tab.closed) {
	          tab.location.href = cartUrl;
	          tab.focus();
	          return;
	        }
	      } catch (e) { /* noop */ }

	      window.open(cartUrl, '_blank', 'noopener');
	    };

	    if (DEBUG_PROGRESS_MODE) {
	      appendProgressDebug('Debug-Modus aktiv: Klicke auf „Zum Warenkorb“, sobald du den Verlauf gesehen hast.');
	      buildDebugContinueButton('Zum Warenkorb', () => {
	        updateLoadingModalProgress(1, { autoShow: false });
	        appendProgressDebug('Weiterleitung …');
	        proceedToCart();
	      });
	      return;
	    }

	    setTimeout(() => {
	      updateLoadingModalProgress(1, { autoShow: false });
	      appendProgressDebug('Weiterleitung …');
	      proceedToCart();
	    }, 600);
	  }

  window.handleExport = async function(_, progressCb){
    if (!isShopifyContext()) {
      if (typeof originalHandleExport === 'function') {
        return originalHandleExport.apply(this, arguments);
      }
      return;
    }
    try {
      const selection = collectSelectedVariants();
      if (typeof progressCb === 'function') progressCb(0.12);
      const editorReorderState = window.__nhEditorReorderState;
      if (editorReorderState && editorReorderState.kind === 'prefix-reorder') {
        await startShopifyCheckoutFromExistingAssets(selection, editorReorderState);
      } else {
        await startShopifyCheckout(selection);
      }
      if (typeof progressCb === 'function') progressCb(0.92);
    } catch (err) {
      console.error('Shopify Checkout Fehler', err);
      alert(err.message || 'Bestellung konnte nicht vorbereitet werden. Bitte versuch es erneut.');
		    } finally {
	      if (typeof progressCb === 'function') progressCb(1);
	      updateLoadingModalProgress(1, { autoShow: window.__nhCheckoutInProgress === true });
	    }
	  };

  function bindShopifyCheckoutButton() {
    if (window.__shopifyCheckoutBtnBound) return;
    window.__shopifyCheckoutBtnBound = true;
    let activeCheckoutButton = null;
    let checkoutInProgress = false;

    const toggleLoadingModal = (visible) => {
      const loadingModal = document.getElementById('loading-modal');
      if (!loadingModal) return;
      loadingModal.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const setLoadingState = (btn, isLoading, progress = null) => {
      const applyProgress = (value, options = {}) => {
        if (typeof value === 'number' && !Number.isNaN(value)) {
          updateLoadingModalProgress(value, { autoShow: checkoutInProgress && (isLoading || options.autoShow) });
          updateCartTabProgress(value);
        }
      };

      if (!btn) {
        applyProgress(progress, { autoShow: true });
        if (!isLoading) toggleLoadingModal(false);
        return;
      }

      if (isLoading) {
        checkoutInProgress = true;
        window.__nhCheckoutInProgress = true;
        btn.dataset.loading = 'true';
        toggleLoadingModal(true);
        activeCheckoutButton = btn;
      } else {
        delete btn.dataset.loading;
        checkoutInProgress = false;
        window.__nhCheckoutInProgress = false;
        if (activeCheckoutButton === btn) activeCheckoutButton = null;
        if (!DEBUG_PROGRESS_MODE) {
          toggleLoadingModal(false);
        }
      }

      applyProgress(progress, { autoShow: true });
      btn.disabled = !!isLoading;
      btn.classList.toggle('is-loading', !!isLoading);
    };

    const handleProgressValue = (raw) => {
      if (typeof raw !== 'number' || Number.isNaN(raw)) {
        return;
      }
      if (!checkoutInProgress && !activeCheckoutButton) return;
      const clamped = Math.max(0, Math.min(1, raw));
      const mapped = 0.15 + clamped * 0.7;
      updateLoadingModalProgress(mapped, { autoShow: checkoutInProgress });
      updateCartTabProgress(mapped);
      if (mapped >= 0.99) {
        updateLoadingModalProgress(1, { autoShow: checkoutInProgress });
        updateCartTabProgress(1);
      }
      if (activeCheckoutButton) {
        setLoadingState(activeCheckoutButton, true, mapped);
      }
    };

    window.addEventListener('nh:export-progress', (event) => {
      const raw = event?.detail?.value;
      if (!checkoutInProgress && !activeCheckoutButton) return;
      updateLoadingModalProgress(raw, { autoShow: checkoutInProgress && typeof raw === 'number' && raw > 0 });
      if (!activeCheckoutButton && typeof raw === 'number' && raw >= 1) toggleLoadingModal(false);
      handleProgressValue(raw);
      appendProgressDebug(`Custom event: ${Math.round((raw || 0) * 100)}%`);
    });

    window.addEventListener('message', (event) => {
      const data = event?.data;
      if (!data || typeof data !== 'object') return;
      if (data.type !== 'NH_EXPORT_PROGRESS') return;
      if (!checkoutInProgress && !activeCheckoutButton) return;
      updateLoadingModalProgress(data.value, { autoShow: checkoutInProgress && typeof data.value === 'number' && data.value > 0 });
      if (!activeCheckoutButton && typeof data.value === 'number' && data.value >= 1) toggleLoadingModal(false);
      handleProgressValue(data.value);
      appendProgressDebug(`Message event: ${Math.round((data.value || 0) * 100)}%`);
    });

		    document.addEventListener('click', async (event) => {
		      const button = event.target && event.target.closest
		        ? event.target.closest('#shopify-checkout-btn, [data-combined-checkout]')
		        : null;
		      if (!button) return;
		      event.preventDefault();
		      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
		      if (button.dataset.loading === 'true') return;

		      if (B2B_PRESET && button.id === 'shopify-checkout-btn') {
		        try {
		          if (typeof window.nhQueueActiveB2bPreset === 'function') {
		            window.nhQueueActiveB2bPreset();
		          }
		        } catch (err) {
		          alert(err?.message || 'Das Firmenpaket konnte nicht zur Auswahl hinzugefügt werden.');
		        }
		        return;
		      }

		      // Neuer Tab sofort (User-Gesture) -> später auf /cart navigieren (sonst Popup-Blocker)
		      if (!isProductAuditMode()) {
		        try {
		          window.__nhCartTab = window.open('about:blank', '_blank');
		          writeCartTabLoading(window.__nhCartTab);
		          updateCartTabProgress(0.05);
		          try {
		            window.__nhCartTab.blur?.();
		            window.focus?.();
		          } catch (_) { /* noop */ }
		        } catch (e) {
		          window.__nhCartTab = null;
		        }
		      } else {
		        window.__nhCartTab = null;
		      }

      setLoadingState(button, true, 0.05);
      try {
        if (typeof window.handleExport === 'function') {
          await Promise.resolve(window.handleExport('standard', (progress) => {
            setLoadingState(button, true, progress);
          }));
        }
	      } catch (err) {
	        console.error('Checkout-Start fehlgeschlagen', err);
	        try { writeCartTabError(err?.message); } catch (_) { /* noop */ }
	      } finally {
	        setLoadingState(button, false);
		      }
		    });
	  }

	  function isReorderPage() {
	    try {
	      const path = (window.location && window.location.pathname) ? String(window.location.pathname) : '';
	      // Match /pages/nachbestellen with optional locale prefix (/de/pages/...)
	      return /\/pages\/nachbestellen\/?$/.test(path);
	    } catch (_) {
	      return false;
	    }
	  }

	  const NH_REORDER_PROFILE_PREFIX_FALLBACK = {
	    sticker_normal_oval: 'NHO-',
	    sticker_normal_rect: 'NHR-',
	    sticker_mini_oval: 'MHO-',
	    sticker_mini_rect: 'MHR-',
	    sticker: 'NHO-',
	    beerdeckel: 'BD-',
	    flag_100x58: 'FH-',
	    flag_150x86: 'FH-',
	    flag_200x115: 'FH-',
	    flag_300x173: 'FH-',
	    tshirt: 'SH-',
	    hoodie: 'KP-',
	    mug_ceramic: 'TK-',
	    mug_enamel: 'TE-'
	  };

		  function nhEscapeHtml(str) {
		    return String(str || '')
		      .replaceAll('&', '&amp;')
		      .replaceAll('<', '&lt;')
		      .replaceAll('>', '&gt;')
		      .replaceAll('"', '&quot;')
		      .replaceAll("'", '&#039;');
		  }

		  function nhIsPdfUrl(url) {
		    return /\.pdf([?#]|$)/i.test(String(url || '').trim());
		  }

		  const NH_PDFJS_VERSION = '3.11.174';
		  const NH_PDFJS_SRC = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${NH_PDFJS_VERSION}/pdf.min.js`;
		  const NH_PDFJS_WORKER_SRC = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${NH_PDFJS_VERSION}/pdf.worker.min.js`;
		  let __nhPdfJsPromise = null;
		  function ensureNhPdfJsLoaded() {
		    try {
		      if (window.pdfjsLib && typeof window.pdfjsLib.getDocument === 'function') {
		        try { window.pdfjsLib.GlobalWorkerOptions.workerSrc = NH_PDFJS_WORKER_SRC; } catch (_) { /* noop */ }
		        return Promise.resolve(window.pdfjsLib);
		      }
		    } catch (_) { /* noop */ }

		    if (__nhPdfJsPromise) return __nhPdfJsPromise;

		    __nhPdfJsPromise = new Promise((resolve) => {
		      try {
		        const script = document.createElement('script');
		        script.src = NH_PDFJS_SRC;
		        script.async = true;
		        script.crossOrigin = 'anonymous';
		        script.onload = () => resolve(window.pdfjsLib || null);
		        script.onerror = () => resolve(null);
		        document.head.appendChild(script);
		      } catch (err) {
		        resolve(null);
		      }
		    }).then((lib) => {
		      if (!lib) return null;
		      try { lib.GlobalWorkerOptions.workerSrc = NH_PDFJS_WORKER_SRC; } catch (_) { /* noop */ }
		      return lib;
		    });

		    return __nhPdfJsPromise;
		  }

		  const __nhPdfThumbCache = window.__nhPdfThumbCache || new Map();
		  window.__nhPdfThumbCache = __nhPdfThumbCache;
			  async function nhPdfFirstPageThumbnailDataUrl(pdfUrl, maxEdge = PREVIEW_MAX_EDGE) {
			    const safeUrl = String(pdfUrl || '').trim();
			    if (!safeUrl) return '';

		    const cached = __nhPdfThumbCache.get(safeUrl);
		    if (typeof cached === 'string') return cached;
		    if (cached && typeof cached.then === 'function') return cached;

		    const promise = (async () => {
		      const lib = await ensureNhPdfJsLoaded();
		      if (!lib) return '';
		      try {
		        const loadingTask = lib.getDocument({ url: safeUrl, withCredentials: false });
		        const pdf = await loadingTask.promise;
		        const page = await pdf.getPage(1);
		        const viewport = page.getViewport({ scale: 1 });
		        const largestSide = Math.max(viewport.width || 0, viewport.height || 0) || 1;
		        const scale = Math.max(0.1, Math.min(2, maxEdge / largestSide));
		        const scaledViewport = page.getViewport({ scale });
		        const canvas = document.createElement('canvas');
		        canvas.width = Math.max(1, Math.round(scaledViewport.width || 1));
		        canvas.height = Math.max(1, Math.round(scaledViewport.height || 1));
		        const ctx = canvas.getContext('2d', { alpha: false });
		        await page.render({ canvasContext: ctx, viewport: scaledViewport, intent: 'display' }).promise;
		        const dataUrl = canvas.toDataURL('image/jpeg', 0.82);
		        try { page.cleanup(); } catch (_) { /* noop */ }
		        try { pdf.cleanup(); } catch (_) { /* noop */ }
		        return dataUrl;
		      } catch (err) {
		        console.warn('[NH Reorder] PDF Vorschau konnte nicht gerendert werden', err);
		        return '';
		      }
		    })();

		    __nhPdfThumbCache.set(safeUrl, promise);
		    const resolved = await promise;
			    __nhPdfThumbCache.set(safeUrl, resolved || '');
			    return resolved || '';
			  }

			  if (!window.nhPdfFirstPageThumbnailDataUrl) {
			    window.nhPdfFirstPageThumbnailDataUrl = nhPdfFirstPageThumbnailDataUrl;
			  }

		  function reorderProfilePrefix(profileKey) {
		    if (!profileKey) return null;
		    try {
	      const profiles = window.__exportProfiles || {};
	      const profile = profiles[profileKey];
	      const prefix = profile && profile.idPrefix ? String(profile.idPrefix) : '';
	      if (prefix) return prefix;
	    } catch (_) { /* noop */ }
	    return NH_REORDER_PROFILE_PREFIX_FALLBACK[profileKey] || null;
	  }

		  function normalizeDesignIdInput(raw) {
		    const value = String(raw || '').trim();
		    if (!value) return '';
		    let normalized = value.replace(/[‑–—−]/g, '-');
		    try {
		      if (/^https?:\/\//i.test(normalized)) {
		        const url = new URL(normalized);
		        normalized = (url.pathname.split('/').pop() || normalized).trim();
		      }
		    } catch (_) { /* noop */ }
		    normalized = normalized.replace(/[?#].*$/, '');
		    const withoutExt = normalized.replace(/\.(pdf|json|jpg|jpeg|png)$/i, '');
		    return withoutExt.replace(/-preview$/i, '').trim();
		  }

		  function normalizeDesignSuffix(raw) {
		    const value = normalizeDesignIdInput(raw);
		    if (!value) return '';
		    const idx = value.indexOf('-');
		    if (idx === -1) return value;
		    const prefix = value.slice(0, idx).trim();
		    const rest = value.slice(idx + 1).trim();
		    if (!rest) return value;
		    // Nur bekannte Präfix-IDs (z.B. NHO-, TK-, M-) abschneiden. Codes selbst enthalten ebenfalls Bindestriche.
		    if (/^[a-zA-Z]{1,4}$/.test(prefix)) return rest;
		    return value;
		  }

		  function buildReorderCandidateDesignIds(suffix) {
		    const normalized = String(suffix || '').trim();
		    if (!normalized) return {};
	    const keys = [
	      'sticker_normal_oval',
	      'sticker_normal_rect',
	      'sticker_mini_oval',
	      'sticker_mini_rect',
	      'beerdeckel',
	      'flag_100x58',
	      'flag_150x86',
	      'flag_200x115',
	      'flag_300x173',
	      'tshirt',
	      'hoodie',
	      'mug_ceramic',
	      'mug_enamel'
	    ];
		    const out = { main: `M-${normalized}` };
		    keys.forEach((profileKey) => {
		      const prefix = reorderProfilePrefix(profileKey);
		      if (!prefix) return;
		      out[profileKey] = `${prefix}${normalized}`;
		    });
		    return out;
		  }

	  function normalizeLookupResponse(json, candidatesByProfile) {
	    const previewUrl = (json && typeof json === 'object')
	      ? (json.previewUrl || json.preview || json.previewRemoteUrl || json.preview_remote_url || json.preview_view_url || '')
	      : '';

	    const profiles = {};
	    let main = null;

	    const takeProfile = (profileKey, raw) => {
	      if (!profileKey || !raw || typeof raw !== 'object') return;
	      const pdfUrl = raw.pdfUrl || raw.pdf_url || raw.url || raw.viewUrl || raw.view_url || '';
	      if (!pdfUrl) return;
	      const designId = raw.designId || raw.design_id || raw.id || candidatesByProfile?.[profileKey] || '';
	      profiles[profileKey] = { designId: String(designId || ''), pdfUrl: String(pdfUrl || '') };
	    };

	    if (json && typeof json === 'object') {
	      const buckets = [json.profiles, json.results, json.files];
	      buckets.forEach((bucket) => {
	        if (!bucket || typeof bucket !== 'object') return;
	        Object.entries(bucket).forEach(([k, v]) => takeProfile(k, v));
	      });

	      const arr = json.items || json.assets;
	      if (Array.isArray(arr)) {
	        arr.forEach((item) => {
	          if (!item || typeof item !== 'object') return;
	          takeProfile(item.profileKey || item.profile || item.key, item);
	        });
	      }

	      const byId = json.found || json.byId || json.urls;
	      if (byId && typeof byId === 'object') {
	        Object.entries(byId).forEach(([designId, pdfUrl]) => {
	          if (!pdfUrl) return;
	          const targetKey = Object.keys(candidatesByProfile || {}).find((k) => candidatesByProfile?.[k] === designId);
	          if (!targetKey) return;
	          profiles[targetKey] = { designId: String(designId), pdfUrl: String(pdfUrl) };
	        });
	      }

	      const rawMain = json.main || json.mainDesign || json.main_design || json.mainFile || json.main_file;
	      if (rawMain && typeof rawMain === 'object') {
	        const jsonUrl = rawMain.jsonUrl || rawMain.json_url || rawMain.url || rawMain.viewUrl || rawMain.view_url || '';
	        const designId = rawMain.designId || rawMain.design_id || rawMain.id || candidatesByProfile?.main || '';
	        if (designId || jsonUrl) {
	          main = { designId: String(designId || ''), jsonUrl: String(jsonUrl || '') };
	        }
	      }
	    }

	    return { previewUrl: String(previewUrl || ''), profiles, main };
	  }

	  function nhProfileLabel(profileKey) {
	    switch (profileKey) {
	      case 'sticker_normal_oval': return 'Aufkleber · Normal · Oval';
	      case 'sticker_normal_rect': return 'Aufkleber · Normal · Rechteck';
	      case 'sticker_mini_oval': return 'Aufkleber · Mini · Oval';
	      case 'sticker_mini_rect': return 'Aufkleber · Mini · Rechteck';
	      case 'beerdeckel': return 'Bierdeckel';
	      case 'tshirt': return 'T‑Shirt';
	      case 'hoodie': return 'Kapuzenpullover';
	      case 'mug_ceramic': return 'Tasse · Keramik';
	      case 'mug_enamel': return 'Tasse · Emaille';
	      default:
	        if (typeof profileKey === 'string' && profileKey.startsWith('flag_')) {
	          const size = profileKey.slice('flag_'.length);
	          return `Fahne · ${flagSizeLabel(size)}`;
	        }
	        return profileKey || 'Produkt';
	    }
	  }

	  function nhVariantLabel(key) {
	    if (!key) return '';
	    if (key.startsWith('oval_normal_')) return `${key.split('_')[2]} Stk`;
	    if (key.startsWith('rect_normal_')) return `${key.split('_')[2]} Stk`;
	    if (key.startsWith('oval_mini_')) return `${key.split('_')[2]} Stk`;
	    if (key.startsWith('rect_mini_')) return `${key.split('_')[2]} Stk`;
	    if (key.startsWith('beerdeckel_')) return `${key.split('_')[1]} Stk`;
	    if (key.startsWith('flag_')) {
	      const size = key.split('_')[1] || '';
	      return flagSizeLabel(size);
	    }
	    if (key.startsWith('tshirt_')) {
	      const parts = key.split('_');
	      const color = parts[1] === 'black' ? 'Schwarz' : 'Weiß';
	      const size = (parts[2] || '').toUpperCase();
	      return `${color} · ${size}`;
	    }
	    if (key.startsWith('hoodie_')) {
	      const parts = key.split('_');
	      const color = parts[1] === 'black' ? 'Schwarz' : 'Weiß';
	      const size = (parts[2] || '').toUpperCase();
	      return `${color} · ${size}`;
	    }
	    if (key === 'mug_ceramic') return 'Keramik';
	    if (key === 'mug_enamel') return 'Emaille';
	    return key;
	  }

	  function nhVariantKeysByProfile() {
	    if (window.__nhVariantKeysByProfileCache) return window.__nhVariantKeysByProfileCache;
	    const map = new Map();
	    Object.keys(SHOPIFY_VARIANT_MAP).forEach((variantKey) => {
	      const profileKey = productTypeForVariantKey(variantKey);
	      if (!profileKey) return;
	      const list = map.get(profileKey) || [];
	      list.push(variantKey);
	      map.set(profileKey, list);
	    });
	    // Stable ordering: pack sizes ascending, others alpha
	    Array.from(map.entries()).forEach(([profileKey, keys]) => {
	      const isPack = profileKey === 'beerdeckel' || (typeof profileKey === 'string' && profileKey.startsWith('sticker_'));
	      if (isPack) {
	        keys.sort((a, b) => {
	          const na = Number((a.match(/_(\d+)$/) || [])[1] || 0);
	          const nb = Number((b.match(/_(\d+)$/) || [])[1] || 0);
	          return na - nb;
	        });
	      } else {
	        keys.sort((a, b) => String(a).localeCompare(String(b)));
	      }
	      map.set(profileKey, keys);
	    });
	    window.__nhVariantKeysByProfileCache = map;
	    return map;
	  }

	  async function nhLookupDesignAssets(rawDesignId) {
	    const endpoint = typeof NETLIFY_FN === 'string' ? NETLIFY_FN : (window.NETLIFY_FN || '');
	    if (!endpoint) {
	      throw new Error('Lookup-Endpoint ist nicht konfiguriert (NETLIFY_FN).');
	    }

	    const cleanedDesignId = normalizeDesignIdInput(rawDesignId);
	    const suffix = normalizeDesignSuffix(cleanedDesignId);
	    if (!suffix) {
	      throw new Error('Bitte eine Design-ID eingeben.');
	    }

		    const candidates = buildReorderCandidateDesignIds(suffix);
		    const lookupId = candidates && candidates.main ? String(candidates.main) : String(cleanedDesignId || rawDesignId || '');
		    const payload = {
		      type: 'lookup',
		      id: lookupId,
		      designId: lookupId,
		      inputId: String(rawDesignId || ''),
		      suffix,
		      candidates
		    };

	    const response = await fetch(endpoint, {
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      },
	      body: JSON.stringify(payload)
	    });

	    const text = await response.text().catch(() => '');
	    let json;
	    try {
	      json = text ? JSON.parse(text) : {};
	    } catch (_) {
	      throw new Error('Design-Lookup fehlgeschlagen (kein JSON).');
	    }

	    if (!response.ok || !json || json.ok !== true) {
	      throw new Error((json && json.error) ? String(json.error) : 'Design-ID nicht gefunden.');
	    }

	    const normalized = normalizeLookupResponse(json, candidates);
	    return { suffix, candidates, normalized };
	  }

	  function ensureReorderPageStyles() {
	    if (document.getElementById('nh-reorder-style')) return;
	    const style = document.createElement('style');
	    style.id = 'nh-reorder-style';
	    style.textContent = `
	      .nh-reorder { max-width: 1080px; margin: 36px auto; padding: 0 16px; }
	      .nh-reorder__card {
	        background: #fff;
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        border-radius: 18px;
	        box-shadow: 0 22px 60px rgba(15, 23, 42, 0.08);
	        padding: 18px;
	      }
	      .nh-reorder__header { display: grid; gap: 14px; align-items: start; }
	      .nh-reorder__title { margin: 0; font-size: 1.55rem; letter-spacing: -0.015em; }
	      .nh-reorder__subtitle { margin: 0; color: rgba(15, 23, 42, 0.72); }
	      .nh-reorder__form { display: grid; grid-template-columns: 1fr; gap: 10px; }
	      .nh-reorder__field { display: grid; gap: 6px; }
	      .nh-reorder__label { font-weight: 700; font-size: 0.95rem; color: rgba(15, 23, 42, 0.92); }
	      .nh-reorder__input {
	        width: 100%;
	        padding: 12px 12px;
	        border-radius: 14px;
	        border: 1px solid rgba(15, 23, 42, 0.18);
	        background: rgba(15, 23, 42, 0.03);
	        color: #0f172a;
	      }
	      .nh-reorder__row { display: flex; gap: 10px; align-items: center; }
	      .nh-reorder__status { margin-top: 10px; font-weight: 700; }
	      .nh-reorder__status.is-muted { font-weight: 600; color: rgba(15, 23, 42, 0.68); }
	      .nh-reorder__status.is-error { color: #b91c1c; }
		      .nh-reorder__status.is-success { color: #047857; }
		      .nh-reorder__results { margin-top: 18px; display: grid; gap: 14px; }
		      .nh-reorder__preview { display: grid; gap: 10px; }
		      .nh-reorder__preview img { width: 100%; height: 260px; object-fit: contain; border-radius: 14px; border: 1px solid rgba(15, 23, 42, 0.12); background: #f7f8f9; display: block; pointer-events: none; user-select: none; -webkit-user-drag: none; -webkit-touch-callout: none; }
		      .nh-reorder__thumb-placeholder { width: 100%; height: 260px; border-radius: 14px; border: 1px solid rgba(15, 23, 42, 0.12); background: #f7f8f9; display: flex; align-items: center; justify-content: center; color: rgba(15, 23, 42, 0.58); font-weight: 800; user-select: none; -webkit-user-drag: none; -webkit-touch-callout: none; }
		      .nh-reorder__products { display: grid; gap: 12px; }
	      .nh-reorder__group { border: 1px solid rgba(15, 23, 42, 0.10); border-radius: 16px; padding: 14px; }
	      .nh-reorder__group-title { margin: 0 0 10px 0; font-size: 1.06rem; font-weight: 900; letter-spacing: -0.01em; }
	      .nh-reorder__pack { display: grid; grid-template-columns: 1fr 120px; gap: 10px; align-items: end; }
	      .nh-reorder__select { width: 100%; padding: 11px 12px; border-radius: 14px; border: 1px solid rgba(15, 23, 42, 0.18); background: rgba(15, 23, 42, 0.03); }
	      .nh-reorder__qty { width: 100%; padding: 11px 10px; border-radius: 14px; border: 1px solid rgba(15, 23, 42, 0.18); background: rgba(15, 23, 42, 0.03); }
	      .nh-reorder__variants { display: grid; gap: 8px; }
	      .nh-reorder__variant { display: flex; justify-content: space-between; gap: 12px; align-items: center; }
	      .nh-reorder__variant-label { font-weight: 700; color: rgba(15, 23, 42, 0.9); }
	      .nh-reorder__hint { margin: 0; color: rgba(15, 23, 42, 0.65); font-size: 0.95rem; }
	      .nh-reorder__actions { display: flex; gap: 12px; align-items: center; justify-content: space-between; flex-wrap: wrap; }
	      .nh-reorder__actions-right { display: inline-flex; gap: 10px; align-items: center; flex-wrap: wrap; justify-content: flex-end; }
	      .nh-reorder__btn {
	        display: inline-flex; align-items: center; justify-content: center;
	        border-radius: 999px;
	        padding: 12px 16px;
	        font-weight: 900;
	        border: 0;
	        background: #16a34a;
	        color: #fff;
	        cursor: pointer;
	        text-decoration: none;
	      }
	      .nh-reorder__btn[disabled] { opacity: 0.65; cursor: not-allowed; }
	      .nh-reorder__btn--ghost {
	        background: rgba(15, 23, 42, 0.06);
	        color: #0f172a;
	        border: 1px solid rgba(15, 23, 42, 0.14);
	      }
	      .nh-reorder__btn--ghost:hover { background: rgba(15, 23, 42, 0.08); }
	      @media (min-width: 900px) {
	        .nh-reorder__header { grid-template-columns: 1.1fr 0.9fr; }
	        .nh-reorder__form { grid-template-columns: 1fr auto; align-items: end; }
	      }
	    `;
	    document.head.appendChild(style);
	  }

	  function ensureReorderModalStyles() {
	    if (document.getElementById('nh-reorder-modal-style')) return;
	    const style = document.createElement('style');
	    style.id = 'nh-reorder-modal-style';
	    style.textContent = `
	      #nh-reorder-modal,
	      #product-info-modal.nh-reorder-info-modal {
	        position: fixed;
	        inset: 0;
	        display: none;
	        align-items: flex-start;
	        justify-content: center;
	        padding: 16px;
	        z-index: 10000;
	      }

	      #nh-reorder-modal[aria-hidden="false"],
	      #product-info-modal.nh-reorder-info-modal[aria-hidden="false"] {
	        display: flex;
	      }

	      #nh-reorder-modal .nh-reorder-modal__backdrop,
	      #product-info-modal.nh-reorder-info-modal .nh-reorder-modal__backdrop {
	        position: absolute;
	        inset: 0;
	        background: rgba(15, 23, 42, 0.45);
	        backdrop-filter: blur(4px);
	      }

	      #nh-reorder-modal .nh-reorder-modal__dialog,
	      #product-info-modal.nh-reorder-info-modal .nh-reorder-modal__dialog {
	        position: relative;
	        width: 100%;
	        max-width: 1120px;
	        background: #fff;
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        border-radius: 28px;
	        box-shadow: 0 36px 90px rgba(17, 17, 17, 0.32);
	        padding: 18px;
	        max-height: min(92vh, 980px);
	        overflow: auto;
	        display: flex;
	        flex-direction: column;
	        gap: 16px;
	      }

	      #product-info-modal.nh-reorder-info-modal .nh-reorder-modal__dialog {
	        max-width: 760px;
	      }

	      #nh-reorder-modal .nh-reorder-modal__close,
	      #product-info-modal.nh-reorder-info-modal .product-info-close {
	        position: absolute;
	        top: 12px;
	        right: 12px;
	        width: 40px;
	        height: 40px;
	        border-radius: 999px;
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        background: rgba(255, 255, 255, 0.95);
	        cursor: pointer;
	        font-size: 18px;
	        font-weight: 900;
	        line-height: 1;
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	      }

	      #nh-reorder-modal .nh-reorder-modal__header {
	        display: grid;
	        gap: 12px;
	        align-items: start;
	      }

	      #nh-reorder-modal .nh-reorder-modal__title {
	        margin: 0;
	        font-size: 1.25rem;
	        letter-spacing: -0.01em;
	      }

	      #nh-reorder-modal .nh-reorder-modal__subtitle {
	        margin: 6px 0 0;
	        color: rgba(15, 23, 42, 0.72);
	        line-height: 1.5;
	      }

		      #nh-reorder-modal .nh-reorder-modal__preview img {
		        width: 100%;
		        max-width: 240px;
		        height: 180px;
		        object-fit: contain;
		        border-radius: 14px;
		        border: 1px solid rgba(15, 23, 42, 0.12);
		        background: #f7f8f9;
		        display: block;
		        pointer-events: none;
		        user-select: none;
		        -webkit-user-drag: none;
		        -webkit-touch-callout: none;
		      }
		      #nh-reorder-modal .nh-reorder-modal__preview .nh-reorder__thumb-placeholder { height: 180px; max-width: 240px; }

	      #nh-reorder-modal .nh-reorder-caret {
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	        width: 22px;
	        height: 22px;
	        border-radius: 999px;
	        background: rgba(15, 23, 42, 0.06);
	        color: rgba(15, 23, 42, 0.85);
	        font-weight: 900;
	        flex: 0 0 auto;
	      }

	      @media (min-width: 980px) {
	        #nh-reorder-modal .nh-reorder-modal__header {
	          grid-template-columns: 1fr auto;
	        }
	      }

	      /* Selector (scoped) */
	      #nh-reorder-modal #shopifySelector {
	        border: 1px solid rgba(255, 214, 64, 0.5);
	        border-radius: 20px;
	        padding: 16px;
	        background: linear-gradient(180deg, #fffdf4 0%, #ffffff 55%);
	        box-shadow: 0 18px 60px rgba(15, 23, 42, 0.12);
	        display: flex;
	        flex-direction: column;
	        gap: 16px;
	        font-size: 1rem;
	      }

	      #nh-reorder-modal #shopifySelector .selector-grid {
	        display: grid;
	        grid-template-columns: minmax(0, 1fr) 420px;
	        gap: 18px;
	        align-items: start;
	      }

	      @media (max-width: 980px) {
	        #nh-reorder-modal #shopifySelector .selector-grid {
	          grid-template-columns: 1fr;
	        }
	      }

	      #nh-reorder-modal #shopifySelector .selector-main {
	        display: flex;
	        flex-direction: column;
	        gap: 12px;
	      }

	      #nh-reorder-modal #shopifySelector .product-card {
	        border: 1px solid rgba(15, 23, 42, 0.08);
	        border-radius: 18px;
	        background: linear-gradient(145deg, #ffffff 0%, #fff9da 100%);
	        box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);
	        overflow: hidden;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__header {
	        display: flex;
	        align-items: center;
	        gap: 10px;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__header-btn {
	        display: flex;
	        align-items: center;
	        justify-content: space-between;
	        gap: 18px;
	        flex: 1 1 auto;
	        min-width: 0;
	        border: 0;
	        background: none;
	        padding: 12px 14px;
	        cursor: pointer;
	        text-align: left;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__titles {
	        display: flex;
	        flex-wrap: wrap;
	        align-items: baseline;
	        gap: 10px;
	        min-width: 0;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__title {
	        font-size: 1.15rem;
	        font-weight: 900;
	        color: #0f172a;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__summary {
	        font-size: 0.92rem;
	        color: #475569;
	        padding: 2px 10px;
	        border-radius: 999px;
	        background: rgba(15, 23, 42, 0.04);
	        border: 1px solid rgba(15, 23, 42, 0.08);
	      }

	      #nh-reorder-modal #shopifySelector .product-card__info-btn {
	        width: 34px;
	        height: 34px;
	        flex: 0 0 auto;
	        border-radius: 12px;
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        background: rgba(255, 255, 255, 0.92);
	        color: #0f172a;
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	        font-weight: 900;
	        cursor: pointer;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__body {
	        border-top: 1px solid rgba(15, 23, 42, 0.08);
	        padding: 12px 14px 14px;
	        display: flex;
	        flex-direction: column;
	        gap: 12px;
	      }

	      #nh-reorder-modal #shopifySelector .product-card__body[hidden] { display: none; }

	      #nh-reorder-modal #shopifySelector .product-field {
	        display: flex;
	        flex-direction: column;
	        gap: 6px;
	      }

	      #nh-reorder-modal #shopifySelector .product-field__label {
	        font-size: 1.05rem;
	        font-weight: 800;
	        color: #0f172a;
	      }

	      #nh-reorder-modal #shopifySelector .pill-select {
	        display: flex;
	        flex-wrap: wrap;
	        gap: 8px;
	      }

	      #nh-reorder-modal #shopifySelector .pill {
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        border-radius: 999px;
	        padding: 7px 12px;
	        background: rgba(15, 23, 42, 0.04);
	        font-size: 0.95rem;
	        font-weight: 800;
	        cursor: pointer;
	      }

	      #nh-reorder-modal #shopifySelector .pill.is-active {
	        background: rgba(255, 230, 0, 0.95);
	        border-color: rgba(255, 230, 0, 0.95);
	        color: #111;
	        box-shadow: 0 8px 18px rgba(255, 230, 0, 0.35);
	      }

	      #nh-reorder-modal #shopifySelector .pill:disabled {
	        opacity: 0.6;
	        cursor: not-allowed;
	      }

	      #nh-reorder-modal #shopifySelector .product-hint {
	        margin: 0;
	        font-size: 0.92rem;
	        color: rgba(15, 23, 42, 0.65);
	        line-height: 1.45;
	      }

	      #nh-reorder-modal #shopifySelector .variant-inputs { display: none; }

	      #nh-reorder-modal #shopifySelector .selector-summary-card {
	        position: sticky;
	        top: 18px;
	        background: #ffffff;
	        border: 1px solid rgba(15, 23, 42, 0.08);
	        border-radius: 18px;
	        box-shadow: 0 18px 60px rgba(15, 23, 42, 0.12);
	        padding: 14px;
	      }

	      @media (max-width: 980px) {
	        #nh-reorder-modal #shopifySelector .selector-summary-card {
	          position: static;
	        }
	      }

	      #nh-reorder-modal #shopifySelector .selector-summary-card h3 {
	        margin: 0;
	        font-size: 1.22rem;
	        font-weight: 900;
	        letter-spacing: -0.01em;
	        color: #0f172a;
	      }

	      #nh-reorder-modal #shopifySelector .selector-summary-hint {
	        margin: 6px 0 12px;
	        color: #64748b;
	        font-size: 0.95rem;
	        line-height: 1.5;
	      }

	      #nh-reorder-modal #shopifySelector .selector-selection-list {
	        display: flex;
	        flex-direction: column;
	        gap: 10px;
	        min-height: 56px;
	      }

	      #nh-reorder-modal #shopifySelector .selector-empty-state {
	        border: 1px dashed rgba(15, 23, 42, 0.18);
	        background: rgba(255, 230, 0, 0.08);
	        color: #64748b;
	        border-radius: 14px;
	        padding: 12px;
	        font-size: 0.95rem;
	      }

	      #nh-reorder-modal #shopifySelector .selector-item {
	        display: grid;
	        grid-template-columns: 1fr auto;
	        gap: 10px;
	        align-items: start;
	        padding: 12px;
	        border-radius: 14px;
	        border: 1px solid rgba(15, 23, 42, 0.08);
	        background: rgba(255, 255, 255, 0.9);
	      }

	      #nh-reorder-modal #shopifySelector .selector-item__title {
	        font-weight: 900;
	        color: #0f172a;
	        font-size: 1rem;
	        margin: 0;
	      }

	      #nh-reorder-modal #shopifySelector .selector-item__meta {
	        margin: 4px 0 0;
	        color: #475569;
	        font-size: 0.92rem;
	        line-height: 1.35;
	      }

	      #nh-reorder-modal #shopifySelector .selector-item__badge {
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	        padding: 6px 10px;
	        border-radius: 999px;
	        font-weight: 900;
	        font-size: 0.9rem;
	        background: rgba(15, 23, 42, 0.06);
	        color: #0f172a;
	        white-space: nowrap;
	      }

	      #nh-reorder-modal #shopifySelector .selector-item__remove {
	        width: 34px;
	        height: 34px;
	        border-radius: 12px;
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        background: rgba(255, 255, 255, 0.9);
	        cursor: pointer;
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	      }

	      #nh-reorder-modal #shopifySelector .selector-summary-footer {
	        margin-top: 12px;
	        padding-top: 12px;
	        border-top: 1px solid rgba(15, 23, 42, 0.08);
	        display: flex;
	        flex-direction: column;
	        gap: 10px;
	      }

	      #nh-reorder-modal #shopifySelector .selector-total {
	        margin: 0;
	        font-weight: 900;
	        color: #0f172a;
	        font-size: 1.05rem;
	      }

	      #nh-reorder-modal #shopifySelector .selector-checkout-hint {
	        margin: 0;
	        color: #64748b;
	        font-size: 0.9rem;
	        line-height: 1.45;
	      }

	      #nh-reorder-modal #shopifySelector .selector-express {
	        margin-top: 8px;
	        display: inline-flex;
	        align-items: center;
	        gap: 10px;
	        padding: 8px 10px;
	        border-radius: 14px;
	        border: 1px solid rgba(15, 23, 42, 0.08);
	        background: rgba(15, 23, 42, 0.03);
	        color: #0f172a;
	        font-size: 0.92rem;
	        font-weight: 900;
	        cursor: pointer;
	        user-select: none;
	      }

	      #nh-reorder-modal #shopifySelector .selector-express:hover {
	        background: rgba(15, 23, 42, 0.05);
	      }

	      #nh-reorder-modal #shopifySelector .selector-express.is-disabled {
	        opacity: 0.6;
	        cursor: not-allowed;
	      }

	      #nh-reorder-modal #shopifySelector .selector-express.is-disabled:hover {
	        background: rgba(15, 23, 42, 0.03);
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__input {
	        position: absolute;
	        opacity: 0;
	        width: 1px;
	        height: 1px;
	        overflow: hidden;
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__toggle {
	        width: 44px;
	        height: 24px;
	        border-radius: 999px;
	        background: rgba(15, 23, 42, 0.16);
	        box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.12);
	        position: relative;
	        flex: 0 0 auto;
	        transition: background 0.18s ease, box-shadow 0.18s ease;
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__toggle::after {
	        content: '';
	        position: absolute;
	        top: 3px;
	        left: 3px;
	        width: 18px;
	        height: 18px;
	        border-radius: 999px;
	        background: #ffffff;
	        box-shadow: 0 10px 20px rgba(15, 23, 42, 0.18);
	        transition: transform 0.18s ease;
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__input:checked + .selector-express__toggle {
	        background: rgba(34, 197, 94, 0.85);
	        box-shadow: inset 0 0 0 1px rgba(22, 163, 74, 0.45);
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__input:checked + .selector-express__toggle::after {
	        transform: translateX(20px);
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__input:focus-visible + .selector-express__toggle {
	        outline: none;
	        box-shadow: 0 0 0 4px rgba(255, 230, 0, 0.35), inset 0 0 0 1px rgba(15, 23, 42, 0.12);
	      }

	      #nh-reorder-modal #shopifySelector .selector-express__label {
	        font-weight: 900;
	        color: #0f172a;
	      }

	      /* Apparel & mugs */
	      #nh-reorder-modal #shopifySelector .product-field--stack { gap: 12px; }
	      #nh-reorder-modal #shopifySelector .tshirt-grid { display: flex; flex-direction: column; gap: 12px; }
	      #nh-reorder-modal #shopifySelector .tshirt-color-group {
	        border: 1px solid rgba(15, 23, 42, 0.08);
	        border-radius: 18px;
	        padding: 12px;
	        background: rgba(255, 255, 255, 0.8);
	        display: flex;
	        flex-direction: column;
	        gap: 10px;
	      }
	      #nh-reorder-modal #shopifySelector .tshirt-color-header { display: flex; align-items: center; gap: 10px; font-weight: 800; color: #0f172a; }
	      #nh-reorder-modal #shopifySelector .tshirt-color-dot { width: 14px; height: 14px; border-radius: 999px; box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.18); }
	      #nh-reorder-modal #shopifySelector .tshirt-color-dot.is-white { background: #fff; }
	      #nh-reorder-modal #shopifySelector .tshirt-color-dot.is-black { background: #0f172a; }
	      #nh-reorder-modal #shopifySelector .tshirt-size-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 10px; }
	      #nh-reorder-modal #shopifySelector .tshirt-size-input { display: flex; flex-direction: column; gap: 8px; font-weight: 800; color: #0f172a; }
	      #nh-reorder-modal #shopifySelector .qty-control {
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	        gap: 6px;
	        border: 1px solid rgba(15, 23, 42, 0.12);
	        border-radius: 999px;
	        padding: 4px;
	        background: #fff;
	        min-height: 44px;
	      }
	      #nh-reorder-modal #shopifySelector .qty-control input {
	        width: 56px;
	        text-align: center;
	        border: 0;
	        background: transparent;
	        font-weight: 900;
	        font-size: 1rem;
	        appearance: textfield;
	      }
	      #nh-reorder-modal #shopifySelector .qty-btn {
	        width: 32px;
	        height: 32px;
	        border-radius: 14px;
	        border: 0;
	        background: rgba(15, 23, 42, 0.08);
	        font-size: 20px;
	        font-weight: 900;
	        color: #0f172a;
	        display: inline-flex;
	        align-items: center;
	        justify-content: center;
	        cursor: pointer;
	      }
	      #nh-reorder-modal #shopifySelector .mug-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 12px; }
	      #nh-reorder-modal #shopifySelector .flag-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
	      #nh-reorder-modal #shopifySelector .mug-variant-card { border: 1px solid rgba(15, 23, 42, 0.08); border-radius: 18px; padding: 12px; background: rgba(255, 255, 255, 0.9); }
	      #nh-reorder-modal #shopifySelector .mug-variant-header { display: flex; flex-direction: column; gap: 2px; margin-bottom: 8px; }
	      #nh-reorder-modal #shopifySelector .mug-variant-title { font-weight: 900; color: #0f172a; }
	      #nh-reorder-modal #shopifySelector .mug-variant-note { font-size: 0.9rem; color: #475569; }
	      @media (max-width: 700px) {
	        #nh-reorder-modal #shopifySelector .flag-grid { grid-template-columns: 1fr; }
	      }

	      /* Product info modal (scoped) */
	      #product-info-modal.nh-reorder-info-modal h3 {
	        margin: 0;
	        font-size: 1.15rem;
	        letter-spacing: -0.01em;
	        color: #0f172a;
	      }
	      #product-info-modal.nh-reorder-info-modal ul {
	        margin: 10px 0 0;
	        padding-left: 18px;
	        color: rgba(15, 23, 42, 0.82);
	        line-height: 1.45;
	      }
	      #product-info-modal.nh-reorder-info-modal p {
	        margin: 10px 0 0;
	        color: rgba(15, 23, 42, 0.82);
	        line-height: 1.45;
	      }
	    `;
	    document.head.appendChild(style);
	  }

	  function ensureReorderProductSelectorModal() {
	    const existing = document.getElementById('nh-reorder-modal');
	    if (existing) return existing;

	    ensureReorderModalStyles();

	    const stickerPacks = [0, 1, 5, 10, 30, 50, 100, 250, 500, 1000, 1500, 2500, 5000, 6000];
        const beerdeckelPacks = [0, 1, 5, 10, 25, 50, 100, 250, 500, 1000, 1500, 2500, 5000];

	    const buildPills = (values, formatter = null) => {
	      return values.map((value, idx) => {
	        const label = typeof formatter === 'function' ? formatter(value) : String(value);
	        const active = idx === 0 ? ' is-active' : '';
	        return `<button class="pill${active}" data-value="${nhEscapeHtml(value)}" type="button">${nhEscapeHtml(label)}</button>`;
	      }).join('');
	    };

	    const flagValues = [
	      { value: '100x58', label: '100 × 58 cm' },
	      { value: '150x86', label: '150 × 86,5 cm' },
	      { value: '200x115', label: '200 × 115,5 cm' },
	      { value: '300x173', label: '300 × 173,4 cm' }
	    ];

	    const buildFlagQuantityGrid = () => {
	      return flagValues.map((entry) => {
	        const value = nhEscapeHtml(entry.value);
	        const label = nhEscapeHtml(entry.label);
	        return `
	          <div class="mug-variant-card flag-variant-card" data-flag-size="${value}">
	            <div class="mug-variant-header">
	              <span class="mug-variant-title">${label}</span>
	              <span class="mug-variant-note">Menge frei wählbar</span>
	            </div>
	            <div class="qty-control" data-qty-control="">
	              <button aria-label="Weniger Fahnen ${label}" class="qty-btn" data-qty-step="-1" type="button">-</button>
	              <input aria-label="Fahnen ${label}" data-input="flag-variant" data-size="${value}" inputmode="numeric" max="99" min="0" pattern="[0-9]*" type="number" value="0"/>
	              <button aria-label="Mehr Fahnen ${label}" class="qty-btn" data-qty-step="1" type="button">+</button>
	            </div>
	          </div>
	        `;
	      }).join('');
	    };

	    const sizeLabel = (size) => {
	      const upper = String(size || '').toUpperCase();
	      if (upper === 'XXXL') return 'XXXL';
	      if (upper === 'XXL') return 'XXL';
	      if (upper === 'XL') return 'XL';
	      return upper;
	    };

	    const buildColorSizeGrid = ({ inputKey, sizes }) => {
	      const colors = [
	        { key: 'white', label: 'Weiß', dot: 'is-white' },
	        { key: 'black', label: 'Schwarz', dot: 'is-black' }
	      ];
	      return `
	        <div class="tshirt-grid">
	          ${colors.map((c) => `
	            <div class="tshirt-color-group">
	              <div class="tshirt-color-header">
	                <span aria-hidden="true" class="tshirt-color-dot ${c.dot}"></span>
	                <span>${c.label}</span>
	              </div>
	              <div class="tshirt-size-grid">
	                ${sizes.map((s) => {
	                  const label = sizeLabel(s);
	                  return `
	                    <div class="tshirt-size-input">
	                      <span>${nhEscapeHtml(label)}</span>
	                      <div class="qty-control" data-qty-control="">
	                        <button aria-label="Weniger ${c.label} Größe ${label}" class="qty-btn" data-qty-step="-1" type="button">-</button>
	                        <input aria-label="${c.label} · Größe ${label}" data-color="${c.key}" data-input="${inputKey}" data-size="${s}" inputmode="numeric" max="99" min="0" pattern="[0-9]*" type="number" value="0"/>
	                        <button aria-label="Mehr ${c.label} Größe ${label}" class="qty-btn" data-qty-step="1" type="button">+</button>
	                      </div>
	                    </div>
	                  `;
	                }).join('')}
	              </div>
	            </div>
	          `).join('')}
	        </div>
	      `;
	    };

	    const tshirtSizes = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl'];
	    const hoodieSizes = ['s', 'm', 'l', 'xl', 'xxl'];

	    const modal = document.createElement('div');
	    modal.id = 'nh-reorder-modal';
	    modal.setAttribute('aria-hidden', 'true');
	    modal.innerHTML = `
	      <div class="nh-reorder-modal__backdrop" data-nh-reorder-close="1"></div>
	      <div class="nh-reorder-modal__dialog" role="dialog" aria-modal="true" aria-label="Produkte auswählen">
	        <button class="nh-reorder-modal__close" type="button" aria-label="Schließen" data-nh-reorder-close="1">✕</button>

	        <div class="nh-reorder-modal__header">
	          <div>
	            <h2 class="nh-reorder-modal__title">Produkte auswählen</h2>
	            <p class="nh-reorder-modal__subtitle">Wähle die passenden Produkte zu deinem Design und lege sie anschließend in den Warenkorb.</p>
	          </div>
	          <div class="nh-reorder-modal__preview" id="nh-reorder-modal-preview" hidden></div>
	        </div>

	        <section class="shopify-selector shopify-selector--v2" id="shopifySelector">
	          <div class="selector-grid">
	            <div class="selector-main">
	              <article class="product-card" data-product="stickers">
	                <header class="product-card__header">
	                  <button aria-expanded="false" class="product-card__header-btn" type="button">
	                    <div class="product-card__titles">
	                      <span class="product-card__title">Aufkleber</span>
	                      <span class="product-card__summary" data-summary="stickers">Noch nichts ausgewählt</span>
	                    </div>
	                    <span class="nh-reorder-caret" aria-hidden="true">▾</span>
	                  </button>
	                  <button class="product-card__info-btn" type="button" data-product-info="stickers" aria-label="Info zu Aufkleber">i</button>
	                </header>
	                <div class="product-card__body" data-body="stickers" hidden="">
	                  <div class="product-field">
	                    <span class="product-field__label">Normal · Oval</span>
	                    <div class="pill-select" data-pill-group="stickers-qty-normal-oval" role="group">
	                      ${buildPills(stickerPacks)}
	                    </div>
	                  </div>
	                  <div class="product-field">
	                    <span class="product-field__label">Normal · Rechteckig</span>
	                    <div class="pill-select" data-pill-group="stickers-qty-normal-rect" role="group">
	                      ${buildPills(stickerPacks)}
	                    </div>
	                  </div>
	                  <div class="product-field">
	                    <span class="product-field__label">Mini · Oval</span>
	                    <div class="pill-select" data-pill-group="stickers-qty-mini-oval" role="group">
	                      ${buildPills(stickerPacks)}
	                    </div>
	                  </div>
	                  <div class="product-field">
	                    <span class="product-field__label">Mini · Rechteckig</span>
	                    <div class="pill-select" data-pill-group="stickers-qty-mini-rect" role="group">
	                      ${buildPills(stickerPacks)}
	                    </div>
	                  </div>
	                  <p class="product-hint">Aufkleber Normal und Mini separat; jedes Paket enthält genau diese Stückzahl.</p>
	                </div>
	              </article>

	              <article class="product-card" data-product="flag">
	                <header class="product-card__header">
	                  <button aria-expanded="false" class="product-card__header-btn" type="button">
	                    <div class="product-card__titles">
	                      <span class="product-card__title">Fahne</span>
	                      <span class="product-card__summary" data-summary="flag">Noch nichts ausgewählt</span>
	                    </div>
	                    <span class="nh-reorder-caret" aria-hidden="true">▾</span>
	                  </button>
	                  <button class="product-card__info-btn" type="button" data-product-info="flag" aria-label="Info zur Fahne">i</button>
	                </header>
	                <div class="product-card__body" data-body="flag" hidden="">
	                  <div class="product-field product-field--stack">
	                    <span class="product-field__label">Größe &amp; Menge</span>
	                    <div class="mug-grid flag-grid">
	                      ${buildFlagQuantityGrid()}
	                    </div>
	                  </div>
	                  <p class="product-hint">Lege die Stückzahl für jede Größe separat fest; mehrere Größen können zusammen bestellt werden.</p>
	                  <p class="product-hint" data-flag-note="">Dein ovales Design bleibt vollständig sichtbar; die rechteckige Fahnenfläche außerhalb des Ovals wird weiß.</p>
	                </div>
	              </article>

	              <article class="product-card" data-product="beerdeckel">
	                <header class="product-card__header">
	                  <button aria-expanded="false" class="product-card__header-btn" type="button">
	                    <div class="product-card__titles">
	                      <span class="product-card__title">Bierdeckel</span>
	                      <span class="product-card__summary" data-summary="beerdeckel">Noch nichts ausgewählt</span>
	                    </div>
	                    <span class="nh-reorder-caret" aria-hidden="true">▾</span>
	                  </button>
	                  <button class="product-card__info-btn" type="button" data-product-info="beerdeckel" aria-label="Info zu Bierdeckeln">i</button>
	                </header>
	                <div class="product-card__body" data-body="beerdeckel" hidden="">
	                  <div class="product-field">
	                    <span class="product-field__label">Menge</span>
	                    <div class="pill-select" data-pill-group="beerdeckel-qty" role="group">
	                      ${buildPills(beerdeckelPacks)}
	                    </div>
	                  </div>
	                  <p class="product-hint" data-beerdeckel-note="">Bierdeckel werden als Packung bestellt (Stückzahl steht auf dem Button).</p>
	                </div>
	              </article>

	              <article class="product-card" data-product="tshirt">
	                <header class="product-card__header">
	                  <button aria-expanded="false" class="product-card__header-btn" type="button">
	                    <div class="product-card__titles">
	                      <span class="product-card__title">T‑Shirt</span>
	                      <span class="product-card__summary" data-summary="tshirt">Noch nichts ausgewählt</span>
	                    </div>
	                    <span class="nh-reorder-caret" aria-hidden="true">▾</span>
	                  </button>
	                  <button class="product-card__info-btn" type="button" data-product-info="tshirt" aria-label="Info zum T‑Shirt">i</button>
	                </header>
	                <div class="product-card__body" data-body="tshirt" hidden="">
	                  <div class="product-field product-field--stack">
	                    <span class="product-field__label">Farbe &amp; Größe kombinieren</span>
	                    ${buildColorSizeGrid({ inputKey: 'tshirt-variant', sizes: tshirtSizes })}
	                    <p class="product-hint">Trage für jede gewünschte Kombination die Stückzahl ein – so kannst du mehrere Größen &amp; Farben auf einmal bestellen.</p>
	                  </div>
	                </div>
	              </article>

	              <article class="product-card" data-product="hoodie">
	                <header class="product-card__header">
	                  <button aria-expanded="false" class="product-card__header-btn" type="button">
	                    <div class="product-card__titles">
	                      <span class="product-card__title">Kapuzenpullover</span>
	                      <span class="product-card__summary" data-summary="hoodie">Noch nichts ausgewählt</span>
	                    </div>
	                    <span class="nh-reorder-caret" aria-hidden="true">▾</span>
	                  </button>
	                  <button class="product-card__info-btn" type="button" data-product-info="hoodie" aria-label="Info zum Kapuzenpullover">i</button>
	                </header>
	                <div class="product-card__body" data-body="hoodie" hidden="">
	                  <div class="product-field product-field--stack">
	                    <span class="product-field__label">Farbe &amp; Größe kombinieren</span>
	                    ${buildColorSizeGrid({ inputKey: 'hoodie-variant', sizes: hoodieSizes })}
	                    <p class="product-hint">Trage für jede gewünschte Kombination die Stückzahl ein – so kannst du mehrere Größen &amp; Farben auf einmal bestellen.</p>
	                  </div>
	                </div>
	              </article>

	              <article class="product-card" data-product="mug">
	                <header class="product-card__header">
	                  <button aria-expanded="false" class="product-card__header-btn" type="button">
	                    <div class="product-card__titles">
	                      <span class="product-card__title">Tasse</span>
	                      <span class="product-card__summary" data-summary="mug">Noch nichts ausgewählt</span>
	                    </div>
	                    <span class="nh-reorder-caret" aria-hidden="true">▾</span>
	                  </button>
	                  <button class="product-card__info-btn" type="button" data-product-info="mug" aria-label="Info zur Tasse">i</button>
	                </header>
	                <div class="product-card__body" data-body="mug" hidden="">
	                  <div class="product-field product-field--stack">
	                    <span class="product-field__label">Material &amp; Menge</span>
	                    <div class="mug-grid">
	                      <div class="mug-variant-card" data-nh-mug="ceramic">
	                        <div class="mug-variant-header">
	                          <span class="mug-variant-title">Keramik</span>
	                          <span class="mug-variant-note">Klassisch, spülmaschinenfest</span>
	                        </div>
	                        <div class="qty-control" data-qty-control="">
	                          <button aria-label="Weniger Keramik-Tassen" class="qty-btn" data-qty-step="-1" type="button">-</button>
	                          <input aria-label="Keramik Tassen" data-input="mug-variant" data-type="ceramic" inputmode="numeric" max="99" min="0" pattern="[0-9]*" type="number" value="0"/>
	                          <button aria-label="Mehr Keramik-Tassen" class="qty-btn" data-qty-step="1" type="button">+</button>
	                        </div>
	                      </div>
	                      <div class="mug-variant-card" data-nh-mug="enamel">
	                        <div class="mug-variant-header">
	                          <span class="mug-variant-title">Emaille</span>
	                          <span class="mug-variant-note">Leicht &amp; outdoor-tauglich</span>
	                        </div>
	                        <div class="qty-control" data-qty-control="">
	                          <button aria-label="Weniger Emaille-Tassen" class="qty-btn" data-qty-step="-1" type="button">-</button>
	                          <input aria-label="Emaille Tassen" data-input="mug-variant" data-type="enamel" inputmode="numeric" max="99" min="0" pattern="[0-9]*" type="number" value="0"/>
	                          <button aria-label="Mehr Emaille-Tassen" class="qty-btn" data-qty-step="1" type="button">+</button>
	                        </div>
	                      </div>
	                    </div>
	                    <p class="product-hint">Passe für jede Tassenart separat die Stückzahl an – beide Varianten können zusammen bestellt werden.</p>
	                  </div>
	                </div>
	              </article>
	            </div>

	            <aside class="selector-sidebar">
	              <div class="selector-summary-card">
	                <h3>Deine Auswahl</h3>
	                <p class="selector-summary-hint">Alles, was du links auswählst, erscheint hier. Du kannst Positionen jederzeit entfernen.</p>

	                <div id="selector-items" class="selector-selection-list">
	                  <div class="selector-empty-state" id="selector-empty-state">Noch nichts ausgewählt.</div>
	                </div>

	                <div class="selector-summary-footer">
	                  <p class="selector-total" id="selector-total">Gesamt: —</p>
	                  <button class="nh-reorder__btn selector-checkout" id="shopify-checkout-btn" type="button">Alles in den Warenkorb</button>
	                  <p class="selector-checkout-hint">Express kannst du hier auswählen oder später im Warenkorb pro Position ändern.</p>
	                </div>
	              </div>
	            </aside>
	          </div>

	          <div aria-hidden="true" class="variant-inputs" id="nh-reorder-variant-inputs"></div>
	        </section>
	      </div>
	    `;

	    document.body.appendChild(modal);

	    const inputHost = modal.querySelector('#nh-reorder-variant-inputs');
	    if (inputHost) {
	      const keys = Object.keys(SHOPIFY_VARIANT_MAP || {});
	      inputHost.innerHTML = keys.map((key) => (
	        `<input data-variant-key="${nhEscapeHtml(key)}" max="999" min="0" type="number" value="0"/>`
	      )).join('');
	    }

	    modal.addEventListener('click', (event) => {
	      const closer = event.target && event.target.closest ? event.target.closest('[data-nh-reorder-close="1"]') : null;
	      if (!closer) return;
	      event.preventDefault();
	      closeReorderProductSelectorModal();
	    });

	    document.addEventListener('keydown', (event) => {
	      if (event.key !== 'Escape') return;
	      if (!isReorderProductSelectorModalOpen()) return;
	      event.preventDefault();
	      closeReorderProductSelectorModal();
	    });

	    if (!document.getElementById('product-info-modal')) {
	      const info = document.createElement('div');
	      info.id = 'product-info-modal';
	      info.className = 'nh-reorder-info-modal';
	      info.setAttribute('aria-hidden', 'true');
	      info.innerHTML = `
	        <div class="nh-reorder-modal__backdrop" data-dismiss="product-info-modal"></div>
	        <div class="nh-reorder-modal__dialog" role="dialog" aria-modal="true" aria-label="Produktinfo">
	          <button class="product-info-close" type="button" aria-label="Schließen">✕</button>
	          <h3 id="product-info-title"></h3>
	          <div id="product-info-content"></div>
	        </div>
	      `;
	      document.body.appendChild(info);
	    }

	    return modal;
	  }

	  function isReorderProductSelectorModalOpen() {
	    const modal = document.getElementById('nh-reorder-modal');
	    return !!modal && modal.getAttribute('aria-hidden') === 'false';
	  }

	  function openReorderProductSelectorModal() {
	    const modal = ensureReorderProductSelectorModal();
	    modal.setAttribute('aria-hidden', 'false');
	    try { document.body.style.overflow = 'hidden'; } catch (_) { /* noop */ }
	    try { modal.querySelector('.nh-reorder-modal__close')?.focus?.(); } catch (_) { /* noop */ }
	  }

	  function closeReorderProductSelectorModal() {
	    const modal = document.getElementById('nh-reorder-modal');
	    if (!modal) return;
	    modal.setAttribute('aria-hidden', 'true');
	    try { document.body.style.overflow = ''; } catch (_) { /* noop */ }
	  }

		  function setReorderProductSelectorPreview(url) {
		    const host = document.getElementById('nh-reorder-modal-preview');
		    if (!host) return;
		    const safe = String(url || '').trim();
		    if (!safe) {
		      host.hidden = true;
		      host.innerHTML = '';
		      return;
		    }
		    host.hidden = false;
		    host.innerHTML = `
		      <div>
		        <p class="nh-reorder__label">Vorschau</p>
		        <img src="${nhEscapeHtml(safe)}" alt="Design Vorschau"/>
		      </div>
		    `;
		  }

	  function mountReorderRoot() {
	    const existing = document.getElementById('nh-reorder-app');
	    if (existing) return existing;
	    const main = document.getElementById('MainContent') || document.querySelector('main');
	    if (!main) return null;
	    const container = main.querySelector('.page-width') || main;
	    const mount = document.createElement('div');
	    mount.id = 'nh-reorder-app';
	    container.prepend(mount);
	    return mount;
	  }

	  function setupReorderPage() {
	    if (!isReorderPage()) return;
	    if (window.__nhReorderPageInitialized) return;
	    window.__nhReorderPageInitialized = true;

	    ensureReorderPageStyles();
	    ensureReorderProductSelectorModal();
	    try { setupProductSelectorUi(); } catch (err) { console.warn('[NH Reorder] Selector init fehlgeschlagen', err); }

	    if (!window.__nhReorderShapeProviderInstalled) {
	      window.__nhReorderShapeProviderInstalled = true;
	      const original = window.getCurrentShapeType;
	      window.getCurrentShapeType = function () {
	        try {
	          if (typeof isReorderPage === 'function' && isReorderPage()) {
	            const shape = window.__nhReorderShape;
	            if (shape === 'oval' || shape === 'rect' || shape === 'both') return shape;
	          }
	        } catch (_) { /* noop */ }
	        if (typeof original === 'function') {
	          try { return original.apply(this, arguments); } catch (_) { /* noop */ }
	        }
	        return 'oval';
	      };
	    }

	    if (typeof window.__nhReorderShape !== 'string') {
	      window.__nhReorderShape = 'both';
	    }

	    const mount = mountReorderRoot();
	    if (!mount) return;

	    mount.innerHTML = `
	      <div class="nh-reorder">
	        <div class="nh-reorder__card">
	          <div class="nh-reorder__header">
	            <div>
	              <h1 class="nh-reorder__title">Nachbestellen</h1>
		              <p class="nh-reorder__subtitle">Gib deine Design‑ID ein (z.B. M‑20251217‑1200‑ABCD) oder nur den Code (20251217‑1200‑ABCD). Wir suchen passende Druckdateien und öffnen anschließend die Produktauswahl.</p>
	            </div>
	            <div class="nh-reorder__preview" id="nh-reorder-preview" hidden></div>
	          </div>

	          <form class="nh-reorder__form" id="nh-reorder-form">
	            <div class="nh-reorder__field">
	              <label class="nh-reorder__label" for="nh-reorder-design-id">Design‑ID</label>
	              <input class="nh-reorder__input" id="nh-reorder-design-id" name="designId" type="text" placeholder="z.B. M-20251217-1200-ABCD oder 20251217-1200-ABCD" autocomplete="off" />
	            </div>
	            <button class="nh-reorder__btn" id="nh-reorder-load-btn" type="submit">Design laden</button>
	          </form>

	          <div class="nh-reorder__status is-muted" id="nh-reorder-status" role="status" aria-live="polite"></div>

	          <div class="nh-reorder__results" id="nh-reorder-results" hidden>
	            <p class="nh-reorder__hint" id="nh-reorder-found"></p>
	            <div class="nh-reorder__actions">
	              <p class="nh-reorder__hint">Express kannst du hier auswählen oder später im Warenkorb pro Position ändern.</p>
	              <div class="nh-reorder__actions-right">
	                <button class="nh-reorder__btn" id="nh-reorder-open-selector" type="button" disabled>Produkte auswählen</button>
	                <a class="nh-reorder__btn nh-reorder__btn--ghost" href="/cart">Zum Warenkorb</a>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    `;

	    const form = mount.querySelector('#nh-reorder-form');
	    const input = mount.querySelector('#nh-reorder-design-id');
	    const loadBtn = mount.querySelector('#nh-reorder-load-btn');
	    const status = mount.querySelector('#nh-reorder-status');
	    const preview = mount.querySelector('#nh-reorder-preview');
	    const results = mount.querySelector('#nh-reorder-results');
	    const found = mount.querySelector('#nh-reorder-found');
	    const openSelectorBtn = mount.querySelector('#nh-reorder-open-selector');

	    const disablePreviewInteraction = (el) => {
	      if (!el || el.__nhNoContextMenu) return;
	      el.__nhNoContextMenu = true;
	      el.addEventListener('contextmenu', (event) => {
	        event.preventDefault();
	      });
	      el.addEventListener('dragstart', (event) => {
	        event.preventDefault();
	      });
	    };

	    disablePreviewInteraction(preview);
	    disablePreviewInteraction(document.getElementById('nh-reorder-modal-preview'));

	    const setStatus = (message, kind = 'muted') => {
	      status.textContent = message || '';
	      status.classList.toggle('is-muted', kind === 'muted');
	      status.classList.toggle('is-error', kind === 'error');
	      status.classList.toggle('is-success', kind === 'success');
	    };

	    const setLoading = (loading) => {
	      loadBtn.disabled = !!loading;
	      openSelectorBtn.disabled = !!loading || !state.loaded;
	      input.disabled = !!loading;
	      if (loading) {
	        loadBtn.textContent = 'Lädt…';
	      } else {
	        loadBtn.textContent = 'Design laden';
	      }
	    };

			    const state = {
			      loaded: false,
			      rawDesignId: '',
			      previewUrl: '',
			      previewDataUrl: '',
			      previewPdfUrl: '',
			      profiles: {},
			      main: null,
			      mainPayload: null,
			      mainPayloadUrl: '',
			      shapeType: 'both',
			      suffix: '',
			      candidates: {},
			      previewRenderSeq: 0
			    };

			    const __nhMainPayloadCache = window.__nhMainPayloadCache || new Map();
			    window.__nhMainPayloadCache = __nhMainPayloadCache;

			    function extractMainPayload(json) {
			      if (!json || typeof json !== 'object') return null;
			      if (json.payload && typeof json.payload === 'object') return json.payload;
			      if (json.snapshot && typeof json.snapshot === 'object' && json.snapshot.payload && typeof json.snapshot.payload === 'object') return json.snapshot.payload;
			      if (json.design && typeof json.design === 'object' && json.design.payload && typeof json.design.payload === 'object') return json.design.payload;
			      return null;
			    }

			    function detectShapeFromPayload(payload) {
			      const objects = payload && typeof payload === 'object' ? payload.objects : null;
			      if (!Array.isArray(objects) || !objects.length) return 'both';
			      const isCandidate = (obj) => {
			        if (!obj || typeof obj !== 'object') return false;
			        if (obj._isBackground) return true;
			        if (obj.selectable === false) return true;
			        return false;
			      };
			      const candidates = objects.filter(isCandidate);
			      const findType = (type) => candidates.find((obj) => obj.type === type) || objects.find((obj) => isCandidate(obj) && obj.type === type);
			      const rect = findType('rect');
			      if (rect) return 'rect';
			      const ellipse = findType('ellipse');
			      if (ellipse) return 'oval';
			      const anyRect = objects.some((obj) => obj && obj.type === 'rect');
			      const anyEllipse = objects.some((obj) => obj && obj.type === 'ellipse');
			      if (anyRect && !anyEllipse) return 'rect';
			      if (anyEllipse && !anyRect) return 'oval';
			      return (anyRect && anyEllipse) ? 'both' : 'both';
			    }

			    async function ensureMainPayloadLoaded() {
			      const mainUrl = state.main && state.main.jsonUrl ? String(state.main.jsonUrl) : '';
			      if (!mainUrl) return null;
			      if (state.mainPayload && state.mainPayloadUrl === mainUrl) return state.mainPayload;

			      const cached = __nhMainPayloadCache.get(mainUrl);
			      if (cached) {
			        const resolved = (typeof cached.then === 'function') ? await cached : cached;
			        state.mainPayload = resolved;
			        state.mainPayloadUrl = mainUrl;
			        state.shapeType = detectShapeFromPayload(resolved);
			        return resolved;
			      }

			      const job = (async () => {
			        const resp = await fetch(mainUrl, { cache: 'no-store', credentials: 'omit' });
			        if (!resp.ok) {
			          throw new Error(`Main-Datei konnte nicht geladen werden (${resp.status}).`);
			        }
			        const text = await resp.text();
			        let json;
			        try { json = text ? JSON.parse(text) : {}; }
			        catch { throw new Error('Main-Datei ist kein gültiges JSON.'); }
			        const payload = extractMainPayload(json);
			        if (!payload || typeof payload !== 'object') {
			          throw new Error('Main-Datei enthält kein Design-Payload.');
			        }
			        return payload;
			      })();

			      __nhMainPayloadCache.set(mainUrl, job);
			      try {
			        const resolved = await job;
			        __nhMainPayloadCache.set(mainUrl, resolved);
			        state.mainPayload = resolved;
			        state.mainPayloadUrl = mainUrl;
			        state.shapeType = detectShapeFromPayload(resolved);
			        return resolved;
			      } catch (err) {
			        __nhMainPayloadCache.delete(mainUrl);
			        throw err;
			      }
			    }

			    const NH_REORDER_EXPORT_FABRIC_SRC = 'https://cdn.jsdelivr.net/npm/fabric@5.3.0/dist/fabric.min.js';
			    const NH_REORDER_EXPORT_JSPDF_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
			    let __nhReorderExportLibsPromise = null;

			    function ensureNhScriptLoaded(src, { check } = {}) {
			      if (typeof check === 'function') {
			        try { if (check()) return Promise.resolve(true); } catch (_) { /* noop */ }
			      }
			      return new Promise((resolve, reject) => {
			        const existing = Array.from(document.scripts || []).find((s) => s && s.src && s.src.includes(src));
			        if (existing) {
			          existing.addEventListener('load', () => resolve(true), { once: true });
			          existing.addEventListener('error', () => reject(new Error(`Script konnte nicht geladen werden: ${src}`)), { once: true });
			          return;
			        }
			        const script = document.createElement('script');
			        script.src = src;
			        script.async = true;
			        script.crossOrigin = 'anonymous';
			        script.onload = () => resolve(true);
			        script.onerror = () => reject(new Error(`Script konnte nicht geladen werden: ${src}`));
			        document.head.appendChild(script);
			      });
			    }

			    function ensureReorderExportLibsLoaded() {
			      if (__nhReorderExportLibsPromise) return __nhReorderExportLibsPromise;
			      __nhReorderExportLibsPromise = Promise.all([
			        ensureNhScriptLoaded(NH_REORDER_EXPORT_FABRIC_SRC, { check: () => !!(window.fabric && window.fabric.StaticCanvas) }),
			        ensureNhScriptLoaded(NH_REORDER_EXPORT_JSPDF_SRC, { check: () => !!(window.jspdf && window.jspdf.jsPDF) })
			      ]).then(() => true);
			      return __nhReorderExportLibsPromise;
			    }

			    const REORDER_EXPORT_PROFILE_FALLBACK = {
			      sticker_normal_oval: { key: 'sticker_normal_oval', label: 'Sticker Oval', idPrefix: 'NHO-', pdfWidthMm: 149, pdfHeightMm: 86, layout: 'fill' },
			      sticker_normal_rect: { key: 'sticker_normal_rect', label: 'Sticker Rechteck', idPrefix: 'NHR-', pdfWidthMm: 149, pdfHeightMm: 86, layout: 'fill' },
			      sticker_mini_oval: { key: 'sticker_mini_oval', label: 'Sticker Mini Oval', idPrefix: 'MHO-', pdfWidthMm: 78, pdfHeightMm: 45, layout: 'fill' },
			      sticker_mini_rect: { key: 'sticker_mini_rect', label: 'Sticker Mini Rechteck', idPrefix: 'MHR-', pdfWidthMm: 78, pdfHeightMm: 45, layout: 'fill' },
			      beerdeckel: { key: 'beerdeckel', label: 'Bierdeckel', idPrefix: 'BD-', pdfWidthMm: 136, pdfHeightMm: 101, layout: 'box', designBoxMm: { width: 136, height: 74.5 }, renderMultiplier: 12 },
			      flag_100x58: { key: 'flag_100x58', label: 'Fahne 100 x 58 cm', idPrefix: 'FH-', pdfWidthMm: 1004, pdfHeightMm: 584, layout: 'box', designBoxMm: { width: 1004, height: 584 }, renderMultiplier: 18 },
			      flag_150x86: { key: 'flag_150x86', label: 'Fahne 150 x 86.5 cm', idPrefix: 'FH-', pdfWidthMm: 1504, pdfHeightMm: 869, layout: 'box', designBoxMm: { width: 1504, height: 869 }, renderMultiplier: 18 },
			      flag_200x115: { key: 'flag_200x115', label: 'Fahne 200 x 115.5 cm', idPrefix: 'FH-', pdfWidthMm: 2004, pdfHeightMm: 1159, layout: 'box', designBoxMm: { width: 2004, height: 1159 }, renderMultiplier: 18 },
			      flag_300x173: { key: 'flag_300x173', label: 'Fahne 300 x 173.4 cm', idPrefix: 'FH-', pdfWidthMm: 3004, pdfHeightMm: 1734, layout: 'box', designBoxMm: { width: 3004, height: 1734 }, renderMultiplier: 18 },
			      hoodie: { key: 'hoodie', label: 'Hoodie', idPrefix: 'KP-', pdfWidthMm: 350, pdfHeightMm: 280, layout: 'box', designBoxMm: { width: 235, height: 135.5 } },
			      mug_ceramic: { key: 'mug_ceramic', label: 'Tasse Keramik', idPrefix: 'TK-', pdfWidthMm: 229, pdfHeightMm: 99, layout: 'box', designBoxMm: { width: 143, height: 82.5 } },
			      mug_enamel: { key: 'mug_enamel', label: 'Tasse Emaille', idPrefix: 'TE-', pdfWidthMm: 229, pdfHeightMm: 74, layout: 'box', designBoxMm: { width: 105, height: 60.6 } },
			      tshirt: { key: 'tshirt', label: 'T-Shirt', idPrefix: 'SH-', pdfWidthMm: 350, pdfHeightMm: 400, layout: 'box', designBoxMm: { width: 237, height: 136.8 }, designBoxOffsetMm: { x: 0, y: -55 } }
			    };

			    function resolveReorderExportProfile(profileKey) {
			      try {
			        const profiles = window.__exportProfiles || {};
			        const profile = profileKey && profiles[profileKey];
			        if (profile) return profile;
			      } catch (_) { /* noop */ }
			      if (profileKey && REORDER_EXPORT_PROFILE_FALLBACK[profileKey]) return REORDER_EXPORT_PROFILE_FALLBACK[profileKey];
			      return REORDER_EXPORT_PROFILE_FALLBACK.sticker_normal_oval;
			    }

			    function jsPdfOutputBlobSafe(doc) {
			      try {
			        const blob = doc.output('blob');
			        if (blob && typeof Blob !== 'undefined' && blob instanceof Blob) return blob;
			      } catch (_) { /* noop */ }
			      const ab = doc.output('arraybuffer');
			      return new Blob([ab], { type: 'application/pdf' });
			    }

			    async function flattenToJpeg(dataUrl, bg = '#ffffff', quality = 0.95) {
			      return new Promise((resolve, reject) => {
			        const img = new Image();
			        img.onload = () => {
			          const c = document.createElement('canvas');
			          c.width = img.width || 1;
			          c.height = img.height || 1;
			          const ctx = c.getContext('2d', { alpha: false });
			          ctx.fillStyle = bg;
			          ctx.fillRect(0, 0, c.width, c.height);
			          ctx.drawImage(img, 0, 0);
			          resolve(c.toDataURL('image/jpeg', quality));
			        };
			        img.onerror = reject;
			        img.src = dataUrl;
			      });
			    }

			    let __nhReorderExportCanvas = null;
			    let __nhReorderExportCanvasLoadedMainUrl = '';

			    function ensureReorderExportCanvas() {
			      if (__nhReorderExportCanvas) return __nhReorderExportCanvas;
			      const wrap = document.createElement('div');
			      wrap.id = 'nh-reorder-export-engine';
			      wrap.style.position = 'fixed';
			      wrap.style.left = '-99999px';
			      wrap.style.top = '-99999px';
			      wrap.style.width = '1px';
			      wrap.style.height = '1px';
			      wrap.style.overflow = 'hidden';
			      wrap.style.opacity = '0';
			      wrap.style.pointerEvents = 'none';
			      wrap.setAttribute('aria-hidden', 'true');
			      const canvasEl = document.createElement('canvas');
			      canvasEl.width = 450;
			      canvasEl.height = 290;
			      wrap.appendChild(canvasEl);
			      document.body.appendChild(wrap);
			      const fabric = window.fabric;
			      if (!fabric || !fabric.StaticCanvas) {
			        throw new Error('Fabric.js ist nicht geladen.');
			      }
			      __nhReorderExportCanvas = new fabric.StaticCanvas(canvasEl, {
			        width: canvasEl.width,
			        height: canvasEl.height,
			        enableRetinaScaling: false,
			        renderOnAddRemove: false,
			        backgroundColor: null
			      });
			      return __nhReorderExportCanvas;
			    }

			    async function ensureReorderExportCanvasHasDesign() {
			      const payload = state.mainPayload || await ensureMainPayloadLoaded();
			      const mainUrl = state.mainPayloadUrl || (state.main && state.main.jsonUrl ? String(state.main.jsonUrl) : '');
			      if (!payload) {
			        throw new Error('Main-Design kann nicht exportiert werden (Payload fehlt).');
			      }

			      await ensureReorderExportLibsLoaded();
			      const canvas = ensureReorderExportCanvas();
			      if (mainUrl && __nhReorderExportCanvasLoadedMainUrl === mainUrl) return canvas;

			      await new Promise((resolve, reject) => {
			        try {
			          canvas.loadFromJSON(payload, () => {
			            try { canvas.setViewportTransform([1, 0, 0, 1, 0, 0]); } catch (_) { /* noop */ }
			            try { canvas.requestRenderAll(); } catch (_) { /* noop */ }
			            __nhReorderExportCanvasLoadedMainUrl = mainUrl;
			            resolve();
			          }, (_o, object) => {
			            try {
			              if (object) {
			                object.objectCaching = false;
			                if (object.type === 'image' && !object.crossOrigin) {
			                  object.crossOrigin = 'anonymous';
			                }
			              }
			            } catch (_) { /* noop */ }
			          });
			        } catch (err) {
			          reject(err);
			        }
			      });

			      return canvas;
			    }

			    async function reorderSaveVectorPDF(profileKey) {
			      await ensureReorderExportLibsLoaded();
			      const profile = resolveReorderExportProfile(profileKey);
			      const { jsPDF } = window.jspdf;

			      const pdfWidthMm = Number(profile.pdfWidthMm) || 149;
			      const pdfHeightMm = Number(profile.pdfHeightMm) || 86;
			      const orientation = pdfWidthMm >= pdfHeightMm ? 'landscape' : 'portrait';

			      const canvas = await ensureReorderExportCanvasHasDesign();

			      const __vt = canvas.viewportTransform ? canvas.viewportTransform.slice() : null;
			      const __oldZoom = typeof canvas.getZoom === 'function' ? canvas.getZoom() : 1;
			      try { canvas.setViewportTransform([1, 0, 0, 1, 0, 0]); } catch (_) { /* noop */ }

			      const toHide = canvas.getObjects().filter(o => o && (o.excludeFromExport || o._helperUI));
			      const prevVis = new Map(toHide.map(o => [o, o.visible]));
			      toHide.forEach(o => { o.visible = false; });
			      try { canvas.discardActiveObject?.(); } catch (_) { /* noop */ }
			      try { canvas.requestRenderAll(); } catch (_) { /* noop */ }

			      const restore = () => {
			        toHide.forEach(o => { o.visible = prevVis.get(o); });
			        if (__vt) {
			          try { canvas.setViewportTransform(__vt.slice()); } catch (_) { /* noop */ }
			        } else if (typeof __oldZoom === 'number' && typeof canvas.setZoom === 'function') {
			          try { canvas.setZoom(__oldZoom); } catch (_) { /* noop */ }
			        }
			        try { canvas.requestRenderAll(); } catch (_) { /* noop */ }
			      };

			      const shapeObj =
			        canvas.getObjects().find(o => o && o._isBackground) ||
			        canvas.getObjects().find(o => o && o.selectable === false) ||
			        null;

			      if (!shapeObj) {
			        restore();
			        throw new Error('Grundform im Main-Design nicht gefunden.');
			      }

			      let vx, vy, vw, vh;
			      if (shapeObj.type === 'ellipse') {
			        vw = shapeObj.rx * 2; vh = shapeObj.ry * 2;
			        vx = shapeObj.left - shapeObj.rx; vy = shapeObj.top - shapeObj.ry;
			      } else if (shapeObj.type === 'rect') {
			        vw = shapeObj.width; vh = shapeObj.height;
			        vx = shapeObj.left - vw / 2; vy = shapeObj.top - vh / 2;
			      } else {
			        const r = shapeObj.getBoundingRect(true);
			        vx = r.left; vy = r.top; vw = r.width; vh = r.height;
			      }

			      async function rasterPdf() {
			        const doc = new jsPDF({ orientation, unit: 'mm', format: [pdfWidthMm, pdfHeightMm], pdfVersion: '1.6' });

			        const multiplier = Number(profile.renderMultiplier) || 6;
			        const vxR = Math.floor(vx);
			        const vyR = Math.floor(vy);
			        const vwR = Math.ceil(vw);
			        const vhR = Math.ceil(vh);

			        const pngDataUrl = canvas.toDataURL({
			          format: 'png',
			          multiplier,
			          left: vxR, top: vyR, width: vwR, height: vhR,
			          enableRetinaScaling: false
			        });

			        const isBeerdeckel = profile.key === 'beerdeckel';
			        let exportDataUrl = pngDataUrl;
			        let exportFormat = 'PNG';

			        if (isBeerdeckel) {
			          const pdfWpx = Math.max(1, Math.round(pdfWidthMm * multiplier));
			          const pdfHpx = Math.max(1, Math.round(pdfHeightMm * multiplier));
			          const targetWmm = profile.designBoxMm?.width || pdfWidthMm;
			          const targetHmm = profile.designBoxMm?.height || pdfHeightMm;
			          const targetPxW = Math.max(1, Math.round(targetWmm * multiplier));
			          const targetPxH = Math.max(1, Math.round(targetHmm * multiplier));
			          const targetPxX = Math.round((pdfWpx - targetPxW) / 2);
			          const targetPxY = Math.round((pdfHpx - targetPxH) / 2);
			          const candidateBg = (() => {
			            if (typeof canvas.backgroundColor === 'string' && canvas.backgroundColor.trim()) return canvas.backgroundColor;
			            if (shapeObj && typeof shapeObj.fill === 'string' && shapeObj.fill.trim()) return shapeObj.fill;
			            return '#ffffff';
			          })();

			          const img = await new Promise((resolve, reject) => {
			            const im = new Image();
			            im.onload = () => resolve(im);
			            im.onerror = reject;
			            im.src = pngDataUrl;
			          });
			          const off = document.createElement('canvas');
			          off.width = pdfWpx;
			          off.height = pdfHpx;
			          const ctx = off.getContext('2d');
			          ctx.save();
			          ctx.beginPath();
			          ctx.ellipse(pdfWpx / 2, pdfHpx / 2, pdfWpx / 2, pdfHpx / 2, 0, 0, Math.PI * 2);
			          ctx.clip();
			          ctx.fillStyle = candidateBg;
			          ctx.fillRect(0, 0, pdfWpx, pdfHpx);
			          ctx.drawImage(img, targetPxX, targetPxY, targetPxW, targetPxH);
			          ctx.restore();
			          exportDataUrl = off.toDataURL('image/png');
			          exportFormat = 'PNG';
			        } else {
			          const jpegDataUrl = await flattenToJpeg(pngDataUrl, '#ffffff', 0.95);
			          exportDataUrl = jpegDataUrl;
			          exportFormat = 'JPEG';
			        }

			        if (profile.layout === 'box' && profile.designBoxMm && !isBeerdeckel) {
			          const targetW = Number(profile.designBoxMm.width) || pdfWidthMm;
			          const targetH = Number(profile.designBoxMm.height) || pdfHeightMm;
			          const offsetX = Number(profile.designBoxOffsetMm?.x) || 0;
			          const offsetY = Number(profile.designBoxOffsetMm?.y) || 0;
			          const centeredX = (pdfWidthMm - targetW) / 2 + offsetX;
			          const centeredY = (pdfHeightMm - targetH) / 2 + offsetY;
			          const x = Math.min(Math.max(0, centeredX), Math.max(0, pdfWidthMm - targetW));
			          const y = Math.min(Math.max(0, centeredY), Math.max(0, pdfHeightMm - targetH));
			          doc.addImage(exportDataUrl, exportFormat, x, y, targetW, targetH, undefined, 'FAST');
			        } else {
			          doc.addImage(exportDataUrl, exportFormat, 0, 0, pdfWidthMm, pdfHeightMm, undefined, 'FAST');
			        }

			        return jsPdfOutputBlobSafe(doc);
			      }

			      try {
			        return await rasterPdf();
			      } finally {
			        restore();
			      }
			    }

			    async function reorderUploadPdfBlob(designId, profileKey, pdfBlob) {
			      const endpoint = typeof NETLIFY_FN === 'string' ? NETLIFY_FN : (window.NETLIFY_FN || '');
			      if (!endpoint) {
			        throw new Error('Upload-Endpoint ist nicht konfiguriert (NETLIFY_FN).');
			      }
			      const safeId = String(designId || '').trim();
			      const safeProfile = String(profileKey || '').trim();
			      if (!safeId) throw new Error('Design-ID fehlt.');
			      if (!pdfBlob) throw new Error('PDF fehlt.');

			      const headers = {
			        'Content-Type': pdfBlob.type || 'application/pdf',
			        'X-Design-Id': safeId,
			        'X-Design-Product': safeProfile,
			        'X-Design-Profile': safeProfile,
			        'X-File-Name': `${safeId}.pdf`
			      };

			      const resp = await fetch(endpoint, { method: 'POST', headers, body: pdfBlob });
			      const text = await resp.text().catch(() => '');
			      let json;
			      try { json = text ? JSON.parse(text) : {}; }
			      catch { throw new Error('Upload fehlgeschlagen (kein JSON).'); }
			      if (!resp.ok || !json || json.ok !== true) {
			        throw new Error(json?.error ? String(json.error) : 'Upload fehlgeschlagen.');
			      }
			      return String(json.viewUrl || json.url || '');
			    }

			    const renderPreview = () => {
			      const previewUrl = String(state.previewUrl || '').trim();
			      const dataUrl = String(state.previewDataUrl || '').trim();
			      const previewUrlIsPdf = nhIsPdfUrl(previewUrl);
			      const imageUrl = (!previewUrlIsPdf && previewUrl) ? previewUrl : dataUrl;
			      const pdfUrl = previewUrlIsPdf ? previewUrl : String(state.previewPdfUrl || '').trim();

		      const modalPreview = document.getElementById('nh-reorder-modal-preview');
		      const placeholderHtml = (labelText) => `
		        <div>
		          <p class="nh-reorder__label">Vorschau</p>
		          <div class="nh-reorder__thumb-placeholder">${nhEscapeHtml(labelText || '')}</div>
		        </div>
		      `;

		      if (!imageUrl && !pdfUrl) {
		        preview.hidden = true;
		        preview.innerHTML = '';
		        setReorderProductSelectorPreview('');
		        if (modalPreview) {
		          modalPreview.hidden = true;
		          modalPreview.innerHTML = '';
		        }
		        return;
		      }

		      preview.hidden = false;
		      if (imageUrl) {
		        setReorderProductSelectorPreview(imageUrl);
		        preview.innerHTML = `
		          <div>
		            <p class="nh-reorder__label">Vorschau</p>
		            <img src="${nhEscapeHtml(imageUrl)}" alt="Design Vorschau"/>
		          </div>
		        `;
		        return;
		      }

		      const seq = ++state.previewRenderSeq;
		      preview.innerHTML = placeholderHtml('Vorschau lädt…');
		      if (modalPreview) {
		        modalPreview.hidden = false;
		        modalPreview.innerHTML = placeholderHtml('Vorschau lädt…');
		      }

		      nhPdfFirstPageThumbnailDataUrl(pdfUrl).then(async (thumb) => {
		        if (seq !== state.previewRenderSeq) return;
		        if (!thumb) {
		          preview.innerHTML = placeholderHtml('Vorschau nicht verfügbar');
		          if (modalPreview) modalPreview.innerHTML = placeholderHtml('Vorschau nicht verfügbar');
		          return;
		        }
		        const processed = await compressPreviewData(thumb, PREVIEW_MAX_EDGE);
		        if (seq !== state.previewRenderSeq) return;
		        state.previewDataUrl = processed || thumb;
		        renderPreview();
		      });
		    };

	    const renderFound = () => {
	      const keys = Object.keys(state.profiles || {});
	      if (!found) return;
	      if (!keys.length) {
	        const mainId = state.main && state.main.designId ? String(state.main.designId) : '';
	        found.textContent = mainId ? `Main‑ID gefunden: ${mainId}` : '';
	        return;
	      }
	      const labels = keys
	        .map((k) => nhProfileLabel(k))
	        .filter(Boolean)
	        .sort((a, b) => String(a).localeCompare(String(b)));
	      found.textContent = labels.length ? `Gefunden: ${labels.join(' · ')}` : '';
	    };

	    const resetSelectorUi = () => {
	      try { zeroVariantKeys(Object.keys(SHOPIFY_VARIANT_MAP || {})); } catch (_) { /* noop */ }
	      try {
	        stickerSelection.normalOval = 0;
	        stickerSelection.normalRect = 0;
	        stickerSelection.miniOval = 0;
	        stickerSelection.miniRect = 0;
	        beerdeckelSelection = 0;
	        flagVariantState.clear();
	        hoodieVariantState.clear();
	        tshirtVariantState.clear();
	        mugVariantState.clear();
	        expressSelectionByGroupKey.clear();
	      } catch (_) { /* noop */ }

	      try {
	        const selectorRoot = document.getElementById('shopifySelector');
	        selectorRoot?.querySelectorAll('input[data-input="tshirt-variant"], input[data-input="hoodie-variant"], input[data-input="mug-variant"], input[data-input="flag-variant"]').forEach((el) => {
	          el.value = '0';
	        });
	      } catch (_) { /* noop */ }

	      try { refreshSummaries(); } catch (_) { /* noop */ }
	      try { refreshTotal(); } catch (_) { /* noop */ }
	    };

	    const applyAvailabilityToSelector = () => {
	      const available = {};

	      const profileKeys = Object.keys(state.profiles || {});
	      const hasMain = !!(state.main && state.main.jsonUrl);

	      if (hasMain) {
	        const shape = (state.shapeType === 'oval' || state.shapeType === 'rect' || state.shapeType === 'both')
	          ? state.shapeType
	          : 'both';

	        ['tshirt', 'hoodie', 'mug_ceramic', 'mug_enamel'].forEach((k) => { available[k] = true; });
	        if (shape === 'oval' || shape === 'both') {
	          ['sticker_normal_oval', 'sticker_mini_oval', 'beerdeckel'].forEach((k) => { available[k] = true; });
	        }
	        if (shape === 'rect' || shape === 'both') {
	          ['sticker_normal_rect', 'sticker_mini_rect'].forEach((k) => { available[k] = true; });
	        }
	        ['flag_100x58', 'flag_150x86', 'flag_200x115', 'flag_300x173'].forEach((k) => { available[k] = true; });
	        profileKeys.forEach((k) => { available[k] = true; });
	        window.__nhReorderShape = shape;
	      } else {
	        profileKeys.forEach((k) => { available[k] = true; });
	        const supportsOval = !!(available.sticker_normal_oval || available.sticker_mini_oval || available.beerdeckel);
	        const supportsRect = !!(
	          available.sticker_normal_rect ||
	          available.sticker_mini_rect ||
	          available.flag_100x58 ||
	          available.flag_150x86 ||
	          available.flag_200x115 ||
	          available.flag_300x173
	        );
	        window.__nhReorderShape = supportsOval && supportsRect ? 'both' : (supportsRect ? 'rect' : (supportsOval ? 'oval' : 'both'));
	      }

	      window.__nhReorderAvailableProfiles = available;

	      const selectorRoot = document.getElementById('shopifySelector');
	      if (!selectorRoot) return;

	      const setCardVisible = (productKey, visible) => {
	        const card = selectorRoot.querySelector(`[data-product="${productKey}"]`);
	        if (!card) return;
	        card.style.display = visible ? '' : 'none';
	      };

	      const hasStickers = !!(available.sticker_normal_oval || available.sticker_normal_rect || available.sticker_mini_oval || available.sticker_mini_rect || available.sticker);
	      setCardVisible('stickers', hasStickers);
	      setCardVisible('tshirt', !!available.tshirt);
	      setCardVisible('hoodie', !!available.hoodie);

	      const hasMug = !!(available.mug_ceramic || available.mug_enamel);
	      setCardVisible('mug', hasMug);
	      if (hasMug) {
	        const ceramic = selectorRoot.querySelector('[data-product="mug"] [data-nh-mug="ceramic"]');
	        const enamel = selectorRoot.querySelector('[data-product="mug"] [data-nh-mug="enamel"]');
	        if (ceramic) ceramic.style.display = available.mug_ceramic ? '' : 'none';
	        if (enamel) enamel.style.display = available.mug_enamel ? '' : 'none';
	        if (!available.mug_ceramic) {
	          selectorRoot.querySelectorAll('input[data-input="mug-variant"][data-type="ceramic"]').forEach((el) => { el.value = '0'; });
	        }
	        if (!available.mug_enamel) {
	          selectorRoot.querySelectorAll('input[data-input="mug-variant"][data-type="enamel"]').forEach((el) => { el.value = '0'; });
	        }
	      }
	    };

	    const buildCartItemsFromSelection = (selection, bundleIdByVariantKey = null) => {
	      return selection.map(({ key, quantity }) => {
	        const variantId = resolveVariantId(key);
	        if (!variantId) {
	          throw new Error(`Variant-ID fehlt für "${key}".`);
	        }
	        const profileKey = productTypeForVariantKey(key);
	        const asset = state.profiles && state.profiles[profileKey];
	        if (!asset || !asset.pdfUrl) {
	          throw new Error(`Keine Druckdatei gefunden für "${nhProfileLabel(profileKey)}".`);
	        }
	        const designId = asset.designId || state.candidates?.[profileKey] || state.rawDesignId || '';
	        const pdfUrl = asset.pdfUrl;
	        const properties = buildLineItemProperties(designId, state.previewDataUrl || '', pdfUrl, state.previewUrl || '');
	        properties['Produktionszeit'] = productionTimeLabelForVariantKey(key);
	        properties['_NH_VARIANT_KEY'] = key;
	        const bundleId = `${designId || state.rawDesignId || 'DESIGN'}::${key}`;
	        properties['_NH_BUNDLE_ID'] = bundleId;
	        if (bundleIdByVariantKey && typeof bundleIdByVariantKey.set === 'function') {
	          bundleIdByVariantKey.set(key, bundleId);
	        }
	        return { id: variantId, quantity, properties };
	      });
	    };

	    const designIdForProfileKey = (profileKey) => {
	      const existing = state.profiles?.[profileKey]?.designId;
	      if (existing) return String(existing);
	      const candidate = state.candidates?.[profileKey];
	      if (candidate) return String(candidate);
	      const suffix = state.suffix || normalizeDesignSuffix(state.rawDesignId);
	      const prefix = reorderProfilePrefix(profileKey) || resolveReorderExportProfile(profileKey)?.idPrefix || '';
	      if (suffix && prefix) return `${prefix}${suffix}`;
	      return String(state.rawDesignId || '');
	    };

	    const ensurePdfsForSelectionIfMissing = async (selection, progressCb) => {
	      const needed = new Set();
	      (selection || []).forEach((item) => {
	        const key = item && item.key ? String(item.key) : '';
	        if (!key) return;
	        const profileKey = productTypeForVariantKey(key);
	        if (!profileKey) return;
	        needed.add(profileKey);
	      });

	      const missing = Array.from(needed).filter((profileKey) => {
	        const asset = state.profiles && state.profiles[profileKey];
	        return !(asset && asset.pdfUrl);
	      });

	      if (!missing.length) return { generated: 0 };
	      if (!state.main || !state.main.jsonUrl) {
	        throw new Error('Für dieses Design fehlen Druckdateien. Bitte nutze die Main‑ID oder bestelle das Design im Editor einmal bis zum Warenkorb.');
	      }

	      setStatus('Druckdateien werden erstellt…', 'muted');
	      if (typeof progressCb === 'function') progressCb(0.18);

	      try {
	        await ensureMainPayloadLoaded();
	      } catch (err) {
	        console.warn('[NH Reorder] Main-Payload erneut laden fehlgeschlagen', err);
	      }

	      await ensureReorderExportCanvasHasDesign();

	      let completed = 0;
	      for (const profileKey of missing) {
	        const label = nhProfileLabel(profileKey) || profileKey;
	        setStatus(`Druckdatei wird erstellt: ${label}…`, 'muted');
	        const designId = designIdForProfileKey(profileKey);
	        const pdfBlob = await reorderSaveVectorPDF(profileKey);
	        const pdfUrl = await reorderUploadPdfBlob(designId, profileKey, pdfBlob);
	        state.profiles[profileKey] = { designId, pdfUrl };
	        completed += 1;
	        if (typeof progressCb === 'function') {
	          progressCb(0.18 + (completed / missing.length) * 0.3);
	        }
	      }

	      if (!state.previewPdfUrl) {
	        const any = Object.values(state.profiles || {}).find((entry) => entry && entry.pdfUrl);
	        state.previewPdfUrl = any?.pdfUrl ? String(any.pdfUrl) : '';
	      }

	      try { renderFound(); } catch (_) { /* noop */ }
	      try { applyAvailabilityToSelector(); } catch (_) { /* noop */ }
	      try { document.getElementById('shopifySelector')?.dispatchEvent(new Event('nh:force-sync')); } catch (_) { /* noop */ }
	      setStatus('Druckdateien bereit.', 'success');
	      return { generated: missing.length };
	    };

	    const handleExportForEditor = window.handleExport;
	    window.handleExport = async function (_, progressCb) {
	      if (!isReorderPage()) {
	        if (typeof handleExportForEditor === 'function') return handleExportForEditor.apply(this, arguments);
	        return;
	      }
	      try {
	        if (!state.loaded) {
	          throw new Error('Bitte zuerst eine Design‑ID laden.');
	        }
	        const selection = collectSelectedVariants();
	        if (!selection.length) {
	          throw new Error('Bitte mindestens ein Produkt auswählen.');
	        }
	        pruneExpressSelections(selection);
	        const wantsExpress = selection.some(item => isExpressSelectedForVariantKey(item.key));
	        let expressProductionVariantId = wantsExpress ? resolveExpressProductionVariantId() : null;
	        if (wantsExpress && !expressProductionVariantId) {
	          expressProductionVariantId = await ensureExpressProductionVariantIdLoaded();
	        }
	        if (wantsExpress && !expressProductionVariantId) {
	          throw new Error('Expressproduktion ist gerade nicht verfügbar. Bitte entferne Express oder versuch es später erneut.');
	        }

	        await ensurePdfsForSelectionIfMissing(selection, progressCb);

	        if (typeof progressCb === 'function') progressCb(0.5);
	        setStatus('Warenkorb wird vorbereitet…', 'muted');

	        const bundleIdByVariantKey = new Map();
	        const items = buildCartItemsFromSelection(selection, bundleIdByVariantKey);
	        if (wantsExpress && expressProductionVariantId) {
	          selection
	            .filter(item => isExpressSelectedForVariantKey(item.key))
	            .forEach(item => {
	              const bundleId = bundleIdByVariantKey.get(item.key) || item.key;
		              items.push({
		                id: expressProductionVariantId,
		                quantity: Math.max(1, parseInt(item.quantity, 10) || 1),
		                properties: {
	                  'Expressproduktion für': expressTargetLabelForVariantKey(item.key),
	                  'Produktionszeit': EXPRESS_PRODUCTION_TIME_LABEL,
	                  '_NH_EXPRESS_FOR_BUNDLE': bundleId,
	                  '_NH_EXPRESS_FOR_KEY': item.key
	                }
	              });
	            });
	        }
	        if (typeof progressCb === 'function') progressCb(0.7);
	        await addProductsToCart(items);
	        if (typeof progressCb === 'function') progressCb(0.85);

	        closeReorderProductSelectorModal();
	        setStatus('Im Warenkorb. Du kannst jetzt eine weitere Design‑ID laden.', 'success');
	        try { input.focus(); input.select(); } catch (_) { /* noop */ }

	        const proceedToCart = () => {
	          const cartUrl = '/cart';
	          const tab = window.__nhCartTab;
	          window.__nhCartTab = null;
	          try {
	            if (tab && !tab.closed) {
	              tab.location.href = cartUrl;
	              tab.focus();
	              return;
	            }
	          } catch (_) { /* noop */ }
	          window.open(cartUrl, '_blank', 'noopener');
	        };

	        setTimeout(proceedToCart, 450);
	      } catch (err) {
	        console.warn('[NH Reorder] Checkout fehlgeschlagen', err);
	        setStatus(err?.message ? String(err.message) : 'Konnte nicht in den Warenkorb legen.', 'error');
	        throw err;
	      } finally {
	        if (typeof progressCb === 'function') progressCb(1);
	      }
	    };

	    const loadDesign = async (designId) => {
	      setLoading(true);
	      setStatus('Design wird geladen…', 'muted');
	      results.hidden = true;
	      try { closeReorderProductSelectorModal(); } catch (_) { /* noop */ }
	      openSelectorBtn.disabled = true;
	      state.loaded = false;
	      state.rawDesignId = '';
	      state.previewUrl = '';
	      state.previewDataUrl = '';
	      state.previewPdfUrl = '';
	      state.profiles = {};
	      state.main = null;
	      window.__nhReorderAvailableProfiles = null;
	      window.__nhReorderShape = 'both';
	      resetSelectorUi();

	      try {
	        const res = await nhLookupDesignAssets(designId);
	        state.rawDesignId = String(designId || '');
	        state.suffix = res.suffix;
	        state.candidates = res.candidates || {};
	        state.previewUrl = res.normalized.previewUrl || '';
	        state.profiles = res.normalized.profiles || {};
	        state.main = res.normalized.main || null;
	        state.mainPayload = null;
	        state.mainPayloadUrl = '';
	        state.shapeType = 'both';

	        if (state.main && state.main.jsonUrl) {
	          try {
	            await ensureMainPayloadLoaded();
	          } catch (err) {
	            console.warn('[NH Reorder] Main-Payload konnte nicht geladen werden', err);
	            state.shapeType = 'both';
	          }
	        }
	        state.previewPdfUrl = (() => {
	          const preferred = [
	            'sticker_normal_oval',
	            'sticker_normal_rect',
	            'sticker_mini_oval',
	            'sticker_mini_rect',
	            'beerdeckel',
	            'tshirt',
	            'hoodie',
	            'mug_ceramic',
	            'mug_enamel',
	            'flag_100x58',
	            'flag_150x86',
	            'flag_200x115',
	            'flag_300x173'
	          ];
	          for (const key of preferred) {
	            const url = state.profiles?.[key]?.pdfUrl;
	            if (url) return String(url);
	          }
	          const any = Object.values(state.profiles || {}).find((entry) => entry && entry.pdfUrl);
	          return any?.pdfUrl ? String(any.pdfUrl) : '';
	        })();

	        const count = Object.keys(state.profiles).length;
	        if (!count) {
	          if (!state.main || !state.main.jsonUrl) {
	            throw new Error('Keine passenden Druckdateien gefunden. Bitte prüfe die Design‑ID.');
	          }
	        }

	        state.loaded = true;
	        renderPreview();
	        renderFound();
	        applyAvailabilityToSelector();
	        resetSelectorUi();
	        try { document.getElementById('shopifySelector')?.dispatchEvent(new Event('nh:force-sync')); } catch (_) { /* noop */ }
	        results.hidden = false;
	        openSelectorBtn.disabled = false;
	        if (!count) {
	          setStatus('Design geladen. Druckdateien werden bei Bedarf beim Nachbestellen erstellt.', 'success');
	        } else {
	          setStatus(`Design geladen (${count} Datei${count === 1 ? '' : 'en'} gefunden).`, 'success');
	        }
	        openReorderProductSelectorModal();
	      } catch (err) {
	        console.warn('[NH Reorder] Lookup fehlgeschlagen', err);
	        setStatus(err?.message ? String(err.message) : 'Design konnte nicht geladen werden.', 'error');
	      } finally {
	        setLoading(false);
	      }
	    };

	    form.addEventListener('submit', (e) => {
	      e.preventDefault();
	      const raw = input.value || '';
	      loadDesign(raw);
	    });

	    openSelectorBtn.addEventListener('click', () => {
	      if (!state.loaded) {
	        setStatus('Bitte zuerst eine Design‑ID laden.', 'error');
	        return;
	      }
	      openReorderProductSelectorModal();
	    });

	    try {
	      const params = new URLSearchParams(window.location.search || '');
	      const preset = params.get('design') || params.get('id') || params.get('designId') || '';
	      if (preset) {
	        input.value = preset;
	        loadDesign(preset);
	      }
	    } catch (_) {
	      // ignore
	    }
	  }

			  function enforceB2bCanvasShape() {
			    if (!B2B_PRESET) return;
			    let attempts = 0;
			    const timer = setInterval(() => {
			      if (!B2B_PRESET) {
			        clearInterval(timer);
			        return;
			      }
			      attempts += 1;
			      try {
			        const target = B2B_PRESET.shape;
			        const current = getShapeType();
			        if (current === target) {
			          clearInterval(timer);
			          document.querySelectorAll('[data-shape-choice]').forEach((button) => {
			            button.disabled = true;
			            button.setAttribute('aria-disabled', 'true');
			            button.title = 'Die Form wurde im Firmenpaket festgelegt.';
			          });
			          document.getElementById('shopifySelector')?.dispatchEvent(new Event('nh:force-sync'));
			          return;
			        }
			        const targetButton = document.querySelector(`[data-shape-choice="${target}"]`);
			        if (targetButton && (current === 'oval' || current === 'rect')) targetButton.click();
			      } catch (_) { /* noop */ }
			      if (attempts >= 12) clearInterval(timer);
			    }, 300);
			  }

			  function initShopifyUi() {
			    setupCartExpressSync();
			    bindShopifyCheckoutButton();
			    setupProductSelectorUi();
			    setupReorderPage();
			    enforceB2bCanvasShape();
			  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopifyUi, { once: true });
  } else {
    initShopifyUi();
  }
})();
